// Node preamble copied from https://github.com/mbullington/node_preamble.dart
var dartNodePreambleSelf="undefined"!=typeof global?global:window,self=Object.create(dartNodePreambleSelf);if(self.scheduleImmediate="undefined"!=typeof setImmediate?function(e){setImmediate(e)}:function(e){setTimeout(e,0)},self.require=require,self.exports=exports,"undefined"!=typeof process)self.process=process;if("undefined"!=typeof __dirname)self.__dirname=__dirname;if("undefined"!=typeof __filename)self.__filename=__filename;if("undefined"!=typeof Buffer)self.Buffer=Buffer;var dartNodeIsActuallyNode=!dartNodePreambleSelf.window;try{if("undefined"!=typeof WorkerGlobalScope&&dartNodePreambleSelf instanceof WorkerGlobalScope)dartNodeIsActuallyNode=!1;if("undefined"!=typeof process&&process.versions&&process.versions.hasOwnProperty("electron")&&process.versions.hasOwnProperty("node"))dartNodeIsActuallyNode=!0}catch(e){}if(dartNodeIsActuallyNode){var url=("undefined"!=typeof __webpack_require__?__non_webpack_require__:require)("url");self.location={get href(){if(url.pathToFileURL)return url.pathToFileURL(process.cwd()).href+"/";else return"file://"+function(){var e=process.cwd();if("win32"!=process.platform)return e;else return"/"+e.replace(/\\/g,"/")}()+"/"}},function(){function e(){try{throw new Error}catch(n){var e=n.stack,r=new RegExp("^ *at [^(]*\\((.*):[0-9]*:[0-9]*\\)$","mg"),o=null;do{var t=r.exec(e);if(null!=t)o=t}while(null!=t);return o[1]}}var r=null;self.document={get currentScript(){if(null==r)r={src:e()};return r}}}(),self.dartDeferredLibraryLoader=function(e,r,o){try{load(e),r()}catch(e){o(e)}}}
(function dartProgram(){function copyProperties(a,b){var t=Object.keys(a)
for(var s=0;s<t.length;s++){var r=t[s]
b[r]=a[r]}}var z=function(){var t=function(){}
t.prototype={p:{}}
var s=new t()
if(!(s.__proto__&&s.__proto__.p===t.prototype.p))return false
try{if(typeof navigator!="undefined"&&typeof navigator.userAgent=="string"&&navigator.userAgent.indexOf("Chrome/")>=0)return true
if(typeof version=="function"&&version.length==0){var r=version()
if(/^\d+\.\d+\.\d+\.\d+$/.test(r))return true}}catch(q){}return false}()
function setFunctionNamesIfNecessary(a){function t(){};if(typeof t.name=="string")return
for(var t=0;t<a.length;t++){var s=a[t]
var r=Object.keys(s)
for(var q=0;q<r.length;q++){var p=r[q]
var o=s[p]
if(typeof o=='function')o.name=p}}}function inherit(a,b){a.prototype.constructor=a
a.prototype["$i"+a.name]=a
if(b!=null){if(z){a.prototype.__proto__=b.prototype
return}var t=Object.create(b.prototype)
copyProperties(a.prototype,t)
a.prototype=t}}function inheritMany(a,b){for(var t=0;t<b.length;t++)inherit(b[t],a)}function mixin(a,b){copyProperties(b.prototype,a.prototype)
a.prototype.constructor=a}function lazyOld(a,b,c,d){var t=a
a[b]=t
a[c]=function(){a[c]=function(){H.ke(b)}
var s
var r=d
try{if(a[b]===t){s=a[b]=r
s=a[b]=d()}else s=a[b]}finally{if(s===r)a[b]=null
a[c]=function(){return this[b]}}return s}}function lazy(a,b,c,d){var t=a
a[b]=t
a[c]=function(){if(a[b]===t)a[b]=d()
a[c]=function(){return this[b]}
return a[b]}}function makeConstList(a){a.immutable$list=Array
a.fixed$length=Array
return a}function convertToFastObject(a){function t(){}t.prototype=a
new t()
return a}function convertAllToFastObject(a){for(var t=0;t<a.length;++t)convertToFastObject(a[t])}var y=0
function tearOffGetter(a,b,c,d,e){return e?new Function("funcs","applyTrampolineIndex","reflectionInfo","name","H","c","return function tearOff_"+d+y+++"(receiver) {"+"if (c === null) c = "+"H.fB"+"("+"this, funcs, applyTrampolineIndex, reflectionInfo, false, true, name);"+"return new c(this, funcs[0], receiver, name);"+"}")(a,b,c,d,H,null):new Function("funcs","applyTrampolineIndex","reflectionInfo","name","H","c","return function tearOff_"+d+y+++"() {"+"if (c === null) c = "+"H.fB"+"("+"this, funcs, applyTrampolineIndex, reflectionInfo, false, false, name);"+"return new c(this, funcs[0], null, name);"+"}")(a,b,c,d,H,null)}function tearOff(a,b,c,d,e,f){var t=null
return d?function(){if(t===null)t=H.fB(this,a,b,c,true,false,e).prototype
return t}:tearOffGetter(a,b,c,e,f)}var x=0
function installTearOff(a,b,c,d,e,f,g,h,i,j){var t=[]
for(var s=0;s<h.length;s++){var r=h[s]
if(typeof r=='string')r=a[r]
r.$callName=g[s]
t.push(r)}var r=t[0]
r.$R=e
r.$D=f
var q=i
if(typeof q=="number")q+=x
var p=h[0]
r.$stubName=p
var o=tearOff(t,j||0,q,c,p,d)
a[b]=o
if(c)r.$tearOff=o}function installStaticTearOff(a,b,c,d,e,f,g,h){return installTearOff(a,b,true,false,c,d,e,f,g,h)}function installInstanceTearOff(a,b,c,d,e,f,g,h,i){return installTearOff(a,b,false,c,d,e,f,g,h,i)}function setOrUpdateInterceptorsByTag(a){var t=v.interceptorsByTag
if(!t){v.interceptorsByTag=a
return}copyProperties(a,t)}function setOrUpdateLeafTags(a){var t=v.leafTags
if(!t){v.leafTags=a
return}copyProperties(a,t)}function updateTypes(a){var t=v.types
var s=t.length
t.push.apply(t,a)
return s}function updateHolder(a,b){copyProperties(b,a)
return a}var hunkHelpers=function(){var t=function(a,b,c,d,e){return function(f,g,h,i){return installInstanceTearOff(f,g,a,b,c,d,[h],i,e)}},s=function(a,b,c,d){return function(e,f,g,h){return installStaticTearOff(e,f,a,b,c,[g],h,d)}}
return{inherit:inherit,inheritMany:inheritMany,mixin:mixin,installStaticTearOff:installStaticTearOff,installInstanceTearOff:installInstanceTearOff,_instance_0u:t(0,0,null,["$0"],0),_instance_1u:t(0,1,null,["$1"],0),_instance_2u:t(0,2,null,["$2"],0),_instance_0i:t(1,0,null,["$0"],0),_instance_1i:t(1,1,null,["$1"],0),_instance_2i:t(1,2,null,["$2"],0),_static_0:s(0,null,["$0"],0),_static_1:s(1,null,["$1"],0),_static_2:s(2,null,["$2"],0),makeConstList:makeConstList,lazy:lazy,lazyOld:lazyOld,updateHolder:updateHolder,convertToFastObject:convertToFastObject,setFunctionNamesIfNecessary:setFunctionNamesIfNecessary,updateTypes:updateTypes,setOrUpdateInterceptorsByTag:setOrUpdateInterceptorsByTag,setOrUpdateLeafTags:setOrUpdateLeafTags}}()
function initializeDeferredHunk(a){x=v.types.length
a(hunkHelpers,v,w,$)}function getGlobalFromName(a){for(var t=0;t<w.length;t++){if(w[t]==C)continue
if(w[t][a])return w[t][a]}}var C={},H={fc:function fc(){},
fj:function(a,b,c,d){P.fi(b,"start")
if(c!=null){P.fi(c,"end")
if(b>c)H.L(P.dv(b,0,c,"start",null))}return new H.bq(a,b,c,d.k("bq<0>"))},
is:function(a,b,c,d){if(u.W.b(a))return new H.S(a,b,c.k("@<0>").U(d).k("S<1,2>"))
return new H.B(a,b,c.k("@<0>").U(d).k("B<1,2>"))},
a9:function(){return new P.aR("No element")},
il:function(){return new P.aR("Too many elements")},
iI:function(a,b){H.cj(a,0,J.E(a)-1,b)},
cj:function(a,b,c,d){if(c-b<=32)H.cl(a,b,c,d)
else H.ck(a,b,c,d)},
cl:function(a,b,c,d){var t,s,r,q,p,o
for(t=b+1,s=J.m(a);t<=c;++t){r=s.h(a,t)
q=t
while(!0){if(q>b){p=d.$2(s.h(a,q-1),r)
if(typeof p!=="number")return p.B()
p=p>0}else p=!1
if(!p)break
o=q-1
s.m(a,q,s.h(a,o))
q=o}s.m(a,q,r)}},
ck:function(a4,a5,a6,a7){var t,s,r,q,p,o,n,m,l,k,j,i=C.b.a0(a6-a5+1,6),h=a5+i,g=a6-i,f=C.b.a0(a5+a6,2),e=f-i,d=f+i,c=J.m(a4),b=c.h(a4,h),a=c.h(a4,e),a0=c.h(a4,f),a1=c.h(a4,d),a2=c.h(a4,g),a3=a7.$2(b,a)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a
a=b
b=t}a3=a7.$2(a1,a2)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a2
a2=a1
a1=t}a3=a7.$2(b,a0)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a0
a0=b
b=t}a3=a7.$2(a,a0)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a0
a0=a
a=t}a3=a7.$2(b,a1)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a1
a1=b
b=t}a3=a7.$2(a0,a1)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a1
a1=a0
a0=t}a3=a7.$2(a,a2)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a2
a2=a
a=t}a3=a7.$2(a,a0)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a0
a0=a
a=t}a3=a7.$2(a1,a2)
if(typeof a3!=="number")return a3.B()
if(a3>0){t=a2
a2=a1
a1=t}c.m(a4,h,b)
c.m(a4,f,a0)
c.m(a4,g,a2)
c.m(a4,e,c.h(a4,a5))
c.m(a4,d,c.h(a4,a6))
s=a5+1
r=a6-1
if(J.n(a7.$2(a,a1),0)){for(q=s;q<=r;++q){p=c.h(a4,q)
o=a7.$2(p,a)
if(o===0)continue
if(typeof o!=="number")return o.F()
if(o<0){if(q!==s){c.m(a4,q,c.h(a4,s))
c.m(a4,s,p)}++s}else for(;!0;){o=a7.$2(c.h(a4,r),a)
if(typeof o!=="number")return o.B()
if(o>0){--r
continue}else{n=r-1
if(o<0){c.m(a4,q,c.h(a4,s))
m=s+1
c.m(a4,s,c.h(a4,r))
c.m(a4,r,p)
r=n
s=m
break}else{c.m(a4,q,c.h(a4,r))
c.m(a4,r,p)
r=n
break}}}}l=!0}else{for(q=s;q<=r;++q){p=c.h(a4,q)
k=a7.$2(p,a)
if(typeof k!=="number")return k.F()
if(k<0){if(q!==s){c.m(a4,q,c.h(a4,s))
c.m(a4,s,p)}++s}else{j=a7.$2(p,a1)
if(typeof j!=="number")return j.B()
if(j>0)for(;!0;){o=a7.$2(c.h(a4,r),a1)
if(typeof o!=="number")return o.B()
if(o>0){--r
if(r<q)break
continue}else{o=a7.$2(c.h(a4,r),a)
if(typeof o!=="number")return o.F()
n=r-1
if(o<0){c.m(a4,q,c.h(a4,s))
m=s+1
c.m(a4,s,c.h(a4,r))
c.m(a4,r,p)
s=m}else{c.m(a4,q,c.h(a4,r))
c.m(a4,r,p)}r=n
break}}}}l=!1}a3=s-1
c.m(a4,a5,c.h(a4,a3))
c.m(a4,a3,a)
a3=r+1
c.m(a4,a6,c.h(a4,a3))
c.m(a4,a3,a1)
H.cj(a4,a5,s-2,a7)
H.cj(a4,r+2,a6,a7)
if(l)return
if(s<h&&r>g){for(;J.n(a7.$2(c.h(a4,s),a),0);)++s
for(;J.n(a7.$2(c.h(a4,r),a1),0);)--r
for(q=s;q<=r;++q){p=c.h(a4,q)
if(a7.$2(p,a)===0){if(q!==s){c.m(a4,q,c.h(a4,s))
c.m(a4,s,p)}++s}else if(a7.$2(p,a1)===0)for(;!0;)if(a7.$2(c.h(a4,r),a1)===0){--r
if(r<q)break
continue}else{o=a7.$2(c.h(a4,r),a)
if(typeof o!=="number")return o.F()
n=r-1
if(o<0){c.m(a4,q,c.h(a4,s))
m=s+1
c.m(a4,s,c.h(a4,r))
c.m(a4,r,p)
s=m}else{c.m(a4,q,c.h(a4,r))
c.m(a4,r,p)}r=n
break}}H.cj(a4,s,r,a7)}else H.cj(a4,s,r,a7)},
o:function o(){},
t:function t(){},
bq:function bq(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.$ti=d},
ao:function ao(a,b){var _=this
_.a=a
_.b=b
_.c=0
_.d=null},
B:function B(a,b,c){this.a=a
this.b=b
this.$ti=c},
S:function S(a,b,c){this.a=a
this.b=b
this.$ti=c},
c4:function c4(a,b){this.a=null
this.b=a
this.c=b},
l:function l(a,b,c){this.a=a
this.b=b
this.$ti=c},
D:function D(a,b,c){this.a=a
this.b=b
this.$ti=c},
ct:function ct(a,b){this.a=a
this.b=b},
b6:function b6(a,b,c){this.a=a
this.b=b
this.$ti=c},
bX:function bX(a,b,c){var _=this
_.a=a
_.b=b
_.c=c
_.d=null},
bV:function bV(){},
b7:function b7(){},
aE:function aE(a,b){this.a=a
this.$ti=b},
aS:function aS(a){this.a=a},
hB:function(a,b){var t=new H.b9(a,b.k("b9<0>"))
t.bh(a)
return t},
hP:function(a){var t,s=H.hO(a)
if(s!=null)return s
t="minified:"+a
return t},
k0:function(a,b){var t
if(b!=null){t=b.x
if(t!=null)return t}return u.p.b(a)},
i:function(a){var t
if(typeof a=="string")return a
if(typeof a=="number"){if(a!==0)return""+a}else if(!0===a)return"true"
else if(!1===a)return"false"
else if(a==null)return"null"
t=J.P(a)
if(typeof t!="string")throw H.a(H.cH(a))
return t},
aQ:function(a){var t=a.$identityHash
if(t==null){t=Math.random()*0x3fffffff|0
a.$identityHash=t}return t},
du:function(a){return H.ix(a)},
ix:function(a){var t,s,r
if(a instanceof P.u)return H.V(H.a3(a),null)
if(J.I(a)===C.C||u.o.b(a)){t=C.l(a)
if(H.h0(t))return t
s=a.constructor
if(typeof s=="function"){r=s.name
if(typeof r=="string"&&H.h0(r))return r}}return H.V(H.a3(a),null)},
h0:function(a){var t=a!=="Object"&&a!==""
return t},
aD:function(a){if(a.date===void 0)a.date=new Date(a.a)
return a.date},
iF:function(a){var t=H.aD(a).getFullYear()+0
return t},
iD:function(a){var t=H.aD(a).getMonth()+1
return t},
iz:function(a){var t=H.aD(a).getDate()+0
return t},
iA:function(a){var t=H.aD(a).getHours()+0
return t},
iC:function(a){var t=H.aD(a).getMinutes()+0
return t},
iE:function(a){var t=H.aD(a).getSeconds()+0
return t},
iB:function(a){var t=H.aD(a).getMilliseconds()+0
return t},
ap:function(a,b,c){var t,s,r={}
r.a=0
t=[]
s=[]
r.a=b.length
C.a.H(t,b)
r.b=""
if(c!=null&&!c.ga1(c))c.R(0,new H.dt(r,s,t))
""+r.a
return J.i2(a,new H.cU(C.H,0,t,s,0))},
iy:function(a,b,c){var t,s,r,q
if(b instanceof Array)t=c==null||c.ga1(c)
else t=!1
if(t){s=b
r=s.length
if(r===0){if(!!a.$0)return a.$0()}else if(r===1){if(!!a.$1)return a.$1(s[0])}else if(r===2){if(!!a.$2)return a.$2(s[0],s[1])}else if(r===3){if(!!a.$3)return a.$3(s[0],s[1],s[2])}else if(r===4){if(!!a.$4)return a.$4(s[0],s[1],s[2],s[3])}else if(r===5)if(!!a.$5)return a.$5(s[0],s[1],s[2],s[3],s[4])
q=a[""+"$"+r]
if(q!=null)return q.apply(a,s)}return H.iw(a,b,c)},
iw:function(a,b,c){var t,s,r,q,p,o,n,m,l,k,j=b instanceof Array?b:P.r(b,!0,u.z),i=j.length,h=a.$R
if(i<h)return H.ap(a,j,c)
t=a.$D
s=t==null
r=!s?t():null
q=J.I(a)
p=q.$C
if(typeof p=="string")p=q[p]
if(s){if(c!=null&&c.gb_(c))return H.ap(a,j,c)
if(i===h)return p.apply(a,j)
return H.ap(a,j,c)}if(r instanceof Array){if(c!=null&&c.gb_(c))return H.ap(a,j,c)
if(i>h+r.length)return H.ap(a,j,null)
C.a.H(j,r.slice(i-h))
return p.apply(a,j)}else{if(i>h)return H.ap(a,j,c)
o=Object.keys(r)
if(c==null)for(s=o.length,n=0;n<o.length;o.length===s||(0,H.K)(o),++n){m=r[o[n]]
if(C.n===m)return H.ap(a,j,c)
C.a.G(j,m)}else{for(s=o.length,l=0,n=0;n<o.length;o.length===s||(0,H.K)(o),++n){k=o[n]
if(c.a6(k)){++l
C.a.G(j,c.h(0,k))}else{m=r[k]
if(C.n===m)return H.ap(a,j,c)
C.a.G(j,m)}}if(l!==c.gi(c))return H.ap(a,j,c)}return p.apply(a,j)}},
j:function(a){throw H.a(H.cH(a))},
f:function(a,b){if(a==null)J.E(a)
throw H.a(H.aY(a,b))},
aY:function(a,b){var t,s,r="index"
if(!H.aV(b))return new P.a7(!0,b,r,null)
t=J.E(a)
if(!(b<0)){if(typeof t!=="number")return H.j(t)
s=b>=t}else s=!0
if(s)return P.fa(b,a,r,null,t)
return P.fh(b,r)},
cH:function(a){return new P.a7(!0,a,null,null)},
eb:function(a){if(typeof a!="number")throw H.a(H.cH(a))
return a},
a:function(a){var t,s
if(a==null)a=new P.ce()
t=new Error()
t.dartException=a
s=H.kf
if("defineProperty" in Object){Object.defineProperty(t,"message",{get:s})
t.name=""}else t.toString=s
return t},
kf:function(){return J.P(this.dartException)},
L:function(a){throw H.a(a)},
K:function(a){throw H.a(P.N(a))},
ae:function(a){var t,s,r,q,p,o
a=H.kc(a.replace(String({}),'$receiver$'))
t=a.match(/\\\$[a-zA-Z]+\\\$/g)
if(t==null)t=H.b([],u.s)
s=t.indexOf("\\$arguments\\$")
r=t.indexOf("\\$argumentsExpr\\$")
q=t.indexOf("\\$expr\\$")
p=t.indexOf("\\$method\\$")
o=t.indexOf("\\$receiver\\$")
return new H.dw(a.replace(new RegExp('\\\\\\$arguments\\\\\\$','g'),'((?:x|[^x])*)').replace(new RegExp('\\\\\\$argumentsExpr\\\\\\$','g'),'((?:x|[^x])*)').replace(new RegExp('\\\\\\$expr\\\\\\$','g'),'((?:x|[^x])*)').replace(new RegExp('\\\\\\$method\\\\\\$','g'),'((?:x|[^x])*)').replace(new RegExp('\\\\\\$receiver\\\\\\$','g'),'((?:x|[^x])*)'),s,r,q,p,o)},
dx:function(a){return function($expr$){var $argumentsExpr$='$arguments$'
try{$expr$.$method$($argumentsExpr$)}catch(t){return t.message}}(a)},
h4:function(a){return function($expr$){try{$expr$.$method$}catch(t){return t.message}}(a)},
h_:function(a,b){return new H.cd(a,b==null?null:b.method)},
fd:function(a,b){var t=b==null,s=t?null:b.method
return new H.c2(a,s,t?null:b.receiver)},
f7:function(a){if(a==null)return new H.d5(a)
if(typeof a!=="object")return a
if("dartException" in a)return H.aI(a,a.dartException)
return H.jI(a)},
aI:function(a,b){if(u.l.b(b))if(b.$thrownJsError==null)b.$thrownJsError=a
return b},
jI:function(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f=null
if(!("message" in a))return a
t=a.message
if("number" in a&&typeof a.number=="number"){s=a.number
r=s&65535
if((C.b.aP(s,16)&8191)===10)switch(r){case 438:return H.aI(a,H.fd(H.i(t)+" (Error "+r+")",f))
case 445:case 5007:return H.aI(a,H.h_(H.i(t)+" (Error "+r+")",f))}}if(a instanceof TypeError){q=$.hQ()
p=$.hR()
o=$.hS()
n=$.hT()
m=$.hW()
l=$.hX()
k=$.hV()
$.hU()
j=$.hZ()
i=$.hY()
h=q.T(t)
if(h!=null)return H.aI(a,H.fd(t,h))
else{h=p.T(t)
if(h!=null){h.method="call"
return H.aI(a,H.fd(t,h))}else{h=o.T(t)
if(h==null){h=n.T(t)
if(h==null){h=m.T(t)
if(h==null){h=l.T(t)
if(h==null){h=k.T(t)
if(h==null){h=n.T(t)
if(h==null){h=j.T(t)
if(h==null){h=i.T(t)
g=h!=null}else g=!0}else g=!0}else g=!0}else g=!0}else g=!0}else g=!0}else g=!0
if(g)return H.aI(a,H.h_(t,h))}}return H.aI(a,new H.cr(typeof t=="string"?t:""))}if(a instanceof RangeError){if(typeof t=="string"&&t.indexOf("call stack")!==-1)return new P.bn()
t=function(b){try{return String(b)}catch(e){}return null}(a)
return H.aI(a,new P.a7(!1,f,f,typeof t=="string"?t.replace(/^RangeError:\s*/,""):t))}if(typeof InternalError=="function"&&a instanceof InternalError)if(typeof t=="string"&&t==="too much recursion")return new P.bn()
return a},
jW:function(a){var t
if(a==null)return new H.cB(a)
t=a.$cachedTrace
if(t!=null)return t
return a.$cachedTrace=new H.cB(a)},
hL:function(a){if(a==null||typeof a!='object')return J.av(a)
else return H.aQ(a)},
jS:function(a,b){var t,s,r,q=a.length
for(t=0;t<q;t=r){s=t+1
r=s+1
b.m(0,a[t],a[s])}return b},
jT:function(a,b){var t,s=a.length
for(t=0;t<s;++t)b.G(0,a[t])
return b},
k_:function(a,b,c,d,e,f){switch(b){case 0:return a.$0()
case 1:return a.$1(c)
case 2:return a.$2(c,d)
case 3:return a.$3(c,d,e)
case 4:return a.$4(c,d,e,f)}throw H.a(P.fT("Unsupported number of arguments for wrapped closure"))},
ec:function(a,b){var t=a.$identity
if(!!t)return t
t=function(c,d,e){return function(f,g,h,i){return e(c,d,f,g,h,i)}}(a,b,H.k_)
a.$identity=t
return t},
ig:function(a,b,c,d,e,f,g){var t,s,r,q,p,o,n,m=b[0],l=m.$callName,k=e?Object.create(new H.cm().constructor.prototype):Object.create(new H.aJ(null,null,null,"").constructor.prototype)
k.$initialize=k.constructor
if(e)t=function static_tear_off(){this.$initialize()}
else{s=$.a8
if(typeof s!=="number")return s.A()
$.a8=s+1
s=new Function("a,b,c,d"+s,"this.$initialize(a,b,c,d"+s+")")
t=s}k.constructor=t
t.prototype=k
if(!e){r=H.fS(a,m,f)
r.$reflectionInfo=d}else{k.$static_name=g
r=m}k.$S=H.ib(d,e,f)
k[l]=r
for(q=r,p=1;p<b.length;++p){o=b[p]
n=o.$callName
if(n!=null){o=e?o:H.fS(a,o,f)
k[n]=o}if(p===c){o.$reflectionInfo=d
q=o}}k.$C=q
k.$R=m.$R
k.$D=m.$D
return t},
ib:function(a,b,c){var t
if(typeof a=="number")return function(d,e){return function(){return d(e)}}(H.hz,a)
if(typeof a=="string"){if(b)throw H.a("Cannot compute signature for static tearoff.")
t=c?H.i9:H.i8
return function(d,e){return function(){return e(this,d)}}(a,t)}throw H.a("Error in functionType of tearoff")},
ic:function(a,b,c,d){var t=H.fQ
switch(b?-1:a){case 0:return function(e,f){return function(){return f(this)[e]()}}(c,t)
case 1:return function(e,f){return function(g){return f(this)[e](g)}}(c,t)
case 2:return function(e,f){return function(g,h){return f(this)[e](g,h)}}(c,t)
case 3:return function(e,f){return function(g,h,i){return f(this)[e](g,h,i)}}(c,t)
case 4:return function(e,f){return function(g,h,i,j){return f(this)[e](g,h,i,j)}}(c,t)
case 5:return function(e,f){return function(g,h,i,j,k){return f(this)[e](g,h,i,j,k)}}(c,t)
default:return function(e,f){return function(){return e.apply(f(this),arguments)}}(d,t)}},
fS:function(a,b,c){var t,s,r,q,p,o,n
if(c)return H.ie(a,b)
t=b.$stubName
s=b.length
r=a[t]
q=b==null?r==null:b===r
p=!q||s>=27
if(p)return H.ic(s,!q,t,b)
if(s===0){q=$.a8
if(typeof q!=="number")return q.A()
$.a8=q+1
o="self"+q
return new Function("return function(){var "+o+" = this."+H.i(H.f9())+";return "+o+"."+H.i(t)+"();}")()}n="abcdefghijklmnopqrstuvwxyz".split("").splice(0,s).join(",")
q=$.a8
if(typeof q!=="number")return q.A()
$.a8=q+1
n+=q
return new Function("return function("+n+"){return this."+H.i(H.f9())+"."+H.i(t)+"("+n+");}")()},
id:function(a,b,c,d){var t=H.fQ,s=H.ia
switch(b?-1:a){case 0:throw H.a(new H.cg("Intercepted function with no arguments."))
case 1:return function(e,f,g){return function(){return f(this)[e](g(this))}}(c,t,s)
case 2:return function(e,f,g){return function(h){return f(this)[e](g(this),h)}}(c,t,s)
case 3:return function(e,f,g){return function(h,i){return f(this)[e](g(this),h,i)}}(c,t,s)
case 4:return function(e,f,g){return function(h,i,j){return f(this)[e](g(this),h,i,j)}}(c,t,s)
case 5:return function(e,f,g){return function(h,i,j,k){return f(this)[e](g(this),h,i,j,k)}}(c,t,s)
case 6:return function(e,f,g){return function(h,i,j,k,l){return f(this)[e](g(this),h,i,j,k,l)}}(c,t,s)
default:return function(e,f,g,h){return function(){h=[g(this)]
Array.prototype.push.apply(h,arguments)
return e.apply(f(this),h)}}(d,t,s)}},
ie:function(a,b){var t,s,r,q,p,o,n=H.f9(),m=$.fO
if(m==null)m=$.fO=H.fN("receiver")
t=b.$stubName
s=b.length
r=a[t]
q=b==null?r==null:b===r
p=!q||s>=28
if(p)return H.id(s,!q,t,b)
if(s===1){q="return function(){return this."+H.i(n)+"."+H.i(t)+"(this."+m+");"
p=$.a8
if(typeof p!=="number")return p.A()
$.a8=p+1
return new Function(q+p+"}")()}o="abcdefghijklmnopqrstuvwxyz".split("").splice(0,s-1).join(",")
q="return function("+o+"){return this."+H.i(n)+"."+H.i(t)+"(this."+m+", "+o+");"
p=$.a8
if(typeof p!=="number")return p.A()
$.a8=p+1
return new Function(q+p+"}")()},
fB:function(a,b,c,d,e,f,g){return H.ig(a,b,c,d,!!e,!!f,g)},
i8:function(a,b){return H.cE(v.typeUniverse,H.a3(a.a),b)},
i9:function(a,b){return H.cE(v.typeUniverse,H.a3(a.c),b)},
fQ:function(a){return a.a},
ia:function(a){return a.c},
f9:function(){var t=$.fP
return t==null?$.fP=H.fN("self"):t},
fN:function(a){var t,s,r,q=new H.aJ("self","target","receiver","name"),p=J.fW(Object.getOwnPropertyNames(q))
for(t=p.length,s=0;s<t;++s){r=p[s]
if(q[r]===a)return r}throw H.a(P.b0("Field name "+a+" not found."))},
ke:function(a){throw H.a(new P.bT(a))},
hx:function(a){return v.getIsolateTag(a)},
kZ:function(a,b,c){Object.defineProperty(a,b,{value:c,enumerable:false,writable:true,configurable:true})},
k4:function(a){var t,s,r,q,p,o=$.hy.$1(a),n=$.ey[o]
if(n!=null){Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}t=$.eQ[o]
if(t!=null)return t
s=v.interceptorsByTag[o]
if(s==null){r=$.ht.$2(a,o)
if(r!=null){n=$.ey[r]
if(n!=null){Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}t=$.eQ[r]
if(t!=null)return t
s=v.interceptorsByTag[r]
o=r}}if(s==null)return null
t=s.prototype
q=o[0]
if(q==="!"){n=H.eS(t)
$.ey[o]=n
Object.defineProperty(a,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
return n.i}if(q==="~"){$.eQ[o]=t
return t}if(q==="-"){p=H.eS(t)
Object.defineProperty(Object.getPrototypeOf(a),v.dispatchPropertyName,{value:p,enumerable:false,writable:true,configurable:true})
return p.i}if(q==="+")return H.hM(a,t)
if(q==="*")throw H.a(P.h5(o))
if(v.leafTags[o]===true){p=H.eS(t)
Object.defineProperty(Object.getPrototypeOf(a),v.dispatchPropertyName,{value:p,enumerable:false,writable:true,configurable:true})
return p.i}else return H.hM(a,t)},
hM:function(a,b){var t=Object.getPrototypeOf(a)
Object.defineProperty(t,v.dispatchPropertyName,{value:J.fF(b,t,null,null),enumerable:false,writable:true,configurable:true})
return b},
eS:function(a){return J.fF(a,!1,null,!!a.$ia_)},
k5:function(a,b,c){var t=b.prototype
if(v.leafTags[a]===true)return H.eS(t)
else return J.fF(t,c,null,null)},
jY:function(){if(!0===$.fD)return
$.fD=!0
H.jZ()},
jZ:function(){var t,s,r,q,p,o,n,m
$.ey=Object.create(null)
$.eQ=Object.create(null)
H.jX()
t=v.interceptorsByTag
s=Object.getOwnPropertyNames(t)
if(typeof window!="undefined"){window
r=function(){}
for(q=0;q<s.length;++q){p=s[q]
o=$.hN.$1(p)
if(o!=null){n=H.k5(p,t[p],o)
if(n!=null){Object.defineProperty(o,v.dispatchPropertyName,{value:n,enumerable:false,writable:true,configurable:true})
r.prototype=o}}}}for(q=0;q<s.length;++q){p=s[q]
if(/^[A-Za-z_]/.test(p)){m=t[p]
t["!"+p]=m
t["~"+p]=m
t["-"+p]=m
t["+"+p]=m
t["*"+p]=m}}},
jX:function(){var t,s,r,q,p,o,n=C.u()
n=H.aX(C.v,H.aX(C.w,H.aX(C.m,H.aX(C.m,H.aX(C.x,H.aX(C.y,H.aX(C.z(C.l),n)))))))
if(typeof dartNativeDispatchHooksTransformer!="undefined"){t=dartNativeDispatchHooksTransformer
if(typeof t=="function")t=[t]
if(t.constructor==Array)for(s=0;s<t.length;++s){r=t[s]
if(typeof r=="function")n=r(n)||n}}q=n.getTag
p=n.getUnknownTag
o=n.prototypeForTag
$.hy=new H.eN(q)
$.ht=new H.eO(p)
$.hN=new H.eP(o)},
aX:function(a,b){return a(b)||b},
kc:function(a){if(/[[\]{}()*+?.\\^$|]/.test(a))return a.replace(/[[\]{}()*+?.\\^$|]/g,"\\$&")
return a},
b3:function b3(a,b){this.a=a
this.$ti=b},
b2:function b2(){},
b4:function b4(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.$ti=d},
bs:function bs(a,b){this.a=a
this.$ti=b},
c_:function c_(){},
b9:function b9(a,b){this.a=a
this.$ti=b},
cU:function cU(a,b,c,d,e){var _=this
_.a=a
_.c=b
_.d=c
_.e=d
_.f=e},
dt:function dt(a,b,c){this.a=a
this.b=b
this.c=c},
dw:function dw(a,b,c,d,e,f){var _=this
_.a=a
_.b=b
_.c=c
_.d=d
_.e=e
_.f=f},
cd:function cd(a,b){this.a=a
this.b=b},
c2:function c2(a,b,c){this.a=a
this.b=b
this.c=c},
cr:function cr(a){this.a=a},
d5:function d5(a){this.a=a},
cB:function cB(a){this.a=a
this.b=null},
ax:function ax(){},
co:function co(){},
cm:function cm(){},
aJ:function aJ(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
cg:function cg(a){this.a=a},
dE:function dE(){},
aa:function aa(a){var _=this
_.a=0
_.f=_.e=_.d=_.c=_.b=null
_.r=0
_.$ti=a},
cY:function cY(a,b){this.a=a
this.b=b
this.c=null},
be:function be(a,b){this.a=a
this.$ti=b},
c3:function c3(a,b){var _=this
_.a=a
_.b=b
_.d=_.c=null},
eN:function eN(a){this.a=a},
eO:function eO(a){this.a=a},
eP:function eP(a){this.a=a},
ah:function(a,b,c){if(a>>>0!==a||a>=c)throw H.a(H.aY(b,a))},
aB:function aB(){},
aO:function aO(){},
aA:function aA(){},
bi:function bi(){},
c6:function c6(){},
c7:function c7(){},
c8:function c8(){},
c9:function c9(){},
ca:function ca(){},
bj:function bj(){},
cb:function cb(){},
by:function by(){},
bz:function bz(){},
bA:function bA(){},
bB:function bB(){},
iH:function(a,b){var t=b.c
return t==null?b.c=H.fq(a,b.z,!0):t},
h1:function(a,b){var t=b.c
return t==null?b.c=H.bF(a,"fU",[b.z]):t},
h2:function(a){var t=a.y
if(t===6||t===7||t===8)return H.h2(a.z)
return t===11||t===12},
iG:function(a){return a.cy},
eM:function(a){return H.dM(v.typeUniverse,a,!1)},
hC:function(a,b){var t,s,r,q,p
if(a==null)return null
t=b.Q
s=a.cx
if(s==null)s=a.cx=new Map()
r=b.cy
q=s.get(r)
if(q!=null)return q
p=H.ai(v.typeUniverse,a.z,t,0)
s.set(r,p)
return p},
ai:function(a,b,c,a0){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d=b.y
switch(d){case 5:case 1:case 2:case 3:case 4:return b
case 6:t=b.z
s=H.ai(a,t,c,a0)
if(s===t)return b
return H.hf(a,s,!0)
case 7:t=b.z
s=H.ai(a,t,c,a0)
if(s===t)return b
return H.fq(a,s,!0)
case 8:t=b.z
s=H.ai(a,t,c,a0)
if(s===t)return b
return H.he(a,s,!0)
case 9:r=b.Q
q=H.bM(a,r,c,a0)
if(q===r)return b
return H.bF(a,b.z,q)
case 10:p=b.z
o=H.ai(a,p,c,a0)
n=b.Q
m=H.bM(a,n,c,a0)
if(o===p&&m===n)return b
return H.fo(a,o,m)
case 11:l=b.z
k=H.ai(a,l,c,a0)
j=b.Q
i=H.jE(a,j,c,a0)
if(k===l&&i===j)return b
return H.hd(a,k,i)
case 12:h=b.Q
a0+=h.length
g=H.bM(a,h,c,a0)
p=b.z
o=H.ai(a,p,c,a0)
if(g===h&&o===p)return b
return H.fp(a,o,g,!0)
case 13:f=b.z
if(f<a0)return b
e=c[f-a0]
if(e==null)return b
return e
default:throw H.a(P.cO("Attempted to substitute unexpected RTI kind "+d))}},
bM:function(a,b,c,d){var t,s,r,q,p=b.length,o=[]
for(t=!1,s=0;s<p;++s){r=b[s]
q=H.ai(a,r,c,d)
if(q!==r)t=!0
o.push(q)}return t?o:b},
jF:function(a,b,c,d){var t,s,r,q,p,o,n=b.length,m=[]
for(t=!1,s=0;s<n;s+=3){r=b[s]
q=b[s+1]
p=b[s+2]
o=H.ai(a,p,c,d)
if(o!==p)t=!0
m.push(r)
m.push(q)
m.push(o)}return t?m:b},
jE:function(a,b,c,d){var t,s=b.a,r=H.bM(a,s,c,d),q=b.b,p=H.bM(a,q,c,d),o=b.c,n=H.jF(a,o,c,d)
if(r===s&&p===q&&n===o)return b
t=new H.cy()
t.a=r
t.b=p
t.c=n
return t},
b:function(a,b){a[v.arrayRti]=b
return a},
hv:function(a){var t=a.$S
if(t!=null){if(typeof t=="number")return H.hz(t)
return a.$S()}return null},
hA:function(a,b){var t
if(H.h2(b))if(a instanceof H.ax){t=H.hv(a)
if(t!=null)return t}return H.a3(a)},
a3:function(a){var t
if(a instanceof P.u){t=a.$ti
return t!=null?t:H.fv(a)}if(Array.isArray(a))return H.F(a)
return H.fv(J.I(a))},
F:function(a){var t=a[v.arrayRti],s=u.n
if(t==null)return s
if(t.constructor!==s.constructor)return s
return t},
Y:function(a){var t=a.$ti
return t!=null?t:H.fv(a)},
fv:function(a){var t=a.constructor,s=t.$ccache
if(s!=null)return s
return H.ji(a,t)},
ji:function(a,b){var t=a instanceof H.ax?a.__proto__.__proto__.constructor:b,s=H.j4(v.typeUniverse,t.name)
b.$ccache=s
return s},
hz:function(a){var t,s=v.types,r=s[a]
if(typeof r=="string"){t=H.dM(v.typeUniverse,r,!1)
s[a]=t
return t}return r},
jP:function(a){var t,s,r,q=a.x
if(q!=null)return q
t=a.cy
s=t.replace(/\*/g,"")
if(s===t)return a.x=new H.cC(a)
r=H.dM(v.typeUniverse,s,!0)
q=r.x
return a.x=q==null?r.x=new H.cC(r):q},
jh:function(a){var t,s,r=this,q=u.C
if(r===q)return H.bI(r,a,H.jn)
if(!H.aj(r))if(!(r===u._))q=r===q
else q=!0
else q=!0
if(q)return H.bI(r,a,H.jq)
q=r.y
t=q===6?r.z:r
if(t===u.S)s=H.aV
else if(t===u.cb||t===u.H)s=H.jm
else if(t===u.N)s=H.jo
else s=t===u.y?H.fw:null
if(s!=null)return H.bI(r,a,s)
if(t.y===9){q=t.z
if(t.Q.every(H.k1)){r.r="$i"+q
return H.bI(r,a,H.jp)}}else if(q===7)return H.bI(r,a,H.jf)
return H.bI(r,a,H.jd)},
bI:function(a,b,c){a.b=c
return a.b(b)},
jg:function(a){var t,s,r=this
if(!H.aj(r))if(!(r===u._))t=r===u.C
else t=!0
else t=!0
if(t)s=H.j7
else if(r===u.C)s=H.j6
else s=H.je
r.a=s
return r.a(a)},
ju:function(a){var t,s=a.y
if(!H.aj(a))if(!(a===u._))t=a===u.C
else t=!0
else t=!0
return t||a===u.F||s===7||a===u.P||a===u.T},
jd:function(a){var t=this
if(a==null)return H.ju(t)
return H.G(v.typeUniverse,H.hA(a,t),null,t,null)},
jf:function(a){if(a==null)return!0
return this.z.b(a)},
jp:function(a){var t=this,s=t.r
if(a instanceof P.u)return!!a[s]
return!!J.I(a)[s]},
kY:function(a){var t=this
if(a==null)return a
else if(t.b(a))return a
H.hl(a,t)},
je:function(a){var t=this
if(a==null)return a
else if(t.b(a))return a
H.hl(a,t)},
hl:function(a,b){throw H.a(H.iV(H.h6(a,H.hA(a,b),H.V(b,null))))},
h6:function(a,b,c){var t=P.aL(a),s=H.V(b==null?H.a3(a):b,null)
return t+": type '"+H.i(s)+"' is not a subtype of type '"+H.i(c)+"'"},
iV:function(a){return new H.bE("TypeError: "+a)},
Q:function(a,b){return new H.bE("TypeError: "+H.h6(a,null,b))},
jn:function(a){return a!=null},
j6:function(a){return a},
jq:function(a){return!0},
j7:function(a){return a},
fw:function(a){return!0===a||!1===a},
kI:function(a){if(!0===a)return!0
if(!1===a)return!1
throw H.a(H.Q(a,"bool"))},
kK:function(a){if(!0===a)return!0
if(!1===a)return!1
if(a==null)return a
throw H.a(H.Q(a,"bool"))},
kJ:function(a){if(!0===a)return!0
if(!1===a)return!1
if(a==null)return a
throw H.a(H.Q(a,"bool?"))},
kL:function(a){if(typeof a=="number")return a
throw H.a(H.Q(a,"double"))},
hj:function(a){if(typeof a=="number")return a
if(a==null)return a
throw H.a(H.Q(a,"double"))},
kM:function(a){if(typeof a=="number")return a
if(a==null)return a
throw H.a(H.Q(a,"double?"))},
aV:function(a){return typeof a=="number"&&Math.floor(a)===a},
kN:function(a){if(typeof a=="number"&&Math.floor(a)===a)return a
throw H.a(H.Q(a,"int"))},
kP:function(a){if(typeof a=="number"&&Math.floor(a)===a)return a
if(a==null)return a
throw H.a(H.Q(a,"int"))},
kO:function(a){if(typeof a=="number"&&Math.floor(a)===a)return a
if(a==null)return a
throw H.a(H.Q(a,"int?"))},
jm:function(a){return typeof a=="number"},
kQ:function(a){if(typeof a=="number")return a
throw H.a(H.Q(a,"num"))},
kS:function(a){if(typeof a=="number")return a
if(a==null)return a
throw H.a(H.Q(a,"num"))},
kR:function(a){if(typeof a=="number")return a
if(a==null)return a
throw H.a(H.Q(a,"num?"))},
jo:function(a){return typeof a=="string"},
kT:function(a){if(typeof a=="string")return a
throw H.a(H.Q(a,"String"))},
kV:function(a){if(typeof a=="string")return a
if(a==null)return a
throw H.a(H.Q(a,"String"))},
kU:function(a){if(typeof a=="string")return a
if(a==null)return a
throw H.a(H.Q(a,"String?"))},
jz:function(a,b){var t,s,r
for(t="",s="",r=0;r<a.length;++r,s=", ")t+=C.e.A(s,H.V(a[r],b))
return t},
hn:function(a4,a5,a6){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3=", "
if(a6!=null){t=a6.length
if(a5==null){a5=H.b([],u.s)
s=null}else s=a5.length
r=a5.length
for(q=t;q>0;--q)a5.push("T"+(r+q))
for(p=u.O,o=u._,n=u.C,m="<",l="",q=0;q<t;++q,l=a3){m+=l
k=a5.length
j=k-1-q
if(j<0)return H.f(a5,j)
m=C.e.A(m,a5[j])
i=a6[q]
h=i.y
if(!(h===2||h===3||h===4||h===5||i===p))if(!(i===o))k=i===n
else k=!0
else k=!0
if(!k)m+=C.e.A(" extends ",H.V(i,a5))}m+=">"}else{m=""
s=null}p=a4.z
g=a4.Q
f=g.a
e=f.length
d=g.b
c=d.length
b=g.c
a=b.length
a0=H.V(p,a5)
for(a1="",a2="",q=0;q<e;++q,a2=a3)a1+=C.e.A(a2,H.V(f[q],a5))
if(c>0){a1+=a2+"["
for(a2="",q=0;q<c;++q,a2=a3)a1+=C.e.A(a2,H.V(d[q],a5))
a1+="]"}if(a>0){a1+=a2+"{"
for(a2="",q=0;q<a;q+=3,a2=a3){a1+=a2
if(b[q+1])a1+="required "
a1+=J.fK(H.V(b[q+2],a5)," ")+b[q]}a1+="}"}if(s!=null){a5.toString
a5.length=s}return m+"("+a1+") => "+H.i(a0)},
V:function(a,b){var t,s,r,q,p,o,n,m=a.y
if(m===5)return"erased"
if(m===2)return"dynamic"
if(m===3)return"void"
if(m===1)return"Never"
if(m===4)return"any"
if(m===6){t=H.V(a.z,b)
return t}if(m===7){s=a.z
t=H.V(s,b)
r=s.y
return J.fK(r===11||r===12?C.e.A("(",t)+")":t,"?")}if(m===8)return"FutureOr<"+H.i(H.V(a.z,b))+">"
if(m===9){q=H.jH(a.z)
p=a.Q
return p.length!==0?q+("<"+H.jz(p,b)+">"):q}if(m===11)return H.hn(a,b,null)
if(m===12)return H.hn(a.z,b,a.Q)
if(m===13){b.toString
o=a.z
n=b.length
o=n-1-o
if(o<0||o>=n)return H.f(b,o)
return b[o]}return"?"},
jH:function(a){var t,s=H.hO(a)
if(s!=null)return s
t="minified:"+a
return t},
hg:function(a,b){var t=a.tR[b]
for(;typeof t=="string";)t=a.tR[t]
return t},
j4:function(a,b){var t,s,r,q,p,o=a.eT,n=o[b]
if(n==null)return H.dM(a,b,!1)
else if(typeof n=="number"){t=n
s=H.bG(a,5,"#")
r=[]
for(q=0;q<t;++q)r.push(s)
p=H.bF(a,b,r)
o[b]=p
return p}else return n},
j2:function(a,b){return H.hh(a.tR,b)},
j1:function(a,b){return H.hh(a.eT,b)},
dM:function(a,b,c){var t,s=a.eC,r=s.get(b)
if(r!=null)return r
t=H.hc(H.ha(a,null,b,c))
s.set(b,t)
return t},
cE:function(a,b,c){var t,s,r=b.ch
if(r==null)r=b.ch=new Map()
t=r.get(c)
if(t!=null)return t
s=H.hc(H.ha(a,b,c,!0))
r.set(c,s)
return s},
j3:function(a,b,c){var t,s,r,q=b.cx
if(q==null)q=b.cx=new Map()
t=c.cy
s=q.get(t)
if(s!=null)return s
r=H.fo(a,b,c.y===10?c.Q:[c])
q.set(t,r)
return r},
au:function(a,b){b.a=H.jg
b.b=H.jh
return b},
bG:function(a,b,c){var t,s,r=a.eC.get(c)
if(r!=null)return r
t=new H.a0(null,null)
t.y=b
t.cy=c
s=H.au(a,t)
a.eC.set(c,s)
return s},
hf:function(a,b,c){var t,s=b.cy+"*",r=a.eC.get(s)
if(r!=null)return r
t=H.j_(a,b,s,c)
a.eC.set(s,t)
return t},
j_:function(a,b,c,d){var t,s,r
if(d){t=b.y
if(!H.aj(b))s=b===u.P||b===u.T||t===7||t===6
else s=!0
if(s)return b}r=new H.a0(null,null)
r.y=6
r.z=b
r.cy=c
return H.au(a,r)},
fq:function(a,b,c){var t,s=b.cy+"?",r=a.eC.get(s)
if(r!=null)return r
t=H.iZ(a,b,s,c)
a.eC.set(s,t)
return t},
iZ:function(a,b,c,d){var t,s,r,q
if(d){t=b.y
if(!H.aj(b))if(!(b===u.P||b===u.T))if(t!==7)s=t===8&&H.eR(b.z)
else s=!0
else s=!0
else s=!0
if(s)return b
else if(t===1||b===u.F)return u.P
else if(t===6){r=b.z
if(r.y===8&&H.eR(r.z))return r
else return H.iH(a,b)}}q=new H.a0(null,null)
q.y=7
q.z=b
q.cy=c
return H.au(a,q)},
he:function(a,b,c){var t,s=b.cy+"/",r=a.eC.get(s)
if(r!=null)return r
t=H.iX(a,b,s,c)
a.eC.set(s,t)
return t},
iX:function(a,b,c,d){var t,s,r
if(d){t=b.y
if(!H.aj(b))if(!(b===u._))s=b===u.C
else s=!0
else s=!0
if(s||b===u.C)return b
else if(t===1)return H.bF(a,"fU",[b])
else if(b===u.P||b===u.T)return u.bc}r=new H.a0(null,null)
r.y=8
r.z=b
r.cy=c
return H.au(a,r)},
j0:function(a,b){var t,s,r=""+b+"^",q=a.eC.get(r)
if(q!=null)return q
t=new H.a0(null,null)
t.y=13
t.z=b
t.cy=r
s=H.au(a,t)
a.eC.set(r,s)
return s},
cD:function(a){var t,s,r,q=a.length
for(t="",s="",r=0;r<q;++r,s=",")t+=s+a[r].cy
return t},
iW:function(a){var t,s,r,q,p,o,n=a.length
for(t="",s="",r=0;r<n;r+=3,s=","){q=a[r]
p=a[r+1]?"!":":"
o=a[r+2].cy
t+=s+q+p+o}return t},
bF:function(a,b,c){var t,s,r,q=b
if(c.length!==0)q+="<"+H.cD(c)+">"
t=a.eC.get(q)
if(t!=null)return t
s=new H.a0(null,null)
s.y=9
s.z=b
s.Q=c
if(c.length>0)s.c=c[0]
s.cy=q
r=H.au(a,s)
a.eC.set(q,r)
return r},
fo:function(a,b,c){var t,s,r,q,p,o
if(b.y===10){t=b.z
s=b.Q.concat(c)}else{s=c
t=b}r=t.cy+(";<"+H.cD(s)+">")
q=a.eC.get(r)
if(q!=null)return q
p=new H.a0(null,null)
p.y=10
p.z=t
p.Q=s
p.cy=r
o=H.au(a,p)
a.eC.set(r,o)
return o},
hd:function(a,b,c){var t,s,r,q,p,o=b.cy,n=c.a,m=n.length,l=c.b,k=l.length,j=c.c,i=j.length,h="("+H.cD(n)
if(k>0){t=m>0?",":""
s=H.cD(l)
h+=t+"["+s+"]"}if(i>0){t=m>0?",":""
s=H.iW(j)
h+=t+"{"+s+"}"}r=o+(h+")")
q=a.eC.get(r)
if(q!=null)return q
p=new H.a0(null,null)
p.y=11
p.z=b
p.Q=c
p.cy=r
s=H.au(a,p)
a.eC.set(r,s)
return s},
fp:function(a,b,c,d){var t,s=b.cy+("<"+H.cD(c)+">"),r=a.eC.get(s)
if(r!=null)return r
t=H.iY(a,b,c,s,d)
a.eC.set(s,t)
return t},
iY:function(a,b,c,d,e){var t,s,r,q,p,o,n,m
if(e){t=c.length
s=new Array(t)
for(r=0,q=0;q<t;++q){p=c[q]
if(p.y===1){s[q]=p;++r}}if(r>0){o=H.ai(a,b,s,0)
n=H.bM(a,c,s,0)
return H.fp(a,o,n,c!==n)}}m=new H.a0(null,null)
m.y=12
m.z=b
m.Q=c
m.cy=d
return H.au(a,m)},
ha:function(a,b,c,d){return{u:a,e:b,r:c,s:[],p:0,n:d}},
hc:function(a){var t,s,r,q,p,o,n,m,l,k,j,i,h=a.r,g=a.s
for(t=h.length,s=0;s<t;){r=h.charCodeAt(s)
if(r>=48&&r<=57)s=H.iQ(s+1,r,h,g)
else if((((r|32)>>>0)-97&65535)<26||r===95||r===36)s=H.hb(a,s,h,g,!1)
else if(r===46)s=H.hb(a,s,h,g,!0)
else{++s
switch(r){case 44:break
case 58:g.push(!1)
break
case 33:g.push(!0)
break
case 59:g.push(H.as(a.u,a.e,g.pop()))
break
case 94:g.push(H.j0(a.u,g.pop()))
break
case 35:g.push(H.bG(a.u,5,"#"))
break
case 64:g.push(H.bG(a.u,2,"@"))
break
case 126:g.push(H.bG(a.u,3,"~"))
break
case 60:g.push(a.p)
a.p=g.length
break
case 62:q=a.u
p=g.splice(a.p)
H.fn(a.u,a.e,p)
a.p=g.pop()
o=g.pop()
if(typeof o=="string")g.push(H.bF(q,o,p))
else{n=H.as(q,a.e,o)
switch(n.y){case 11:g.push(H.fp(q,n,p,a.n))
break
default:g.push(H.fo(q,n,p))
break}}break
case 38:H.iR(a,g)
break
case 42:m=a.u
g.push(H.hf(m,H.as(m,a.e,g.pop()),a.n))
break
case 63:m=a.u
g.push(H.fq(m,H.as(m,a.e,g.pop()),a.n))
break
case 47:m=a.u
g.push(H.he(m,H.as(m,a.e,g.pop()),a.n))
break
case 40:g.push(a.p)
a.p=g.length
break
case 41:q=a.u
l=new H.cy()
k=q.sEA
j=q.sEA
o=g.pop()
if(typeof o=="number")switch(o){case-1:k=g.pop()
break
case-2:j=g.pop()
break
default:g.push(o)
break}else g.push(o)
p=g.splice(a.p)
H.fn(a.u,a.e,p)
a.p=g.pop()
l.a=p
l.b=k
l.c=j
g.push(H.hd(q,H.as(q,a.e,g.pop()),l))
break
case 91:g.push(a.p)
a.p=g.length
break
case 93:p=g.splice(a.p)
H.fn(a.u,a.e,p)
a.p=g.pop()
g.push(p)
g.push(-1)
break
case 123:g.push(a.p)
a.p=g.length
break
case 125:p=g.splice(a.p)
H.iT(a.u,a.e,p)
a.p=g.pop()
g.push(p)
g.push(-2)
break
default:throw"Bad character "+r}}}i=g.pop()
return H.as(a.u,a.e,i)},
iQ:function(a,b,c,d){var t,s,r=b-48
for(t=c.length;a<t;++a){s=c.charCodeAt(a)
if(!(s>=48&&s<=57))break
r=r*10+(s-48)}d.push(r)
return a},
hb:function(a,b,c,d,e){var t,s,r,q,p,o,n=b+1
for(t=c.length;n<t;++n){s=c.charCodeAt(n)
if(s===46){if(e)break
e=!0}else{if(!((((s|32)>>>0)-97&65535)<26||s===95||s===36))r=s>=48&&s<=57
else r=!0
if(!r)break}}q=c.substring(b,n)
if(e){t=a.u
p=a.e
if(p.y===10)p=p.z
o=H.hg(t,p.z)[q]
if(o==null)H.L('No "'+q+'" in "'+H.iG(p)+'"')
d.push(H.cE(t,p,o))}else d.push(q)
return n},
iR:function(a,b){var t=b.pop()
if(0===t){b.push(H.bG(a.u,1,"0&"))
return}if(1===t){b.push(H.bG(a.u,4,"1&"))
return}throw H.a(P.cO("Unexpected extended operation "+H.i(t)))},
as:function(a,b,c){if(typeof c=="string")return H.bF(a,c,a.sEA)
else if(typeof c=="number")return H.iS(a,b,c)
else return c},
fn:function(a,b,c){var t,s=c.length
for(t=0;t<s;++t)c[t]=H.as(a,b,c[t])},
iT:function(a,b,c){var t,s=c.length
for(t=2;t<s;t+=3)c[t]=H.as(a,b,c[t])},
iS:function(a,b,c){var t,s,r=b.y
if(r===10){if(c===0)return b.z
t=b.Q
s=t.length
if(c<=s)return t[c-1]
c-=s
b=b.z
r=b.y}else if(c===0)return b
if(r!==9)throw H.a(P.cO("Indexed base must be an interface type"))
t=b.Q
if(c<=t.length)return t[c-1]
throw H.a(P.cO("Bad index "+c+" for "+b.l(0)))},
G:function(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k
if(b===d)return!0
if(!H.aj(d))if(!(d===u._))t=d===u.C
else t=!0
else t=!0
if(t)return!0
s=b.y
if(s===4)return!0
if(H.aj(b))return!1
if(b.y!==1)t=b===u.P||b===u.T
else t=!0
if(t)return!0
r=s===13
if(r)if(H.G(a,c[b.z],c,d,e))return!0
q=d.y
if(s===6)return H.G(a,b.z,c,d,e)
if(q===6){t=d.z
return H.G(a,b,c,t,e)}if(s===8){if(!H.G(a,b.z,c,d,e))return!1
return H.G(a,H.h1(a,b),c,d,e)}if(s===7){t=H.G(a,b.z,c,d,e)
return t}if(q===8){if(H.G(a,b,c,d.z,e))return!0
return H.G(a,b,c,H.h1(a,d),e)}if(q===7){t=H.G(a,b,c,d.z,e)
return t}if(r)return!1
t=s!==11
if((!t||s===12)&&d===u.Y)return!0
if(q===12){if(b===u.g)return!0
if(s!==12)return!1
p=b.Q
o=d.Q
n=p.length
if(n!==o.length)return!1
c=c==null?p:p.concat(c)
e=e==null?o:o.concat(e)
for(m=0;m<n;++m){l=p[m]
k=o[m]
if(!H.G(a,l,c,k,e)||!H.G(a,k,e,l,c))return!1}return H.hr(a,b.z,c,d.z,e)}if(q===11){if(b===u.g)return!0
if(t)return!1
return H.hr(a,b,c,d,e)}if(s===9){if(q!==9)return!1
return H.jl(a,b,c,d,e)}return!1},
hr:function(a1,a2,a3,a4,a5){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0
if(!H.G(a1,a2.z,a3,a4.z,a5))return!1
t=a2.Q
s=a4.Q
r=t.a
q=s.a
p=r.length
o=q.length
if(p>o)return!1
n=o-p
m=t.b
l=s.b
k=m.length
j=l.length
if(p+k<o+j)return!1
for(i=0;i<p;++i){h=r[i]
if(!H.G(a1,q[i],a5,h,a3))return!1}for(i=0;i<n;++i){h=m[i]
if(!H.G(a1,q[p+i],a5,h,a3))return!1}for(i=0;i<j;++i){h=m[n+i]
if(!H.G(a1,l[i],a5,h,a3))return!1}g=t.c
f=s.c
e=g.length
d=f.length
for(c=0,b=0;b<d;b+=3){a=f[b]
for(;!0;){if(c>=e)return!1
a0=g[c]
c+=3
if(a<a0)return!1
if(a0<a)continue
h=g[c-1]
if(!H.G(a1,f[b+2],a5,h,a3))return!1
break}}return!0},
jl:function(a,b,c,d,e){var t,s,r,q,p,o,n,m,l=b.z,k=d.z
if(l===k){t=b.Q
s=d.Q
r=t.length
for(q=0;q<r;++q){p=t[q]
o=s[q]
if(!H.G(a,p,c,o,e))return!1}return!0}if(d===u.C)return!0
n=H.hg(a,l)
if(n==null)return!1
m=n[k]
if(m==null)return!1
r=m.length
s=d.Q
for(q=0;q<r;++q)if(!H.G(a,H.cE(a,b,m[q]),c,s[q],e))return!1
return!0},
eR:function(a){var t,s=a.y
if(!(a===u.P||a===u.T))if(!H.aj(a))if(s!==7)if(!(s===6&&H.eR(a.z)))t=s===8&&H.eR(a.z)
else t=!0
else t=!0
else t=!0
else t=!0
return t},
k1:function(a){var t
if(!H.aj(a))if(!(a===u._))t=a===u.C
else t=!0
else t=!0
return t},
aj:function(a){var t=a.y
return t===2||t===3||t===4||t===5||a===u.O},
hh:function(a,b){var t,s,r=Object.keys(b),q=r.length
for(t=0;t<q;++t){s=r[t]
a[s]=b[s]}},
a0:function a0(a,b){var _=this
_.a=a
_.b=b
_.x=_.r=_.c=null
_.y=0
_.cy=_.cx=_.ch=_.Q=_.z=null},
cy:function cy(){this.c=this.b=this.a=null},
cC:function cC(a){this.a=a},
cw:function cw(){},
bE:function bE(a){this.a=a},
hD:function(a){return u.d.b(a)||u.E.b(a)||u.cF.b(a)||u.t.b(a)||u.a1.b(a)||u.cg.b(a)||u.bj.b(a)},
hO:function(a){return v.mangledGlobalNames[a]},
w:function(a){if(typeof dartPrint=="function"){dartPrint(a)
return}if(typeof console=="object"&&typeof console.log!="undefined"){console.log(a)
return}if(typeof window=="object")return
if(typeof print=="function"){print(a)
return}throw"Unable to print message: "+String(a)}},J={
fF:function(a,b,c,d){return{i:a,p:b,e:c,x:d}},
fC:function(a){var t,s,r,q,p=a[v.dispatchPropertyName]
if(p==null)if($.fD==null){H.jY()
p=a[v.dispatchPropertyName]}if(p!=null){t=p.p
if(!1===t)return p.i
if(!0===t)return a
s=Object.getPrototypeOf(a)
if(t===s)return p.i
if(p.e===s)throw H.a(P.h5("Return interceptor for "+H.i(t(a,p))))}r=a.constructor
q=r==null?null:r[J.fX()]
if(q!=null)return q
q=H.k4(a)
if(q!=null)return q
if(typeof a=="function")return C.E
t=Object.getPrototypeOf(a)
if(t==null)return C.q
if(t===Object.prototype)return C.q
if(typeof r=="function"){Object.defineProperty(r,J.fX(),{value:C.j,enumerable:false,writable:true,configurable:true})
return C.j}return C.j},
fX:function(){var t=$.h9
return t==null?$.h9=v.getIsolateTag("_$dart_js"):t},
fV:function(a,b){if(a<0||a>4294967295)throw H.a(P.dv(a,0,4294967295,"length",null))
return J.im(new Array(a),b)},
cS:function(a,b){if(a<0)throw H.a(P.b0("Length must be a non-negative integer: "+a))
return H.b(new Array(a),b.k("p<0>"))},
im:function(a,b){return J.fW(H.b(a,b.k("p<0>")))},
fW:function(a){a.fixed$length=Array
return a},
I:function(a){if(typeof a=="number"){if(Math.floor(a)==a)return J.bb.prototype
return J.ba.prototype}if(typeof a=="string")return J.az.prototype
if(a==null)return J.bc.prototype
if(typeof a=="boolean")return J.cT.prototype
if(a.constructor==Array)return J.p.prototype
if(typeof a!="object"){if(typeof a=="function")return J.al.prototype
return a}if(a instanceof P.u)return a
return J.fC(a)},
m:function(a){if(typeof a=="string")return J.az.prototype
if(a==null)return a
if(a.constructor==Array)return J.p.prototype
if(typeof a!="object"){if(typeof a=="function")return J.al.prototype
return a}if(a instanceof P.u)return a
return J.fC(a)},
R:function(a){if(a==null)return a
if(a.constructor==Array)return J.p.prototype
if(typeof a!="object"){if(typeof a=="function")return J.al.prototype
return a}if(a instanceof P.u)return a
return J.fC(a)},
hw:function(a){if(typeof a=="number")return J.aM.prototype
if(typeof a=="string")return J.az.prototype
if(a==null)return a
if(!(a instanceof P.u))return J.aF.prototype
return a},
jV:function(a){if(a==null)return a
if(!(a instanceof P.u))return J.aF.prototype
return a},
fK:function(a,b){if(typeof a=="number"&&typeof b=="number")return a+b
return J.hw(a).A(a,b)},
n:function(a,b){if(a==null)return b==null
if(typeof a!="object")return b!=null&&a===b
return J.I(a).q(a,b)},
cI:function(a,b){if(typeof b==="number")if(a.constructor==Array||typeof a=="string"||H.k0(a,a[v.dispatchPropertyName]))if(b>>>0===b&&b<a.length)return a[b]
return J.m(a).h(a,b)},
bO:function(a,b){return J.hw(a).J(a,b)},
fL:function(a,b){return J.R(a).L(a,b)},
av:function(a){return J.I(a).gv(a)},
M:function(a){return J.R(a).gw(a)},
E:function(a){return J.m(a).gi(a)},
i0:function(a){return J.jV(a).gbJ(a)},
i1:function(a){return J.R(a).gb4(a)},
fM:function(a,b){return J.R(a).V(a,b)},
cJ:function(a,b,c){return J.R(a).a2(a,b,c)},
i2:function(a,b){return J.I(a).aj(a,b)},
cK:function(a,b){return J.R(a).M(a,b)},
i3:function(a){return J.R(a).al(a)},
i4:function(a){return J.R(a).am(a)},
P:function(a){return J.I(a).l(a)},
i5:function(a,b){return J.R(a).ab(a,b)},
Z:function Z(){},
cT:function cT(){},
bc:function bc(){},
am:function am(){},
cf:function cf(){},
aF:function aF(){},
al:function al(){},
p:function p(a){this.$ti=a},
cV:function cV(a){this.$ti=a},
b1:function b1(a,b){var _=this
_.a=a
_.b=b
_.c=0
_.d=null},
aM:function aM(){},
bb:function bb(){},
ba:function ba(){},
az:function az(){}},P={
iL:function(){var t,s,r={}
if(self.scheduleImmediate!=null)return P.jK()
if(self.MutationObserver!=null&&self.document!=null){t=self.document.createElement("div")
s=self.document.createElement("span")
r.a=null
new self.MutationObserver(H.ec(new P.dz(r),1)).observe(t,{childList:true})
return new P.dy(r,t,s)}else if(self.setImmediate!=null)return P.jL()
return P.jM()},
iM:function(a){self.scheduleImmediate(H.ec(new P.dA(a),0))},
iN:function(a){self.setImmediate(H.ec(new P.dB(a),0))},
iO:function(a){P.fk(C.A,a)},
fk:function(a,b){var t=C.b.a0(a.a,1000)
return P.iU(t<0?0:t,b)},
iU:function(a,b){var t=new P.dK()
t.bi(a,b)
return t},
jt:function(){var t,s
for(t=$.aW;t!=null;t=$.aW){$.bK=null
s=t.b
$.aW=s
if(s==null)$.bJ=null
t.a.$0()}},
jD:function(){$.fx=!0
try{P.jt()}finally{$.bK=null
$.fx=!1
if($.aW!=null)$.fH().$1(P.hu())}},
jA:function(a){var t,s,r,q,p,o=$.aW
if(o==null){t=new P.cv(a)
s=$.bJ
if(s==null){$.aW=$.bJ=t
if(!$.fx)$.fH().$1(P.hu())}else $.bJ=s.b=t
$.bK=$.bJ
return}r=new P.cv(a)
q=$.bK
if(q==null){r.b=o
$.aW=$.bK=r}else{p=q.b
r.b=p
$.bK=q.b=r
if(p==null)$.bJ=r}},
iK:function(a,b){var t=$.cu
if(t===C.h)return P.fk(a,b)
return P.fk(a,t.bx(b))},
jx:function(a,b,c,d,e){P.jA(new P.dZ(d,e))},
jy:function(a,b,c,d){var t,s=$.cu
if(s===c)return d.$0()
$.cu=c
t=s
try{s=d.$0()
return s}finally{$.cu=t}},
dz:function dz(a){this.a=a},
dy:function dy(a,b,c){this.a=a
this.b=b
this.c=c},
dA:function dA(a){this.a=a},
dB:function dB(a){this.a=a},
dK:function dK(){},
dL:function dL(a,b){this.a=a
this.b=b},
cv:function cv(a){this.a=a
this.b=null},
dN:function dN(){},
dZ:function dZ(a,b){this.a=a
this.b=b},
dF:function dF(){},
dG:function dG(a,b){this.a=a
this.b=b},
h7:function(a,b){var t=a[b]
return t===a?null:t},
h8:function(a,b,c){if(c==null)a[b]=a
else a[b]=c},
iP:function(){var t=Object.create(null)
P.h8(t,"<non-identifier-key>",t)
delete t["<non-identifier-key>"]
return t},
ip:function(a,b){return new H.aa(a.k("@<0>").U(b).k("aa<1,2>"))},
cZ:function(a,b,c){return H.jS(a,new H.aa(b.k("@<0>").U(c).k("aa<1,2>")))},
fe:function(a){return new P.a2(a.k("a2<0>"))},
a5:function(a){return new P.a2(a.k("a2<0>"))},
T:function(a,b){return H.jT(a,new P.a2(b.k("a2<0>")))},
fm:function(){var t=Object.create(null)
t["<non-identifier-key>"]=t
delete t["<non-identifier-key>"]
return t},
fl:function(a,b){var t=new P.aH(a,b)
t.c=a.e
return t},
ik:function(a,b,c){var t,s
if(P.fy(a)){if(b==="("&&c===")")return"(...)"
return b+"..."+c}t=H.b([],u.s)
$.W.push(a)
try{P.jr(a,t)}finally{if(0>=$.W.length)return H.f($.W,-1)
$.W.pop()}s=P.h3(b,t,", ")+c
return s.charCodeAt(0)==0?s:s},
fb:function(a,b,c){var t,s
if(P.fy(a))return b+"..."+c
t=new P.bp(b)
$.W.push(a)
try{s=t
s.a=P.h3(s.a,a,", ")}finally{if(0>=$.W.length)return H.f($.W,-1)
$.W.pop()}t.a+=c
s=t.a
return s.charCodeAt(0)==0?s:s},
fy:function(a){var t,s
for(t=$.W.length,s=0;s<t;++s)if(a===$.W[s])return!0
return!1},
jr:function(a,b){var t,s,r,q,p,o,n,m=a.gw(a),l=0,k=0
while(!0){if(!(l<80||k<3))break
if(!m.n())return
t=H.i(m.gp())
b.push(t)
l+=t.length+2;++k}if(!m.n()){if(k<=5)return
if(0>=b.length)return H.f(b,-1)
s=b.pop()
if(0>=b.length)return H.f(b,-1)
r=b.pop()}else{q=m.gp();++k
if(!m.n()){if(k<=4){b.push(H.i(q))
return}s=H.i(q)
if(0>=b.length)return H.f(b,-1)
r=b.pop()
l+=s.length+2}else{p=m.gp();++k
for(;m.n();q=p,p=o){o=m.gp();++k
if(k>100){while(!0){if(!(l>75&&k>3))break
if(0>=b.length)return H.f(b,-1)
l-=b.pop().length+2;--k}b.push("...")
return}}r=H.i(q)
s=H.i(p)
l+=s.length+r.length+4}}if(k>b.length+2){l+=5
n="..."}else n=null
while(!0){if(!(l>80&&b.length>3))break
if(0>=b.length)return H.f(b,-1)
l-=b.pop().length+2
if(n==null){l+=5
n="..."}}if(n!=null)b.push(n)
b.push(r)
b.push(s)},
fY:function(a,b,c,d,e){var t=P.ip(d,e)
P.ir(t,a,b,c)
return t},
iq:function(a,b){var t,s,r=P.fe(b)
for(t=a.length,s=0;s<a.length;a.length===t||(0,H.K)(a),++s)r.G(0,b.a(a[s]))
return r},
d_:function(a,b){var t=P.fe(b)
t.H(0,a)
return t},
d1:function(a){var t,s={}
if(P.fy(a))return"{...}"
t=new P.bp("")
try{$.W.push(a)
t.a+="{"
s.a=!0
a.R(0,new P.d2(s,t))
t.a+="}"}finally{if(0>=$.W.length)return H.f($.W,-1)
$.W.pop()}s=t.a
return s.charCodeAt(0)==0?s:s},
ir:function(a,b,c,d){var t,s,r
for(t=b.length,s=0;s<b.length;b.length===t||(0,H.K)(b),++s){r=b[s]
a.m(0,c.$1(r),d.$1(r))}},
bt:function bt(){},
bv:function bv(a){var _=this
_.a=0
_.e=_.d=_.c=_.b=null
_.$ti=a},
bu:function bu(a,b){this.a=a
this.$ti=b},
cz:function cz(a,b){var _=this
_.a=a
_.b=b
_.c=0
_.d=null},
a2:function a2(a){var _=this
_.a=0
_.f=_.e=_.d=_.c=_.b=null
_.r=0
_.$ti=a},
dD:function dD(a){this.a=a
this.b=null},
aH:function aH(a,b){var _=this
_.a=a
_.b=b
_.d=_.c=null},
q:function q(){},
bf:function bf(){},
d2:function d2(a,b){this.a=a
this.b=b},
bg:function bg(){},
cF:function cF(){},
bh:function bh(){},
br:function br(){},
bD:function bD(){},
bH:function bH(){},
ij:function(a){if(a instanceof H.ax)return a.l(0)
return"Instance of '"+H.i(H.du(a))+"'"},
d0:function(a,b,c,d){var t,s=c?J.cS(a,d):J.fV(a,d)
if(a!==0&&b!=null)for(t=0;t<s.length;++t)s[t]=b
return s},
r:function(a,b,c){var t,s=H.b([],c.k("p<0>"))
for(t=J.M(a);t.n();)s.push(t.gp())
return s},
ff:function(a,b,c){var t,s,r=J.cS(a,c)
for(t=0;t<a;++t){s=b.$1(t)
if(t>=r.length)return H.f(r,t)
r[t]=s}return r},
h3:function(a,b,c){var t=J.M(b)
if(!t.n())return a
if(c.length===0){do a+=H.i(t.gp())
while(t.n())}else{a+=H.i(t.gp())
for(;t.n();)a=a+c+H.i(t.gp())}return a},
fZ:function(a,b,c,d){return new P.cc(a,b,c,d)},
ih:function(a){var t=Math.abs(a),s=a<0?"-":""
if(t>=1000)return""+a
if(t>=100)return s+"0"+t
if(t>=10)return s+"00"+t
return s+"000"+t},
ii:function(a){if(a>=100)return""+a
if(a>=10)return"0"+a
return"00"+a},
bU:function(a){if(a>=10)return""+a
return"0"+a},
aL:function(a){if(typeof a=="number"||H.fw(a)||null==a)return J.P(a)
if(typeof a=="string")return JSON.stringify(a)
return P.ij(a)},
cO:function(a){return new P.bR(a)},
b0:function(a){return new P.a7(!1,null,null,a)},
i6:function(a,b,c){return new P.a7(!0,a,b,c)},
i7:function(a,b){return!1},
fh:function(a,b){return new P.bl(null,null,!0,a,b,"Value not in range")},
dv:function(a,b,c,d,e){return new P.bl(b,c,!0,a,d,"Invalid value")},
fi:function(a,b){if(a<0)throw H.a(P.dv(a,0,null,b,null))
return a},
fa:function(a,b,c,d,e){var t=e==null?J.E(b):e
return new P.bZ(t,!0,a,c,"Index out of range")},
J:function(a){return new P.cs(a)},
h5:function(a){return new P.cq(a)},
iJ:function(a){return new P.aR(a)},
N:function(a){return new P.bS(a)},
fT:function(a){return new P.dC(a)},
z:function(a){H.w(J.P(a))},
d4:function d4(a,b){this.a=a
this.b=b},
b5:function b5(a,b){this.a=a
this.b=b},
aK:function aK(a){this.a=a},
cQ:function cQ(){},
cR:function cR(){},
y:function y(){},
bR:function bR(a){this.a=a},
cp:function cp(){},
ce:function ce(){},
a7:function a7(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
bl:function bl(a,b,c,d,e,f){var _=this
_.e=a
_.f=b
_.a=c
_.b=d
_.c=e
_.d=f},
bZ:function bZ(a,b,c,d,e){var _=this
_.f=a
_.a=b
_.b=c
_.c=d
_.d=e},
cc:function cc(a,b,c,d){var _=this
_.a=a
_.b=b
_.c=c
_.d=d},
cs:function cs(a){this.a=a},
cq:function cq(a){this.a=a},
aR:function aR(a){this.a=a},
bS:function bS(a){this.a=a},
bn:function bn(){},
bT:function bT(a){this.a=a},
dC:function dC(a){this.a=a},
h:function h(){},
c0:function c0(){},
bk:function bk(){},
u:function u(){},
bp:function bp(a){this.a=a},
bd:function bd(){},
j8:function(a,b,c,d){var t,s,r
if(b){t=[c]
C.a.H(t,d)
d=t}s=u.z
r=P.r(J.cJ(d,P.k2(),s),!0,s)
return P.dP(H.iy(a,r,null))},
cW:function(a){if(!u.f.b(a)&&!0)throw H.a(P.b0("object must be a Map or Iterable"))
return P.fA(P.io(a))},
io:function(a){return new P.cX(new P.bv(u.aR)).$1(a)},
j9:function(a){return a},
fr:function(a,b,c){var t
try{if(Object.isExtensible(a)&&!Object.prototype.hasOwnProperty.call(a,b)){Object.defineProperty(a,b,{value:c})
return!0}}catch(t){H.f7(t)}return!1},
hp:function(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]
return null},
dP:function(a){if(a==null||typeof a=="string"||typeof a=="number"||H.fw(a))return a
if(a instanceof P.O)return a.a
if(H.hD(a))return a
if(u.Q.b(a))return a
if(a instanceof P.b5)return H.aD(a)
if(u.Y.b(a))return P.ho(a,"$dart_jsFunction",new P.dQ())
return P.ho(a,"_$dart_jsObject",new P.dR($.fJ()))},
ho:function(a,b,c){var t=P.hp(a,b)
if(t==null){t=c.$1(a)
P.fr(a,b,t)}return t},
hk:function(a){var t,s
if(a==null||typeof a=="string"||typeof a=="number"||typeof a=="boolean")return a
else if(a instanceof Object&&H.hD(a))return a
else if(a instanceof Object&&u.Q.b(a))return a
else if(a instanceof Date){t=a.getTime()
if(Math.abs(t)<=864e13)s=!1
else s=!0
if(s)H.L(P.b0("DateTime is outside valid range: "+H.i(t)))
P.i7(!1,"isUtc")
return new P.b5(t,!1)}else if(a.constructor===$.fJ())return a.o
else return P.fA(a)},
fA:function(a){if(typeof a=="function")return P.fu(a,$.f8(),new P.e_())
if(a instanceof Array)return P.fu(a,$.fI(),new P.e0())
return P.fu(a,$.fI(),new P.e1())},
fu:function(a,b,c){var t=P.hp(a,b)
if(t==null||!(a instanceof Object)){t=c.$1(a)
P.fr(a,b,t)}return t},
cX:function cX(a){this.a=a},
dQ:function dQ(){},
dR:function dR(a){this.a=a},
e_:function e_(){},
e0:function e0(){},
e1:function e1(){},
O:function O(a){this.a=a},
c1:function c1(a){this.a=a},
an:function an(a,b){this.a=a
this.$ti=b},
bx:function bx(){},
hI:function(a,b){return Math.min(H.eb(a),H.eb(b))}},W={e:function e(){},bP:function bP(){},bQ:function bQ(){},aw:function aw(){},a4:function a4(){},cP:function cP(){},d:function d(){},c:function c(){},bW:function bW(){},bY:function bY(){},b8:function b8(){},C:function C(){},ch:function ch(){},aT:function aT(){},af:function af(){}},V={
X:function(a){return new V.c5(a)},
c5:function c5(a){this.a=a},
k9:function(a6,a7,a8){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4,a5=J.E(a6.a)
if(a5<3)return H.b([],u.K)
a5=a7.a
if(a5!=null)t=a5==1/0||a5==-1/0||isNaN(a5)||C.c.ga7(a5)
else t=!0
if(t)throw H.a(V.X(2000))
t=a7.b
if(t!=null)s=t==1/0||t==-1/0||isNaN(t)||C.c.ga7(t)
else s=!0
if(s)throw H.a(V.X(1440))
if(a6.O())throw H.a(V.X(1201))
a6=a6.a8()
if(J.E(a6.a)<3)return H.b([],u.K)
s=a6.aW(a5,!0)
r=s==null?null:s.D()
if(r==null)throw H.a(V.X(700))
if(r.O())throw H.a(V.X(700))
q=r.W()
if(q.a.length===0)return S.kb(a6,a7,a8,null)
p=H.b([],u.b)
for(s=r.a,o=J.m(s),n=0;n<o.gi(s);n=l){m=o.h(s,n)
l=n+1
k=o.h(s,C.b.j(l,o.gi(s)))
if(r.ae(n))continue
j=m.K(k)
i=j<1.5707963267948966?j+4.71238898038469:j-1.5707963267948966
if(q.ag(i))p.push(Q.bN(r,i,m,k,t))
h=n-1
g=o.h(s,C.b.j(h,o.gi(s)))
f=m.K(g)
if(r.ae(C.b.j(h,o.gi(s))))continue
e=f>=4.71238898038469?f-4.71238898038469:f+1.5707963267948966
if(q.ag(e))p.push(Q.bN(r,e,m,g,t))}if(p.length===0){d=q.gaE(q)
for(h=P.fl(d,d.r);h.n();){c=h.d
b=o.h(s,r.aS(c)[0]).E(c,t)
if(typeof c!=="number")return c.A()
a=r.ah(new R.ab(b.E(C.c.j(c+1.5707963267948966,6.283185307179586),10),b.E(C.c.j(c-1.5707963267948966,6.283185307179586),10)))
a0=a.length
if(a0!==2)continue
if(0>=a0)return H.f(a,0)
a1=a[0]
if(1>=a0)return H.f(a,1)
a2=Q.bN(r,c,a1,a[1],t)
c=a2.b.length
if(c===0)continue
p.push(a2)}}if(p.length===0)throw H.a(V.X(4242))
t=u.c
s=u.M
a3=K.iu(P.r(new H.l(p,new V.eZ(new L.aC(a6,H.b([a6],t),H.b([a6.X(a5)],t)),a7),s),!0,s.k("t.E")))
if(a3<0||a3>=p.length)return H.f(p,a3)
a4=p[a3]
C.a.aB(p,a3)
C.a.aV(p,0,a4)
return a4.b},
eZ:function eZ(a,b){this.a=a
this.b=b},
hE:function(){$.i_().m(0,"planRoute",V.k7())},
ka:function(a,b){var t,s,r,q,p,o,n,m=null,l="startingPoint",k=!0,j=null,i=null
try{r=a==null?m:new H.l(a,new V.f_(),a.$ti.k("l<q.E,aN*>"))
r=r==null?m:P.r(r,!0,r.$ti.k("t.E"))
if(b!=null){q=b.h(0,"insetDistance")
p=b.h(0,"lineWidth")
if("startingPoint" in b.a&&b.h(0,l)!=null){o=u.V
o=X.fg(H.hj(o.a(b.h(0,l)).h(0,"latitude")),H.hj(o.a(b.h(0,l)).h(0,"longitude")))}else o=m
o=new X.d3(q,p,o)
q=o}else q=m
t=X.k8(r,q)
k=!0
q=t
r=H.a3(q).k("l<1,U<bo*,@>*>")
p=r.k("l<t.E,O*>")
o=[]
C.a.H(o,new H.l(new H.l(new H.l(q,new V.f0(),r),new V.f1(),p),P.k3(),p.k("l<t.E,@>")))
j=new P.an(o,u.A)}catch(n){r=H.f7(n)
if(r instanceof V.c5){s=r
k=!1
i=P.cW(P.cZ(["code",s.a,"message",J.i0(s)],u.X,u.z))}else{k=!1
i=P.cW(P.cZ(["code",-1,"message","Unknown error."],u.X,u.z))}}return P.cW(P.cZ(["success",k,"plannedPath",j,"thrownException",i],u.X,u.z))},
f_:function f_(){},
f0:function f0(){},
f1:function f1(){}},X={
fg:function(a,b){var t
if(typeof a!=="number")return a.F()
if(a<-90)t=-90
else if(90<a)t=90
else t=a
if(typeof b!=="number")return b.A()
return new X.aN(t,C.c.j(b+180,360)-180)},
k8:function(a,b){var t,s,r,q
if(a==null||a.length===0)throw H.a(V.X(9))
if(b==null)throw H.a(V.X(1399))
if(J.n((a&&C.a).gC(a),C.a.gI(a))){t=P.r(a,!0,u.I)
C.a.aC(t)}else t=a
if(t.length<3)throw H.a(V.X(150))
s=C.a.gI(t)
r=H.F(t).k("l<1,x*>")
q=new A.v(P.r(new H.l(t,new X.f4(s),r),!0,r.k("t.E")))
if(q.O())throw H.a(V.X(1201))
r=q.P()
if(typeof r!=="number")return r.B()
if(r>5e8)throw H.a(V.X(2201))
r=b.c
r=J.cJ(V.k9(q,b,r==null?null:L.fR(r,s)),new X.f5(s),u.I)
return P.r(r,!0,r.$ti.k("t.E"))},
aN:function aN(a,b){this.a=a
this.b=b},
d3:function d3(a,b,c){this.a=a
this.b=b
this.c=c},
f4:function f4(a){this.a=a},
f5:function f5(a){this.a=a}},B={
ag:function(a,b){var t
if(typeof a!=="number")return a.j()
t=C.c.j(a,6.283185307179586)
if(typeof b!=="number")return b.j()
return new B.ar(t,C.c.j(b,6.283185307179586),!1)},
b_:function b_(){this.a=null},
cM:function cM(a){this.a=a},
cL:function cL(a){this.a=a},
cN:function cN(){},
ar:function ar(a,b,c){this.a=a
this.b=b
this.c=c}},L={
fR:function(a,b){var t=a.a,s=b.a,r=Math.cos(t*0.017453292519943295)
return new L.x((C.c.j(a.b-b.b+180,360)-180)*r/360*40030173.59204114,(t-s)/360*40030173.59204114)},
hJ:function(a){return J.cK(a,new L.eX()).a},
hG:function(a){return J.cK(a,new L.eT()).a},
hK:function(a){return J.cK(a,new L.eY()).b},
hH:function(a){return J.cK(a,new L.eU()).b},
x:function x(a,b){this.a=a
this.b=b},
eX:function eX(){},
eT:function eT(){},
eY:function eY(){},
eU:function eU(){},
iv:function(a,b){var t,s
if(a.W().a.length!==0){t=u.c
return H.b([new L.aC(a,H.b([a],t),H.b([a.X(b.a)],t))],u.w)}t=u.L
s=t.k("l<t.E,aC*>")
return P.r(new H.l(new H.l(H.b([0,0.5235987755982988,0.7853981633974483,1.0471975511965976,1.5707963267948966,2.0943951023931953,2.356194490192345,2.6179938779914944],u.m),new L.d8(a,b),t),new L.d9(b,a),s),!0,s.k("t.E"))},
jN:function(a2,a3,a4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1
if(typeof a3!=="number")return a3.j()
t=C.c.j(a3,3.141592653589793)
s=a2.X(a4)
r=s==null?null:s.W()
s=r==null?null:r.a.length!==0
if(s===!0){P.z("boustrophedonPartition: Partitioning not necessary.")
return P.T([a2],u.j)}s=a2.a
q=J.m(s)
p=a2.ak(-t,q.h(s,0))
o=P.a5(u.c7)
for(n=p.a,m=J.m(n),l=0;l<m.gi(n);++l){k=a2.D().a
j=!a2.aY()?q.gi(s)-1-l:l
i=J.m(k)
if(A.cG(i.h(k,j),i.h(k,C.b.j(j-1,i.gi(k))),i.h(k,C.b.j(j+1,i.gi(k))))>3.141592653589793){h=m.h(n,C.b.j(l-1,m.gi(n)))
g=m.h(n,C.b.j(l+1,m.gi(n)))
i=m.h(n,l).a
f=h.a
if(typeof i!=="number")return i.B()
if(typeof f!=="number")return H.j(f)
e=i>f
if(e){d=g.a
if(typeof d!=="number")return H.j(d)
d=i>d}else d=!1
if(d)o.G(0,i)
f=i<f
if(f){d=g.a
if(typeof d!=="number")return H.j(d)
d=i<d}else d=!1
if(d)o.G(0,i)
if(e&&i===g.a)o.G(0,i)
if(f&&i===g.a)o.G(0,i)}}c=P.r(o,!0,o.$ti.c)
C.a.N(c,new L.e4())
b=H.b([P.T([p],u.j)],u.D)
for(l=0;l<c.length;++l){s=C.a.gC(b)
a=new H.S(s,new L.e5(c,l,!1),H.Y(s).k("S<1,ay*>")).M(0,new L.e6())
if(0>=b.length)return H.f(b,-1)
b.pop()
s=a.a
b.push(s)
b.push(a.b)
for(q=new P.aH(s,s.r),q.c=s.e;q.n();){s=q.d
if(s.W().a.length===0){H.w("Warning: Non-sweepable piece found in cutting board.")
H.w("Polygon begin:")
for(s=J.M(s.a);s.n();)H.w("  "+H.i(s.gp()))
s="Cut of index "+l+" at x="
if(l>=c.length)return H.f(c,l)
H.w(s+H.i(c[l]))
H.w("Polygon(s) being cut:")
for(s=C.a.gC(b),n=new P.aH(s,s.r),n.c=s.e;n.n();){s=n.d
H.w("Begin polygon:")
for(s=J.M(s.a);s.n();)H.w("  "+H.i(s.gp()))}}}}a0=J.i4(C.a.M(b,new L.e7()))
s=H.Y(a0).k("S<1,v*>")
s=L.k6(P.d_(new H.S(a0,new L.e8(t,a2),s),s.k("h.E")),a4)
a1=P.iq(s,H.F(s).c)
return a1},
jC:function(a,b){var t,s,r,q,p,o,n
for(t=J.M(a.a),s=b.a,r=J.R(s),q=0;t.n();){p=t.gp()
for(o=r.gw(s),n=J.I(p);o.n();)if(n.q(p,o.gp())){++q
if(q>=2)return!0}}return!1},
hi:function(a,b){var t,s,r,q,p=H.b([],u.K)
for(t=b.a,s=J.m(t),r=0;r<s.gi(t);){q=s.h(t,r)
p.push(q);++r
C.a.H(p,L.jc(new R.ac(q,s.h(t,C.b.j(r,s.gi(t)))),a))}return new A.v(p)},
jc:function(a,b){var t,s,r,q,p,o,n,m,l=H.b([],u.K)
for(t=b.a,s=J.m(t),r=a.a,q=a.b,p=J.I(q),o=J.I(r),n=0;n<s.gi(t);++n){m=s.h(t,n)
if(o.q(r,m))continue
if(p.q(q,m))continue
if(Math.abs(r.t(m)+q.t(m)-r.t(q))<1e-10)l.push(m)}return l},
k6:function(a,b){var t,s,r,q,p,o,n,m,l,k,j,i,h=P.r(a,!0,H.Y(a).c)
C.a.N(h,new L.eV())
$label0$0:for(t=u.c,s=0;!0;){++s
if(s>1e6)break $label0$0
r=H.b([],t)
for(q=h.length,p=0;p<h.length;h.length===q||(0,H.K)(h),++p)r.push(h[p])
q=r.length
p=0
for(;p<r.length;r.length===q||(0,H.K)(r),++p){o=r[p]
n=H.b([],t)
for(m=h.length,l=0;l<h.length;h.length===m||(0,H.K)(h),++l)n.push(h[l])
C.a.a9(n,o)
for(m=n.length,l=0;l<n.length;n.length===m||(0,H.K)(n),++l){k=n[l]
if(o.O()||k.O())continue
j=L.kd(o.az(1e-8),k.az(1e-8),!1)
if(j==null)continue
i=j.X(b)
i=i==null?null:i.W()
i=i==null?null:i.a.length!==0
if(i===!0){C.a.a9(h,o)
C.a.a9(h,k)
C.a.G(h,j)
r=new L.eW()
if(!!h.immutable$list)H.L(P.J("sort"))
q=h.length-1
if(q-0<=32)H.cl(h,0,q,r)
else H.ck(h,0,q,r)
continue $label0$0}continue}continue}break $label0$0}return h},
kd:function(a,b,c){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e=null,d={}
if(a.aX(b))return e
if(a.b8(b))return a
t=a.D()
s=d.a=b.D()
r=H.b([],u.K)
q=L.hi(s,t)
p=L.hi(t,s)
d.a=p
if(!L.jC(q,p))return e
o=q.a
n=J.R(o)
m=n.S(o,new L.f6(d))
if(m===-1)return d.a
for(l=e,k=0;!0;k=j){j=k+1
if(k>1e7){H.w("recomposeTouchingPolygons executed a loop 10 million times.\nThis is very likely to be an infinite loop. Aborting.")
H.w("Polygons that caused the infinite loop:")
H.w("First:")
for(i=n.gw(o);i.n();)H.w(J.P(i.gp()))
H.w("Second:")
for(o=J.M(d.a.a);o.n();)H.w(J.P(o.gp()))
return e}if(m!=null){h=n.h(o,m)
if(r.length!==0&&J.n(h,C.a.gI(r)))break
r.push(h)
g=J.fM(d.a.a,h)
if(g!==-1){l=C.b.j(g+1,J.E(d.a.a))
m=e
continue}else{m=C.b.j(m+1,n.gi(o))
continue}}else{h=J.cI(d.a.a,l)
if(J.n(h,C.a.gI(r)))break
r.push(h)
f=n.V(o,h)
if(f!==-1){m=C.b.j(f+1,n.gi(o))
l=e
continue}else{if(typeof l!=="number")return l.A()
l=C.b.j(l+1,J.E(d.a.a))
continue}}}return new A.v(r).a8()},
jQ:function(b1,b2,b3){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4=u.j,a5=P.a5(a4),a6=P.a5(a4),a7=b1.D().a8().a,a8=H.b([],u.r),a9=u.K,b0=H.b([],a9)
for(t=J.m(a7),s=0;s<t.gi(a7);++s){b0.push(t.h(a7,s))
r=L.jk(b1.D(),s,b2)
r.toString
C.a.H(a8,new H.l(r,new L.ed(b0),H.F(r).k("l<1,at*>")))
q=L.jj(b1.D(),s,b2)
p=q.length
if(p===1){b0.push(C.a.gan(q))
p=C.a.gan(q)
a8.push(new L.at(b0.length-1,p))}else if(p===2){p=C.a.gI(q)
a8.push(new L.at(b0.length-1,p))
p=C.a.gC(q)
a8.push(new L.at(b0.length,p))}}for(t=a8.length,o=0;p=a8.length,o<p;a8.length===t||(0,H.K)(a8),++o){n=a8[o]
if(n.a>=b0.length){H.w("Wrapping polygon index! Please debug.")
n.a=0}}if(p<=1){for(a9=b1.a,t=J.m(a9),m=C.d,l=0;m===C.d;){m=R.a6(new L.x(b2,0),new L.x(b2,1),t.h(a9,l))
l=C.b.j(l+1,t.gi(a9))}if(m===C.f)return new L.ay(P.a5(a4),P.T([b1],a4))
else return new L.ay(P.T([b1],a4),P.a5(a4))}C.a.N(a8,new L.ee())
a4=u.z
t=u.c5
k=P.fY(P.ff(a8.length,new L.ef(),a4),new L.el(),new L.em(),a4,t)
for(s=0;p=a8.length,s<p;++s){if(k.h(0,s))continue
k.m(0,s,!0)
if(s>=a8.length)return H.f(a8,s)
n=a8[s]
j=H.b([],a9)
i=C.a.V(b0,n.b)
for(h=0;!0;){if(i<0||i>=b0.length)return H.f(b0,i)
g=b0[i]
if(j.length!==0&&J.n(g,C.a.gI(j))){a5.G(0,new A.v(j))
break}j.push(g)
f=h===-1?C.a.b0(a8,new L.en(g)):C.a.S(a8,new L.eo(g))
p=f!==-1&&J.n(k.h(0,f),!1)
e=i+1
d=b0.length
if(p){c=b0[C.b.j(i-1,d)]
b=b0[C.b.j(e,d)]
p=c.a
if(typeof p!=="number")return p.F()
if(typeof b2!=="number")return H.j(b2)
if(p<b2){p=b.a
if(typeof p!=="number")return p.F()
p=p<b2}else p=!1
if(p){p=f+1
d=a8.length
if(p<d){if(f<0||f>=d)return H.f(a8,f)
a=a8[f].b
if(p<0)return H.f(a8,p)
a=J.n(a,a8[p].b)
d=a}else d=!1
if(d){k.m(0,f,!0)
k.m(0,p,!0)
h=0
continue}else{if(f>0){if(f>=a8.length)return H.f(a8,f)
p=J.n(a8[f].b,a8[f-1].b)}else p=!1
if(p){p=f-2
if(p<0||p>=a8.length)return H.f(a8,p)
i=a8[p].a
k.m(0,f-1,!0)
k.m(0,f,!0)
h=-1
continue}else H.w("Cut by vertical line: Unknown case (right side) please debug.")}}p=C.b.j(f,2)===0
if(p){d=f+1
if(k.h(0,d)){if(d<0||d>=a8.length)return H.f(a8,d)
a0=a8[d].a
d=b0.length
if(d>1){if(a0<0||a0>=d)return H.f(b0,a0)
d=!J.n(b0[a0],b0[0])}else d=!1
if(d){k.m(0,f,!0)
i=C.b.j(e,b0.length)
h=0
continue}}}e=a8.length
if(p){p=f+1
if(p<0||p>=e)return H.f(a8,p)
a0=a8[p].a
k.m(0,f,!0)
i=a0
h=1}else{p=f-1
if(p<0||p>=e)return H.f(a8,p)
a0=a8[p].a
k.m(0,f,!0)
i=a0
h=-1}}else{i=C.b.j(e,d)
h=0}}}a1=P.fY(P.ff(p,new L.ep(),a4),new L.eq(),new L.er(),a4,t)
for(s=a8.length-1;s>=0;--s){if(a1.h(0,s))continue
a1.m(0,s,!0)
if(s>=a8.length)return H.f(a8,s)
n=a8[s]
j=H.b([],a9)
i=C.a.V(b0,n.b)
for(h=0;!0;){if(i<0||i>=b0.length)return H.f(b0,i)
g=b0[i]
if(j.length!==0&&J.n(g,C.a.gI(j))){a6.G(0,new A.v(j))
break}j.push(g)
f=h===1?C.a.S(a8,new L.es(g)):C.a.b0(a8,new L.eg(g))
a4=f!==-1&&J.n(a1.h(0,f),!1)
t=i+1
p=b0.length
if(a4){c=b0[C.b.j(i-1,p)]
b=b0[C.b.j(t,p)]
a4=c.a
if(typeof a4!=="number")return a4.B()
if(typeof b2!=="number")return H.j(b2)
if(a4>b2){a4=b.a
if(typeof a4!=="number")return a4.B()
a4=a4>b2}else a4=!1
if(a4){if(f>0){if(f>=a8.length)return H.f(a8,f)
a4=J.n(a8[f].b,a8[f-1].b)}else a4=!1
if(a4){a1.m(0,f,!0)
a1.m(0,f-1,!0)
h=0
continue}else{a4=f+1
p=a8.length
if(a4<p){if(f<0||f>=p)return H.f(a8,f)
e=a8[f].b
if(a4<0)return H.f(a8,a4)
e=J.n(e,a8[a4].b)
p=e}else p=!1
if(p){a1.m(0,f,!0)
a1.m(0,a4,!0)
a4=f+2
if(a4<0||a4>=a8.length)return H.f(a8,a4)
i=a8[a4].a
h=1
continue}else H.w("Cut by vertical line: Unknown case (left side) please debug.")}}a4=C.b.j(f,2)
if(a4===1){p=f-1
if(a1.h(0,p)){if(p<0||p>=a8.length)return H.f(a8,p)
a0=a8[p].a
p=b0.length
if(p>1){if(a0<0||a0>=p)return H.f(b0,a0)
p=!J.n(b0[a0],b0[0])}else p=!1
if(p){a1.m(0,f,!0)
i=C.b.j(t,b0.length)
h=0
continue}}}t=a8.length
if(a4===0){a4=f+1
if(a4<0||a4>=t)return H.f(a8,a4)
a0=a8[a4].a
a1.m(0,f,!0)
i=a0
h=1}else{a4=f-1
if(a4<0||a4>=t)return H.f(a8,a4)
a0=a8[a4].a
a1.m(0,f,!0)
i=a0
h=-1}}else{i=C.b.j(t,p)
h=0}}}a4=a5.$ti
a9=a4.k("B<1,v*>")
a2=P.d_(new H.B(new H.D(a5,new L.eh(),a4.k("D<1>")),new L.ei(),a9),a9.k("h.E"))
a9=a6.$ti
a4=a9.k("B<1,v*>")
a3=P.d_(new H.B(new H.D(a6,new L.ej(),a9.k("D<1>")),new L.ek(),a4),a4.k("h.E"))
return new L.ay(a3,a2)},
jj:function(a,b,c){var t,s=a.a,r=J.m(s),q=r.h(s,b),p=r.h(s,C.b.j(b+1,r.gi(s))),o=r.h(s,C.b.j(b-1,r.gi(s))),n=r.h(s,C.b.j(b+2,r.gi(s)))
if(J.n(q,p)){P.z("0-length edge found while cutting a polygon.")
for(s=r.gw(s);s.n();)H.w(J.P(s.gp()))
return H.b([],u.K)}s=q.a
r=s==c
if(r&&p.a==c){s=o.a
if(typeof s!=="number")return s.F()
if(typeof c!=="number")return H.j(c)
r=s<c
if(r){t=n.a
if(typeof t!=="number")return H.j(t)
t=c<t}else t=!1
if(!t)if(s>c){t=n.a
if(typeof t!=="number")return H.j(t)
t=c>t}else t=!1
else t=!0
if(t)return H.b([new L.x(c,(q.b+p.b)/2)],u.K)
if(r){r=n.a
if(typeof r!=="number")return H.j(r)
r=c>r}else r=!1
if(!r)if(s>c){s=n.a
if(typeof s!=="number")return H.j(s)
s=c<s}else s=!1
else s=!0
if(s)return H.b([q,p],u.K)
throw H.a(P.fT("Polygon contains redundant vertices."))}if(r||p.a==c)return H.b([],u.K)
if(typeof s!=="number")return s.F()
if(typeof c!=="number")return H.j(c)
if(s<c){r=p.a
if(typeof r!=="number")return r.F()
r=r<c}else r=!1
if(!r)if(s>c){s=p.a
if(typeof s!=="number")return s.B()
s=s>c}else s=!1
else s=!0
if(s)return H.b([],u.K)
return H.b([R.hm(new L.x(c,0),new L.x(c,1),q,p)],u.K)},
jk:function(a,b,c){var t,s,r,q,p=a.a,o=J.m(p),n=o.h(p,b)
if(n.a!=c)return H.b([],u.K)
t=o.h(p,C.b.j(b+1,o.gi(p)))
s=o.h(p,C.b.j(b-1,o.gi(p)))
p=t.a
if(p==c||s.a==c)return H.b([],u.K)
o=s.a
if(typeof o!=="number")return o.F()
if(typeof c!=="number")return H.j(c)
r=o<c
if(r){if(typeof p!=="number")return H.j(p)
q=c<p}else q=!1
if(!q)if(o>c){if(typeof p!=="number")return H.j(p)
q=c>p}else q=!1
else q=!0
if(q)return H.b([n],u.K)
if(r){if(typeof p!=="number")return p.F()
r=p<c}else r=!1
if(!r)if(o>c){if(typeof p!=="number")return p.B()
p=p>c}else p=!1
else p=!0
if(p)return H.b([n,n],u.K)},
aC:function aC(a,b,c){this.a=a
this.b=b
this.c=c},
d8:function d8(a,b){this.a=a
this.b=b},
d9:function d9(a,b){this.a=a
this.b=b},
d6:function d6(a){this.a=a},
d7:function d7(){},
e4:function e4(){},
e5:function e5(a,b,c){this.a=a
this.b=b
this.c=c},
e6:function e6(){},
e7:function e7(){},
e8:function e8(a,b){this.a=a
this.b=b},
eV:function eV(){},
eW:function eW(){},
f6:function f6(a){this.a=a},
at:function at(a,b){this.a=a
this.b=b},
ay:function ay(a,b){this.a=a
this.b=b},
ed:function ed(a){this.a=a},
ee:function ee(){},
ef:function ef(){},
el:function el(){},
em:function em(){},
en:function en(a){this.a=a},
eo:function eo(a){this.a=a},
ep:function ep(){},
eq:function eq(){},
er:function er(){},
es:function es(a){this.a=a},
eg:function eg(a){this.a=a},
eh:function eh(){},
ei:function ei(){},
ej:function ej(){},
ek:function ek(){}},A={
jw:function(a,b){var t=a.a,s=t.a,r=a.b,q=r.a,p=s==q
if(p&&t.b<r.b)C.a.N(b,new A.dV())
else if(p&&t.b>r.b)C.a.N(b,new A.dW())
else{if(typeof s!=="number")return s.F()
if(typeof q!=="number")return H.j(q)
if(s<q)C.a.N(b,new A.dX())
else if(s>q)C.a.N(b,new A.dY())
else{P.z("Warning: trying to reorder points along invalid line.")
P.z("Segment is from "+t.l(0)+" to "+r.l(0))
return}}},
jb:function(a,b,c,d,a0){var t,s,r,q,p,o,n,m,l=A.hs(a,b),k=A.hs(b,c),j=new R.ab(a,b).b5(0,l,d),i=new R.ab(b,c).b5(0,k,d),h=j.a,g=j.b,f=i.a,e=i.b
if(a0<3.141592653589793){t=R.dS(h,g,f,e)
h=u.K
if(t==null)return H.b([],h)
else return H.b([t],h)}else{s=C.c.j(A.fE(b.K(a),b.K(c))+3.141592653589793,6.283185307179586)
r=b.E(s,d)
if(typeof d!=="number")return d.Z()
q=d*2
p=r.E(s+4.71238898038469,q)
o=b.E(s,d).E(s+1.5707963267948966,q)
n=R.dS(p,o,h,g)
m=R.dS(p,o,f,e)
h=n==null||m==null
g=u.K
if(h)return H.b([],g)
else return H.b([n,m],g)}},
fE:function(a,b){var t,s,r,q,p,o
if(a>6.283185307179586||b>6.283185307179586)return A.fE(C.c.j(a,6.283185307179586),C.c.j(b,6.283185307179586))
t=C.i.j((a+b)/2,6.283185307179586)
s=C.i.j(t+3.141592653589793,6.283185307179586)
r=u.m
q=u.z
p=C.a.M(H.b([Math.abs(a-t),Math.abs(t-a),Math.abs(b-t),Math.abs(t-b)],r),H.hB(P.hF(),q))
o=C.a.M(H.b([Math.abs(a-s),Math.abs(s-a),Math.abs(b-s),Math.abs(s-b)],r),H.hB(P.hF(),q))
if(typeof o!=="number")return o.F()
if(typeof p!=="number")return H.j(p)
if(o<p)return s
else return t},
hs:function(a,b){var t=b.a,s=a.a
if(typeof t!=="number")return t.u()
if(typeof s!=="number")return H.j(s)
return C.c.j(Math.atan2(b.b-a.b,t-s)+4.71238898038469,6.283185307179586)},
cG:function(a,b,c){var t,s=b.b,r=a.b,q=b.a,p=a.a
if(typeof q!=="number")return q.u()
if(typeof p!=="number")return H.j(p)
t=Math.atan2(s-r,q-p)
q=c.b
s=c.a
if(typeof s!=="number")return s.u()
return C.c.j(Math.atan2(q-r,s-p)+6.283185307179586-t,6.283185307179586)},
jR:function(a7){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3,a4=H.b([],u.k),a5=u.K,a6=H.b([],a5)
for(t=0;t<a7.length;++t)a6.push(a7[t])
for(s=0,t=0;r=a7.length,t<r;t=p){q=a7[t]
p=t+1
r=a7[p%r]
o=new R.ac(q,r)
n=H.b([],a5)
for(m=J.I(r),l=J.I(q),k=0;j=a7.length,k<j;){i=a7[k];++k
j=a7[k%j]
if(o.q(0,new R.ac(i,j)))continue
if(l.q(q,j))continue
if(m.q(r,i))continue
h=R.ft(q,r,i,j)
if(h!=null)n.push(h)}r=n.length
if(r===0)continue
q=new A.et(a7,t)
if(!!n.immutable$list)H.L(P.J("sort"));--r
if(r-0<=32)H.cl(n,0,r,q)
else H.ck(n,0,r,q)
for(g=0;g<n.length;++g){C.a.aV(a6,t+s+1,n[g]);++s}}for(r=u.R,q=u.i,f=0;a6.length!==0;){e=H.b([],a5)
d=H.b([],q)
for(c=0;!0;f=a1){b={}
a=P.r(a6,!0,r)
if(c<0||c>=a.length)return H.f(a,c)
a[c]=null
if(c>=a6.length)return H.f(a6,c)
b.a=a6[c]
a0=C.a.S(a,new A.eu(b))
if(a0!==-1){if(a0<0||a0>=a6.length)return H.f(a6,a0)
b.a=a6[a0]
c=a0}if(e.length!==0&&J.n(b.a,C.a.gI(e)))break
e.push(b.a)
d.push(c)
c=C.b.j(c+1,a6.length)
a1=f+1
if(f>1e7){H.w("discardIntersectingFolds executed a loop 10 million times.\nThis is very likely to be an infinite loop. Aborting.")
H.w("Polygon that caused the infinite loop:")
for(a5=a7.length,a2=0;a2<a7.length;a7.length===a5||(0,H.K)(a7),++a2)H.w(J.P(a7[a2]))
return null}}for(m=d.length,l=a6.length,a2=0;a2<m;++a2){a3=d[a2]
if(a3<0||a3>=l)return H.f(a6,a3)
a6[a3]=null}if(!!a6.fixed$length)H.L(P.J("removeWhere"))
C.a.aN(a6,new A.ev(),!0)
a4.push(e)}return new H.l(a4,new A.ew(),u.bx).M(0,new A.ex()).a},
fz:function(a,a0){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b
a0=new A.v(a0).D().a
for(t=J.m(a0),s=0;s<t.gi(a0);++s)if(J.n(t.h(a0,s),a)){r=t.h(a0,C.b.j(s-1,t.gi(a0)))
q=t.h(a0,C.b.j(s+1,t.gi(a0)))
return a.E(A.fE(t.h(a0,s).K(r),t.h(a0,s).K(q)),1e-7)}for(s=0;s<t.gi(a0);s=o){p=t.h(a0,s)
o=s+1
n=t.h(a0,C.b.j(o,t.gi(a0)))
m=a.a
l=p.a
if(typeof m!=="number")return m.u()
if(typeof l!=="number")return H.j(l)
k=a.b
j=p.b
p=n.a
if(typeof p!=="number")return p.u()
i=p-l
h=n.b
g=h-j
f=i*i+g*g
e=f!==0?((m-l)*i+(k-j)*g)/f:-1
if(e<0)d=l
else if(e>1){j=h
d=p}else{d=l+e*i
j+=e*g}c=m-d
b=k-j
if(Math.sqrt(c*c+b*b)<1e-9)return a.E(t.h(a0,s).K(t.h(a0,C.b.j(o,t.gi(a0))))+4.71238898038469,1e-7)}return a},
aZ:function(a){var t,s,r
for(t=0,s=0;s<a.length-1;s=r){r=s+1
t+=a[s].t(a[r])}return t},
v:function v(a){var _=this
_.a=a
_.y=_.x=_.r=_.e=_.c=_.b=null},
dr:function dr(a,b){this.a=a
this.b=b},
dn:function dn(a){this.a=a},
dd:function dd(a){this.a=a},
de:function de(a){this.a=a},
df:function df(){},
dg:function dg(a){this.a=a},
dh:function dh(){},
di:function di(a,b){this.a=a
this.b=b},
dj:function dj(a){this.a=a},
dk:function dk(a){this.a=a},
dl:function dl(){},
dm:function dm(){},
da:function da(a){this.a=a},
db:function db(a){this.a=a},
dc:function dc(a){this.a=a},
ds:function ds(a,b){this.a=a
this.b=b},
dp:function dp(){},
dq:function dq(){},
dV:function dV(){},
dW:function dW(){},
dX:function dX(){},
dY:function dY(){},
aq:function aq(a,b){this.a=a
this.b=b},
aU:function aU(){var _=this
_.d=_.c=_.b=_.a=null},
et:function et(a,b){this.a=a
this.b=b},
eu:function eu(a){this.a=a},
ev:function ev(){},
ew:function ew(){},
ex:function ex(){},
cA:function cA(a,b){this.a=a
this.b=b}},R={
j5:function(a){var t,s,r,q,p,o,n=new R.dH(H.b([],u.J)),m=H.b([],u.cM)
for(t=P.fl(a,a.r);t.n();){s=t.d
r=s.c
m.push(r==null?s.c=new R.bC(s,C.k):r)
r=s.d
m.push(r==null?s.d=new R.bC(s,C.r):r)}C.a.N(m,new R.dO())
for(t=n.b;m.length!==0;){q=C.a.aB(m,0)
switch(q.b){case C.k:s=q.a
n.bu(s)
p=n.aT(s)
if(p!=null&&p.ay(s))return!0
o=n.aU(s)
if(o!=null&&o.ay(s))return!0
break
case C.r:n.bL(q)
s=q.a
p=n.aT(s)
o=n.aU(s)
if(p!=null&&o!=null&&p.ay(o))return!0
C.a.a9(t,s)
break}}return!1},
dS:function(a,b,c,d){var t,s,r,q,p,o,n=a.b,m=b.b,l=n-m,k=b.a,j=a.a
if(typeof k!=="number")return k.u()
if(typeof j!=="number")return H.j(j)
t=k-j
s=-(j*m-k*n)
n=c.b
k=d.b
r=n-k
m=d.a
j=c.a
if(typeof m!=="number")return m.u()
if(typeof j!=="number")return H.j(j)
q=m-j
p=-(j*k-m*n)
o=l*q-r*t
if(o===0)return null
return new L.x((q*s-t*p)/o,(l*p-r*s)/o)},
jB:function(a,b,c,d){var t,s,r,q,p=J.I(a)
if(!p.q(a,c))if(!p.q(a,d)){p=J.I(b)
p=p.q(b,c)||p.q(b,d)}else p=!0
else p=!0
if(p)return!1
t=R.a6(a,b,c)
s=R.a6(a,b,d)
r=R.a6(c,d,a)
q=R.a6(c,d,b)
if(t!==s&&r!==q)return!0
if(t===C.d&&R.bL(c,a,b))return!0
if(s===C.d&&R.bL(d,a,b))return!0
if(r===C.d&&R.bL(a,c,d))return!0
if(q===C.d&&R.bL(b,c,d))return!0
return!1},
ft:function(a,b,c,d){var t,s,r,q,p,o,n,m,l,k,j=J.I(a)
if(j.q(a,c)||j.q(a,d))return a
t=J.I(b)
if(t.q(b,c)||t.q(b,d))return b
if(j.q(a,b)||J.n(c,d))return null
j=b.b
t=a.b
j-=t
s=b.a
r=a.a
if(typeof s!=="number")return s.u()
if(typeof r!=="number")return H.j(r)
s-=r
q=d.b
p=c.b
q-=p
o=d.a
n=c.a
if(typeof o!=="number")return o.u()
if(typeof n!=="number")return H.j(n)
o-=n
if(j/s===q/o)return null
n=r-n
p=t-p
m=-o*j+s*q
l=(-j*n+s*p)/m
k=(o*p-q*n)/m
if(l>=0&&l<=1&&k>=0&&k<=1)return new L.x(r+k*s,t+k*j)
return null},
hm:function(a,b,c,d){var t=R.dS(a,b,c,d)
if(t==null)return null
if(Math.abs(c.t(t)+t.t(d)-c.t(d))<1e-10)return t
else return null},
bL:function(a,b,c){var t,s,r
if(b.J(0,c)>0)return R.bL(a,c,b)
t=a.a
s=c.a
if(typeof t!=="number")return t.b7()
if(typeof s!=="number")return H.j(s)
if(t<=s){s=b.a
if(typeof s!=="number")return H.j(s)
if(t>=s){t=a.b
s=b.b
r=c.b
t=t<=Math.max(s,r)&&t>=Math.min(s,r)}else t=!1}else t=!1
return t},
a6:function(a,b,c){var t,s,r,q=b.b,p=a.b,o=c.a,n=b.a
if(typeof o!=="number")return o.u()
if(typeof n!=="number")return H.j(n)
t=c.b
s=a.a
if(typeof s!=="number")return H.j(s)
r=(q-p)*(o-n)-(t-q)*(n-s)
if(r===0)return C.d
return r>0?C.f:C.G},
jJ:function(a){var t=H.Y(a).k("S<1,bw*>")
return R.j5(P.d_(new H.S(a,new R.e2(),t),t.k("h.E")))},
bw:function bw(a,b){var _=this
_.a=a
_.b=b
_.e=_.d=_.c=null},
cx:function cx(a){this.b=a},
bC:function bC(a,b){this.a=a
this.b=b},
dH:function dH(a){this.b=a},
dI:function dI(a,b){this.a=a
this.b=b},
dJ:function dJ(a,b){this.a=a
this.b=b},
dO:function dO(){},
ac:function ac(a,b){this.a=a
this.b=b},
ab:function ab(a,b){this.a=a
this.b=b},
bm:function bm(a){this.b=a},
e2:function e2(){}},S={
kb:function(a,b,c,d){var t,s=L.iv(a,b),r=H.F(s).k("l<1,aP*>"),q=P.r(new H.l(s,new S.f2(b,c),r),!0,r.k("t.E"))
if(q.length===0||C.a.aR(q,new S.f3()))throw H.a(V.X(3110))
t=K.it(q,1)
if(t==null)throw H.a(V.X(3110))
return t.a},
jU:function(a7,a8,a9){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3=null,a4={},a5=a7.b,a6=a5.length
if(a6===0){P.z("Warning: Decomposition found without any elements at all!")
return a3}if(a6===1){P.z("Warning: Decomposition found with only one element!")
P.z("Original polygon:")
for(a6=J.M(a7.a.a);a6.n();)H.w(J.P(a6.gp()))
if(C.a.gan(a5).W().a.length===0)P.z("Warning: Single partition is not sweepable. Cannot continue.")
return a3}t=H.b([],u.c)
a5=a7.c
a6=H.F(a5)
s=a6.k("D<1>")
r=a6.k("B<1,A<ad*>*>")
q=P.r(new H.B(new H.D(a5,new S.ez(t),s),new S.eA(a8),r),!0,r.k("h.E"))
r=u.m
p=H.b([],r)
for(o=new H.l(t,new S.eB(a7),u.bo),o=new H.ao(o,o.gi(o));o.n();){n=o.d
p.push(n)}p.push(0)
p=C.a.M(p,new S.eE())
if(typeof p!=="number")return H.j(p)
m=Math.pow(1+p,5.5)
a6=a6.k("B<1,x*>")
l=P.r(new H.B(new H.D(a5,new S.eF(),s),new S.eG(),a6),!0,a6.k("h.E"))
a6=a7.a
s=a8.a
if(typeof s!=="number")return s.Z()
k=a6.X(s*0.95)
j=H.b([],u.v)
for(i=0;i<l.length;++i){j.push(H.b([],r))
for(h=0;a5=l.length,h<a5;++h){if(i===h)g=0
else{if(i>=a5)return H.f(l,i)
g=A.aZ(k.a3(l[i],l[h]))}if(i>=j.length)return H.f(j,i)
j[i].push(g)}}a5=a4.a=!1
P.iK(C.B,new S.eH(a4))
f=H.b([],u.i)
for(e=1/0,i=0;a6=l.length,i<S.fs(a6);++i){if(C.b.j(i,5000)===0?a4.a:a5)break
d=S.js(S.hq(i,a6))
c=S.jG(a9,j,l,d)
if(c<e){e=c
f=d}}P.z("Indices: "+H.i(f))
a5=H.F(f)
a6=a5.k("l<1,x*>")
b=P.r(new H.l(f,new S.eI(l),a6),!0,a6.k("t.E"))
a5=a5.k("l<1,A<ad*>*>")
a=P.r(new H.l(f,new S.eJ(q),a5),!0,a5.k("t.E"))
a0=H.b([],u.b)
for(i=0;i<f.length;++i){if(i===0)a1=a3
else{a5=i-1
if(a5<0||a5>=a0.length)return H.f(a0,a5)
a1=a0[a5]}a2=i>=b.length-1?a3:b[i+1]
if(i>=a.length)return H.f(a,i)
a0.push(S.jv(a[i],a1,a2,a9,k))}if(a0.length===0||C.a.aR(a0,new S.eK())){P.z("Resulting decomposed path is empty. Cannot continue.")
return a3}return new K.aP(new H.B(new H.D(a0,new S.eL(),u.bG),new S.eC(),u.ak).M(0,new S.eD(k)),a7,m)},
ja:function(a,b,c){var t,s,r=J.R(a),q=J.R(b),p=c.a3(r.gC(a),q.gI(b)),o=H.b([],u.K)
for(r=r.gw(a);r.n();)o.push(r.gp())
for(r=H.fj(p,1,null,H.F(p).c).al(0),C.a.aC(r),t=r.length,s=0;s<r.length;r.length===t||(0,H.K)(r),++s)o.push(r[s])
for(r=q.gw(b);r.n();)o.push(r.gp())
return o},
jG:function(a,b,c,d){var t,s,r,q,p,o,n
for(t=d.length-1,s=b.length,r=0,q=0;q<t;){p=d[q];++q
o=d[q]
if(p>>>0!==p||p>=s)return H.f(b,p)
n=b[p]
if(o>>>0!==o||o>=n.length)return H.f(n,o)
r+=n[o]}if(a!=null){t=C.a.gI(d)
if(t>>>0!==t||t>=c.length)return H.f(c,t)
t=a.t(c[t])
s=C.a.gC(d)
if(s>>>0!==s||s>=c.length)return H.f(c,s)
r=r+t+a.t(c[s])}return r},
js:function(a){var t=H.F(a).k("l<1,k*>")
return P.r(new H.l(a,new S.dT(P.ff(a.length,new S.dU(),u.e)),t),!0,t.k("t.E"))},
hq:function(a,b){var t,s,r,q,p,o=u.i
if(b<=1)return H.b([0],o)
else{t=b-1
s=S.fs(t)
r=C.i.bB(a/s)
o=H.b([],o)
o.push(r)
for(t=S.hq(C.b.j(a,s),t),q=t.length,p=0;p<t.length;t.length===q||(0,H.K)(t),++p)o.push(t[p])
return o}},
fs:function(a){if(a<=0)return 1
else return a*S.fs(a-1)},
jv:function(a,b,c,d,e){var t,s,r,q,p,o,n,m,l,k,j=null
for(t=J.M(a),s=d!=null,r=c!=null,q=b!=null,p=j,o=1/0;t.n();){n=t.gp()
if(q){m=b.b
m=m.length!==0?C.a.gC(m):j
l=n.b
k=0+A.aZ(e.a3(m,l.length!==0?C.a.gI(l):j))}else if(s){m=n.b
k=0+d.t(m.length!==0?C.a.gI(m):j)}else k=0
if(r){m=n.b
k+=A.aZ(e.a3(c,m.length!==0?C.a.gC(m):j))}else if(s){m=n.b
k+=d.t(m.length!==0?C.a.gC(m):j)}if(k<o){p=n
o=k}}return p},
f2:function f2(a,b){this.a=a
this.b=b},
f3:function f3(){},
ez:function ez(a){this.a=a},
eA:function eA(a){this.a=a},
eB:function eB(a){this.a=a},
eE:function eE(){},
eF:function eF(){},
eG:function eG(){},
eH:function eH(a){this.a=a},
eI:function eI(a){this.a=a},
eJ:function eJ(a){this.a=a},
eK:function eK(){},
eL:function eL(){},
eC:function eC(){},
eD:function eD(a){this.a=a},
dU:function dU(){},
dT:function dT(a){this.a=a}},K={
it:function(a,b){var t,s,r,q,p,o
for(t=a.length,s=1/0,r=null,q=0;q<a.length;a.length===t||(0,H.K)(a),++q){p=a[q]
o=p==null?null:p.aQ(b)
if(o==null)o=1/0
H.w("Score: "+H.i(o))
if(o<s){r=p
s=o}}t=H.b(a.slice(0),H.F(a))
P.z("Chose index="+C.a.V(t,r))
return r},
iu:function(a){var t,s,r,q
for(t=1/0,s=-1,r=0;r<a.length;++r){q=a[r].aQ(0)
if(q<t){s=r
t=q}}return s},
aP:function aP(a,b,c){this.a=a
this.e=b
this.f=c}},Q={
jO:function(a3,a4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2
if(a3.W().a.length===0){P.z("buildCandidates called with a non-sweepable polygon. Returning [].")
return H.b([],u.b)}t=a3.D()
if(t.O())return H.b([],u.b)
s=t.W()
if(s.a.length===0)return H.b([],u.b)
r=H.b([],u.b)
for(q=t.a,p=J.m(q),o=a4.b,n=0;n<p.gi(q);n=l){m=p.h(q,n)
l=n+1
k=p.h(q,C.b.j(l,p.gi(q)))
if(t.ae(n))continue
j=m.K(k)
i=j<1.5707963267948966?j+4.71238898038469:j-1.5707963267948966
if(s.ag(i))r.push(Q.bN(t,i,m,k,o))
h=n-1
g=p.h(q,C.b.j(h,p.gi(q)))
f=m.K(g)
if(t.ae(C.b.j(h,p.gi(q))))continue
e=f>=4.71238898038469?f-4.71238898038469:f+1.5707963267948966
if(s.ag(e))r.push(Q.bN(t,e,m,g,o))}if(r.length===0){d=s.gaE(s)
for(h=P.fl(d,d.r);h.n();){c=h.d
b=p.h(q,t.aS(c)[0]).E(c,o)
if(typeof c!=="number")return c.A()
a=t.ah(new R.ab(b.E(C.c.j(c+1.5707963267948966,6.283185307179586),10),b.E(C.c.j(c-1.5707963267948966,6.283185307179586),10)))
a0=a.length
if(a0!==2)continue
if(0>=a0)return H.f(a,0)
a1=a[0]
if(1>=a0)return H.f(a,1)
a2=Q.bN(t,c,a1,a[1],o)
c=a2.b.length
if(c===0)continue
r.push(a2)}}return r},
bN:function(a,b,c,d,e){var t,s,r,q,p,o,n,m,l=H.b([new Q.aG(c,d)],u.cp)
$label0$0:for(;!0;){t=C.a.gC(l)
s=a.ah(new R.ab(t.a.E(b,e),t.b.E(b,e)))
if(s.length===0){for(t=[0.95,0.9,0.85,0.8,0.75],r=0;r<5;++r){q=t[r]
p=C.a.gC(l)
if(typeof e!=="number")return e.Z()
o=e*q
n=a.ah(new R.ab(p.a.E(b,o),p.b.E(b,o)))
if(n.length!==0){l.push(new Q.aG(C.a.gC(n),C.a.gI(n)))
break $label0$0}}break $label0$0}l.push(new Q.aG(C.a.gC(s),C.a.gI(s)))
continue $label0$0}if(a.aZ()){t=u.x
m=P.r(new H.b6(l,new Q.e9(),t),!0,t.k("h.E"))}else m=J.i3(C.a.bD(l,H.b([],u.K),new Q.ea(a)))
t=m.length
if(t>2&&J.n(m[t-1],m[t-2]))C.a.aC(m)
A.aZ(m)
return new Q.ad(m)},
ad:function ad(a){this.b=a},
e9:function e9(){},
ea:function ea(a){this.a=a},
aG:function aG(a,b){this.a=a
this.b=b}}
var w=[C,H,J,P,W,V,X,B,L,A,R,S,K,Q]
hunkHelpers.setFunctionNamesIfNecessary(w)
var $={}
H.fc.prototype={}
J.Z.prototype={
q:function(a,b){return a===b},
gv:function(a){return H.aQ(a)},
l:function(a){return"Instance of '"+H.i(H.du(a))+"'"},
aj:function(a,b){throw H.a(P.fZ(a,b.gb1(),b.gb3(),b.gb2()))}}
J.cT.prototype={
l:function(a){return String(a)},
gv:function(a){return a?519018:218159}}
J.bc.prototype={
q:function(a,b){return null==b},
l:function(a){return"null"},
gv:function(a){return 0},
aj:function(a,b){return this.ba(a,b)}}
J.am.prototype={
gv:function(a){return 0},
l:function(a){return String(a)}}
J.cf.prototype={}
J.aF.prototype={}
J.al.prototype={
l:function(a){var t=a[$.f8()]
if(t==null)return this.bd(a)
return"JavaScript function for "+H.i(J.P(t))},
$iak:1}
J.p.prototype={
G:function(a,b){if(!!a.fixed$length)H.L(P.J("add"))
a.push(b)},
aB:function(a,b){if(!!a.fixed$length)H.L(P.J("removeAt"))
if(!H.aV(b))throw H.a(H.cH(b))
if(b<0||b>=a.length)throw H.a(P.fh(b,null))
return a.splice(b,1)[0]},
aV:function(a,b,c){var t
if(!!a.fixed$length)H.L(P.J("insert"))
t=a.length
if(b>t)throw H.a(P.fh(b,null))
a.splice(b,0,c)},
aC:function(a){if(!!a.fixed$length)H.L(P.J("removeLast"))
if(a.length===0)throw H.a(H.aY(a,-1))
return a.pop()},
a9:function(a,b){var t
if(!!a.fixed$length)H.L(P.J("remove"))
for(t=0;t<a.length;++t)if(J.n(a[t],b)){a.splice(t,1)
return!0}return!1},
aN:function(a,b,c){var t,s,r,q=[],p=a.length
for(t=0;t<p;++t){s=a[t]
if(!b.$1(s))q.push(s)
if(a.length!==p)throw H.a(P.N(a))}r=q.length
if(r===p)return
this.si(a,r)
for(t=0;t<q.length;++t)a[t]=q[t]},
ab:function(a,b){return new H.D(a,b,H.F(a).k("D<1>"))},
H:function(a,b){var t
if(!!a.fixed$length)H.L(P.J("addAll"))
for(t=J.M(b);t.n();)a.push(t.gp())},
R:function(a,b){var t,s=a.length
for(t=0;t<s;++t){b.$1(a[t])
if(a.length!==s)throw H.a(P.N(a))}},
a2:function(a,b,c){return new H.l(a,b,H.F(a).k("@<1>").U(c).k("l<1,2>"))},
bH:function(a,b){var t,s,r=P.d0(a.length,"",!1,u.N)
for(t=0;t<a.length;++t){s=H.i(a[t])
if(t>=r.length)return H.f(r,t)
r[t]=s}return r.join(b)},
M:function(a,b){var t,s,r=a.length
if(r===0)throw H.a(H.a9())
if(0>=r)return H.f(a,0)
t=a[0]
for(s=1;s<r;++s){t=b.$2(t,a[s])
if(r!==a.length)throw H.a(P.N(a))}return t},
bC:function(a,b,c){var t,s,r=a.length
for(t=b,s=0;s<r;++s){t=c.$2(t,a[s])
if(a.length!==r)throw H.a(P.N(a))}return t},
bD:function(a,b,c){return this.bC(a,b,c,u.z)},
L:function(a,b){if(b<0||b>=a.length)return H.f(a,b)
return a[b]},
gI:function(a){if(a.length>0)return a[0]
throw H.a(H.a9())},
gC:function(a){var t=a.length
if(t>0)return a[t-1]
throw H.a(H.a9())},
gan:function(a){var t=a.length
if(t===1){if(0>=t)return H.f(a,0)
return a[0]}if(t===0)throw H.a(H.a9())
throw H.a(H.il())},
bv:function(a,b){var t,s=a.length
for(t=0;t<s;++t){if(b.$1(a[t]))return!0
if(a.length!==s)throw H.a(P.N(a))}return!1},
aR:function(a,b){var t,s=a.length
for(t=0;t<s;++t){if(!b.$1(a[t]))return!1
if(a.length!==s)throw H.a(P.N(a))}return!0},
gb4:function(a){return new H.aE(a,H.F(a).k("aE<1>"))},
N:function(a,b){if(!!a.immutable$list)H.L(P.J("sort"))
H.iI(a,b)},
V:function(a,b){var t,s=a.length
if(0>=s)return-1
for(t=0;t<s;++t){if(t>=a.length)return H.f(a,t)
if(J.n(a[t],b))return t}return-1},
ga1:function(a){return a.length===0},
l:function(a){return P.fb(a,"[","]")},
aa:function(a,b){var t=H.b(a.slice(0),H.F(a))
return t},
al:function(a){return this.aa(a,!0)},
gw:function(a){return new J.b1(a,a.length)},
gv:function(a){return H.aQ(a)},
gi:function(a){return a.length},
si:function(a,b){if(!!a.fixed$length)H.L(P.J("set length"))
a.length=b},
h:function(a,b){if(!H.aV(b))throw H.a(H.aY(a,b))
if(b>=a.length||b<0)throw H.a(H.aY(a,b))
return a[b]},
m:function(a,b,c){if(!!a.immutable$list)H.L(P.J("indexed set"))
if(!H.aV(b))throw H.a(H.aY(a,b))
if(b>=a.length||b<0)throw H.a(H.aY(a,b))
a[b]=c},
S:function(a,b){var t
if(0>=a.length)return-1
for(t=0;t<a.length;++t)if(b.$1(a[t]))return t
return-1},
b0:function(a,b){var t,s=a.length-1
if(s<0)return-1
for(t=s;t>=0;--t){if(t>=a.length)return H.f(a,t)
if(b.$1(a[t]))return t}return-1},
$io:1,
$ih:1,
$iA:1}
J.cV.prototype={}
J.b1.prototype={
gp:function(){return this.d},
n:function(){var t,s=this,r=s.a,q=r.length
if(s.b!==q)throw H.a(H.K(r))
t=s.c
if(t>=q){s.d=null
return!1}s.d=r[t]
s.c=t+1
return!0}}
J.aM.prototype={
J:function(a,b){var t
if(typeof b!="number")throw H.a(H.cH(b))
if(a<b)return-1
else if(a>b)return 1
else if(a===b){if(a===0){t=this.ga7(b)
if(this.ga7(a)===t)return 0
if(this.ga7(a))return-1
return 1}return 0}else if(isNaN(a)){if(isNaN(b))return 0
return 1}else return-1},
ga7:function(a){return a===0?1/a<0:a<0},
bB:function(a){var t,s
if(a>=0){if(a<=2147483647)return a|0}else if(a>=-2147483648){t=a|0
return a===t?t:t-1}s=Math.floor(a)
if(isFinite(s))return s
throw H.a(P.J(""+a+".floor()"))},
l:function(a){if(a===0&&1/a<0)return"-0.0"
else return""+a},
gv:function(a){var t,s,r,q,p=a|0
if(a===p)return 536870911&p
t=Math.abs(a)
s=Math.log(t)/0.6931471805599453|0
r=Math.pow(2,s)
q=t<1?t/r:r/t
return 536870911&((q*9007199254740992|0)+(q*3542243181176521|0))*599197+s*1259},
j:function(a,b){var t=a%b
if(t===0)return 0
if(t>0)return t
if(b<0)return t-b
else return t+b},
a0:function(a,b){return(a|0)===a?a/b|0:this.bt(a,b)},
bt:function(a,b){var t=a/b
if(t>=-2147483648&&t<=2147483647)return t|0
if(t>0){if(t!==1/0)return Math.floor(t)}else if(t>-1/0)return Math.ceil(t)
throw H.a(P.J("Result of truncating division is "+H.i(t)+": "+H.i(a)+" ~/ "+b))},
aP:function(a,b){var t
if(a>0)t=this.br(a,b)
else{t=b>31?31:b
t=a>>t>>>0}return t},
br:function(a,b){return b>31?0:a>>>b},
$iH:1}
J.bb.prototype={$ik:1}
J.ba.prototype={}
J.az.prototype={
A:function(a,b){if(typeof b!="string")throw H.a(P.i6(b,null,null))
return a+b},
l:function(a){return a},
gv:function(a){var t,s,r
for(t=a.length,s=0,r=0;r<t;++r){s=536870911&s+a.charCodeAt(r)
s=536870911&s+((524287&s)<<10)
s^=s>>6}s=536870911&s+((67108863&s)<<3)
s^=s>>11
return 536870911&s+((16383&s)<<15)},
gi:function(a){return a.length},
$ibo:1}
H.o.prototype={}
H.t.prototype={
gw:function(a){return new H.ao(this,this.gi(this))},
a2:function(a,b,c){return new H.l(this,b,H.Y(this).k("@<t.E>").U(c).k("l<1,2>"))},
M:function(a,b){var t,s,r=this,q=r.gi(r)
if(q===0)throw H.a(H.a9())
t=r.L(0,0)
for(s=1;s<q;++s){t=b.$2(t,r.L(0,s))
if(q!==r.gi(r))throw H.a(P.N(r))}return t},
am:function(a){var t,s=this,r=P.fe(H.Y(s).k("t.E"))
for(t=0;t<s.gi(s);++t)r.G(0,s.L(0,t))
return r}}
H.bq.prototype={
gbo:function(){var t=J.E(this.a),s=this.c
if(s==null||s>t)return t
return s},
gbs:function(){var t=J.E(this.a),s=this.b
if(s>t)return t
return s},
gi:function(a){var t,s=J.E(this.a),r=this.b
if(r>=s)return 0
t=this.c
if(t==null||t>=s)return s-r
if(typeof t!=="number")return t.u()
return t-r},
L:function(a,b){var t=this,s=t.gbs()+b
if(b<0||s>=t.gbo())throw H.a(P.fa(b,t,"index",null,null))
return J.fL(t.a,s)},
aa:function(a,b){var t,s,r,q,p=this,o=p.b,n=p.a,m=J.m(n),l=m.gi(n),k=p.c
if(k!=null&&k<l)l=k
if(typeof l!=="number")return l.u()
t=l-o
if(t<=0){n=p.$ti.c
return b?J.cS(0,n):J.fV(0,n)}s=P.d0(t,m.L(n,o),b,p.$ti.c)
for(r=1;r<t;++r){q=m.L(n,o+r)
if(r>=s.length)return H.f(s,r)
s[r]=q
if(m.gi(n)<l)throw H.a(P.N(p))}return s},
al:function(a){return this.aa(a,!0)}}
H.ao.prototype={
gp:function(){var t=this.d
return t},
n:function(){var t,s=this,r=s.a,q=J.m(r),p=q.gi(r)
if(s.b!==p)throw H.a(P.N(r))
t=s.c
if(t>=p){s.d=null
return!1}s.d=q.L(r,t);++s.c
return!0}}
H.B.prototype={
gw:function(a){return new H.c4(J.M(this.a),this.b)},
gi:function(a){return J.E(this.a)}}
H.S.prototype={$io:1}
H.c4.prototype={
n:function(){var t=this,s=t.b
if(s.n()){t.a=t.c.$1(s.gp())
return!0}t.a=null
return!1},
gp:function(){var t=this.a
return t}}
H.l.prototype={
gi:function(a){return J.E(this.a)},
L:function(a,b){return this.b.$1(J.fL(this.a,b))}}
H.D.prototype={
gw:function(a){return new H.ct(J.M(this.a),this.b)},
a2:function(a,b,c){return new H.B(this,b,this.$ti.k("@<1>").U(c).k("B<1,2>"))}}
H.ct.prototype={
n:function(){var t,s
for(t=this.a,s=this.b;t.n();)if(s.$1(t.gp()))return!0
return!1},
gp:function(){return this.a.gp()}}
H.b6.prototype={
gw:function(a){return new H.bX(J.M(this.a),this.b,C.t)}}
H.bX.prototype={
gp:function(){var t=this.d
return t},
n:function(){var t,s,r=this,q=r.c
if(q==null)return!1
for(t=r.a,s=r.b;!q.n();){r.d=null
if(t.n()){r.c=null
q=J.M(s.$1(t.gp()))
r.c=q}else return!1}r.d=r.c.gp()
return!0}}
H.bV.prototype={
n:function(){return!1},
gp:function(){throw H.a(H.a9())}}
H.b7.prototype={}
H.aE.prototype={
gi:function(a){return J.E(this.a)},
L:function(a,b){var t=this.a,s=J.m(t)
return s.L(t,s.gi(t)-1-b)}}
H.aS.prototype={
gv:function(a){var t=this._hashCode
if(t!=null)return t
t=536870911&664597*J.av(this.a)
this._hashCode=t
return t},
l:function(a){return'Symbol("'+H.i(this.a)+'")'},
q:function(a,b){if(b==null)return!1
return b instanceof H.aS&&this.a==b.a},
$icn:1}
H.b3.prototype={}
H.b2.prototype={
l:function(a){return P.d1(this)},
$iU:1}
H.b4.prototype={
gi:function(a){return this.a},
a6:function(a){if(typeof a!="string")return!1
if("__proto__"===a)return!1
return this.b.hasOwnProperty(a)},
h:function(a,b){if(!this.a6(b))return null
return this.aL(b)},
aL:function(a){return this.b[a]},
R:function(a,b){var t,s,r,q=this.c
for(t=q.length,s=0;s<t;++s){r=q[s]
b.$2(r,this.aL(r))}},
gY:function(){return new H.bs(this,H.Y(this).k("bs<1>"))}}
H.bs.prototype={
gw:function(a){var t=this.a.c
return new J.b1(t,t.length)},
gi:function(a){return this.a.c.length}}
H.c_.prototype={
bh:function(a){if(false)H.hC(0,0)},
l:function(a){var t="<"+C.a.bH([H.jP(this.$ti.c)],", ")+">"
return H.i(this.a)+" with "+t}}
H.b9.prototype={
$2:function(a,b){return this.a.$1$2(a,b,this.$ti.Q[0])},
$S:function(){return H.hC(H.hv(this.a),this.$ti)}}
H.cU.prototype={
gb1:function(){var t=this.a
return t},
gb3:function(){var t,s,r,q,p=this
if(p.c===1)return C.o
t=p.d
s=t.length-p.e.length-p.f
if(s===0)return C.o
r=[]
for(q=0;q<s;++q){if(q>=t.length)return H.f(t,q)
r.push(t[q])}r.fixed$length=Array
r.immutable$list=Array
return r},
gb2:function(){var t,s,r,q,p,o,n,m,l=this
if(l.c!==0)return C.p
t=l.e
s=t.length
r=l.d
q=r.length-s-l.f
if(s===0)return C.p
p=new H.aa(u.B)
for(o=0;o<s;++o){if(o>=t.length)return H.f(t,o)
n=t[o]
m=q+o
if(m<0||m>=r.length)return H.f(r,m)
p.m(0,new H.aS(n),r[m])}return new H.b3(p,u.h)}}
H.dt.prototype={
$2:function(a,b){var t=this.a
t.b=t.b+"$"+H.i(a)
this.b.push(a)
this.c.push(b);++t.a}}
H.dw.prototype={
T:function(a){var t,s,r=this,q=new RegExp(r.a).exec(a)
if(q==null)return null
t=Object.create(null)
s=r.b
if(s!==-1)t.arguments=q[s+1]
s=r.c
if(s!==-1)t.argumentsExpr=q[s+1]
s=r.d
if(s!==-1)t.expr=q[s+1]
s=r.e
if(s!==-1)t.method=q[s+1]
s=r.f
if(s!==-1)t.receiver=q[s+1]
return t}}
H.cd.prototype={
l:function(a){var t=this.b
if(t==null)return"NoSuchMethodError: "+H.i(this.a)
return"NoSuchMethodError: method not found: '"+t+"' on null"}}
H.c2.prototype={
l:function(a){var t,s=this,r="NoSuchMethodError: method not found: '",q=s.b
if(q==null)return"NoSuchMethodError: "+H.i(s.a)
t=s.c
if(t==null)return r+q+"' ("+H.i(s.a)+")"
return r+q+"' on '"+t+"' ("+H.i(s.a)+")"}}
H.cr.prototype={
l:function(a){var t=this.a
return t.length===0?"Error":"Error: "+t}}
H.d5.prototype={
l:function(a){return"Throw of null ('"+(this.a===null?"null":"undefined")+"' from JavaScript)"}}
H.cB.prototype={
l:function(a){var t,s=this.b
if(s!=null)return s
s=this.a
t=s!==null&&typeof s==="object"?s.stack:null
return this.b=t==null?"":t}}
H.ax.prototype={
l:function(a){var t=this.constructor,s=t==null?null:t.name
return"Closure '"+H.hP(s==null?"unknown":s)+"'"},
$iak:1,
gbP:function(){return this},
$C:"$1",
$R:1,
$D:null}
H.co.prototype={}
H.cm.prototype={
l:function(a){var t=this.$static_name
if(t==null)return"Closure of unknown static method"
return"Closure '"+H.hP(t)+"'"}}
H.aJ.prototype={
q:function(a,b){var t=this
if(b==null)return!1
if(t===b)return!0
if(!(b instanceof H.aJ))return!1
return t.a===b.a&&t.b===b.b&&t.c===b.c},
gv:function(a){var t,s=this.c
if(s==null)t=H.aQ(this.a)
else t=typeof s!=="object"?J.av(s):H.aQ(s)
return(t^H.aQ(this.b))>>>0},
l:function(a){var t=this.c
if(t==null)t=this.a
return"Closure '"+H.i(this.d)+"' of "+("Instance of '"+H.i(H.du(t))+"'")}}
H.cg.prototype={
l:function(a){return"RuntimeError: "+this.a}}
H.dE.prototype={}
H.aa.prototype={
gi:function(a){return this.a},
ga1:function(a){return this.a===0},
gb_:function(a){return!this.ga1(this)},
gY:function(){return new H.be(this,H.Y(this).k("be<1>"))},
a6:function(a){var t,s
if(typeof a=="string"){t=this.b
if(t==null)return!1
return this.bm(t,a)}else{s=this.bE(a)
return s}},
bE:function(a){var t=this,s=t.d
if(s==null)return!1
return t.ax(t.ar(s,t.aw(a)),a)>=0},
h:function(a,b){var t,s,r,q,p=this,o=null
if(typeof b=="string"){t=p.b
if(t==null)return o
s=p.ac(t,b)
r=s==null?o:s.b
return r}else if(typeof b=="number"&&(b&0x3ffffff)===b){q=p.c
if(q==null)return o
s=p.ac(q,b)
r=s==null?o:s.b
return r}else return p.bF(b)},
bF:function(a){var t,s,r=this,q=r.d
if(q==null)return null
t=r.ar(q,r.aw(a))
s=r.ax(t,a)
if(s<0)return null
return t[s].b},
m:function(a,b,c){var t,s,r=this
if(typeof b=="string"){t=r.b
r.aG(t==null?r.b=r.as():t,b,c)}else if(typeof b=="number"&&(b&0x3ffffff)===b){s=r.c
r.aG(s==null?r.c=r.as():s,b,c)}else r.bG(b,c)},
bG:function(a,b){var t,s,r,q=this,p=q.d
if(p==null)p=q.d=q.as()
t=q.aw(a)
s=q.ar(p,t)
if(s==null)q.au(p,t,[q.at(a,b)])
else{r=q.ax(s,a)
if(r>=0)s[r].b=b
else s.push(q.at(a,b))}},
R:function(a,b){var t=this,s=t.e,r=t.r
for(;s!=null;){b.$2(s.a,s.b)
if(r!==t.r)throw H.a(P.N(t))
s=s.c}},
aG:function(a,b,c){var t=this.ac(a,b)
if(t==null)this.au(a,b,this.at(b,c))
else t.b=c},
at:function(a,b){var t=this,s=new H.cY(a,b)
if(t.e==null)t.e=t.f=s
else t.f=t.f.c=s;++t.a
t.r=t.r+1&67108863
return s},
aw:function(a){return J.av(a)&0x3ffffff},
ax:function(a,b){var t,s
if(a==null)return-1
t=a.length
for(s=0;s<t;++s)if(J.n(a[s].a,b))return s
return-1},
l:function(a){return P.d1(this)},
ac:function(a,b){return a[b]},
ar:function(a,b){return a[b]},
au:function(a,b,c){a[b]=c},
bn:function(a,b){delete a[b]},
bm:function(a,b){return this.ac(a,b)!=null},
as:function(){var t="<non-identifier-key>",s=Object.create(null)
this.au(s,t,s)
this.bn(s,t)
return s}}
H.cY.prototype={}
H.be.prototype={
gi:function(a){return this.a.a},
gw:function(a){var t=this.a,s=new H.c3(t,t.r)
s.c=t.e
return s}}
H.c3.prototype={
gp:function(){return this.d},
n:function(){var t,s=this,r=s.a
if(s.b!==r.r)throw H.a(P.N(r))
t=s.c
if(t==null){s.d=null
return!1}else{s.d=t.a
s.c=t.c
return!0}}}
H.eN.prototype={
$1:function(a){return this.a(a)}}
H.eO.prototype={
$2:function(a,b){return this.a(a,b)}}
H.eP.prototype={
$1:function(a){return this.a(a)}}
H.aB.prototype={$ia1:1}
H.aO.prototype={
gi:function(a){return a.length},
$ia_:1}
H.aA.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]},
m:function(a,b,c){H.ah(b,a,a.length)
a[b]=c},
$io:1,
$ih:1,
$iA:1}
H.bi.prototype={
m:function(a,b,c){H.ah(b,a,a.length)
a[b]=c},
$io:1,
$ih:1,
$iA:1}
H.c6.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.c7.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.c8.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.c9.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.ca.prototype={
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.bj.prototype={
gi:function(a){return a.length},
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.cb.prototype={
gi:function(a){return a.length},
h:function(a,b){H.ah(b,a,a.length)
return a[b]}}
H.by.prototype={}
H.bz.prototype={}
H.bA.prototype={}
H.bB.prototype={}
H.a0.prototype={
k:function(a){return H.cE(v.typeUniverse,this,a)},
U:function(a){return H.j3(v.typeUniverse,this,a)}}
H.cy.prototype={}
H.cC.prototype={
l:function(a){return H.V(this.a,null)}}
H.cw.prototype={
l:function(a){return this.a}}
H.bE.prototype={}
P.dz.prototype={
$1:function(a){var t=this.a,s=t.a
t.a=null
s.$0()}}
P.dy.prototype={
$1:function(a){var t,s
this.a.a=a
t=this.b
s=this.c
t.firstChild?t.removeChild(s):t.appendChild(s)}}
P.dA.prototype={
$0:function(){this.a.$0()},
$C:"$0",
$R:0}
P.dB.prototype={
$0:function(){this.a.$0()},
$C:"$0",
$R:0}
P.dK.prototype={
bi:function(a,b){if(self.setTimeout!=null)self.setTimeout(H.ec(new P.dL(this,b),0),a)
else throw H.a(P.J("`setTimeout()` not found."))}}
P.dL.prototype={
$0:function(){this.b.$0()},
$C:"$0",
$R:0}
P.cv.prototype={}
P.dN.prototype={}
P.dZ.prototype={
$0:function(){var t=H.a(this.a)
t.stack=J.P(this.b)
throw t}}
P.dF.prototype={
bO:function(a){var t,s,r,q=null
try{if(C.h===$.cu){a.$0()
return}P.jy(q,q,this,a)}catch(r){t=H.f7(r)
s=H.jW(r)
P.jx(q,q,this,t,s)}},
bx:function(a){return new P.dG(this,a)}}
P.dG.prototype={
$0:function(){return this.a.bO(this.b)}}
P.bt.prototype={
gi:function(a){return this.a},
gY:function(){return new P.bu(this,this.$ti.k("bu<1>"))},
a6:function(a){var t,s
if(typeof a=="string"&&a!=="__proto__"){t=this.b
return t==null?!1:t[a]!=null}else if(typeof a=="number"&&(a&1073741823)===a){s=this.c
return s==null?!1:s[a]!=null}else return this.bl(a)},
bl:function(a){var t=this.d
if(t==null)return!1
return this.a4(this.aM(t,a),a)>=0},
h:function(a,b){var t,s,r
if(typeof b=="string"&&b!=="__proto__"){t=this.b
s=t==null?null:P.h7(t,b)
return s}else if(typeof b=="number"&&(b&1073741823)===b){r=this.c
s=r==null?null:P.h7(r,b)
return s}else return this.bp(b)},
bp:function(a){var t,s,r=this.d
if(r==null)return null
t=this.aM(r,a)
s=this.a4(t,a)
return s<0?null:t[s+1]},
m:function(a,b,c){var t,s,r,q=this,p=q.d
if(p==null)p=q.d=P.iP()
t=H.hL(b)&1073741823
s=p[t]
if(s==null){P.h8(p,t,[b,c]);++q.a
q.e=null}else{r=q.a4(s,b)
if(r>=0)s[r+1]=c
else{s.push(b,c);++q.a
q.e=null}}},
R:function(a,b){var t,s,r,q=this,p=q.aK()
for(t=p.length,s=0;s<t;++s){r=p[s]
b.$2(r,q.h(0,r))
if(p!==q.e)throw H.a(P.N(q))}},
aK:function(){var t,s,r,q,p,o,n,m,l,k,j=this,i=j.e
if(i!=null)return i
i=P.d0(j.a,null,!1,u.z)
t=j.b
if(t!=null){s=Object.getOwnPropertyNames(t)
r=s.length
for(q=0,p=0;p<r;++p){i[q]=s[p];++q}}else q=0
o=j.c
if(o!=null){s=Object.getOwnPropertyNames(o)
r=s.length
for(p=0;p<r;++p){i[q]=+s[p];++q}}n=j.d
if(n!=null){s=Object.getOwnPropertyNames(n)
r=s.length
for(p=0;p<r;++p){m=n[s[p]]
l=m.length
for(k=0;k<l;k+=2){i[q]=m[k];++q}}}return j.e=i},
aM:function(a,b){return a[H.hL(b)&1073741823]}}
P.bv.prototype={
a4:function(a,b){var t,s,r
if(a==null)return-1
t=a.length
for(s=0;s<t;s+=2){r=a[s]
if(r==null?b==null:r===b)return s}return-1}}
P.bu.prototype={
gi:function(a){return this.a.a},
gw:function(a){var t=this.a
return new P.cz(t,t.aK())}}
P.cz.prototype={
gp:function(){return this.d},
n:function(){var t=this,s=t.b,r=t.c,q=t.a
if(s!==q.e)throw H.a(P.N(q))
else if(r>=s.length){t.d=null
return!1}else{t.d=s[r]
t.c=r+1
return!0}}}
P.a2.prototype={
bq:function(){return new P.a2(H.Y(this).k("a2<1>"))},
gw:function(a){var t=new P.aH(this,this.r)
t.c=this.e
return t},
gi:function(a){return this.a},
G:function(a,b){var t,s,r=this
if(typeof b=="string"&&b!=="__proto__"){t=r.b
return r.aI(t==null?r.b=P.fm():t,b)}else if(typeof b=="number"&&(b&1073741823)===b){s=r.c
return r.aI(s==null?r.c=P.fm():s,b)}else return r.bj(b)},
bj:function(a){var t,s,r=this,q=r.d
if(q==null)q=r.d=P.fm()
t=r.bk(a)
s=q[t]
if(s==null)q[t]=[r.ao(a)]
else{if(r.a4(s,a)>=0)return!1
s.push(r.ao(a))}return!0},
aI:function(a,b){if(a[b]!=null)return!1
a[b]=this.ao(b)
return!0},
ao:function(a){var t=this,s=new P.dD(a)
if(t.e==null)t.e=t.f=s
else t.f=t.f.b=s;++t.a
t.r=1073741823&t.r+1
return s},
bk:function(a){return J.av(a)&1073741823},
a4:function(a,b){var t,s
if(a==null)return-1
t=a.length
for(s=0;s<t;++s)if(J.n(a[s].a,b))return s
return-1}}
P.dD.prototype={}
P.aH.prototype={
gp:function(){return this.d},
n:function(){var t=this,s=t.c,r=t.a
if(t.b!==r.r)throw H.a(P.N(r))
else if(s==null){t.d=null
return!1}else{t.d=s.a
t.c=s.b
return!0}}}
P.q.prototype={
gw:function(a){return new H.ao(a,this.gi(a))},
L:function(a,b){return this.h(a,b)},
ga1:function(a){return this.gi(a)===0},
gI:function(a){if(this.gi(a)===0)throw H.a(H.a9())
return this.h(a,0)},
gC:function(a){if(this.gi(a)===0)throw H.a(H.a9())
return this.h(a,this.gi(a)-1)},
ab:function(a,b){return new H.D(a,b,H.a3(a).k("D<q.E>"))},
a2:function(a,b,c){return new H.l(a,b,H.a3(a).k("@<q.E>").U(c).k("l<1,2>"))},
M:function(a,b){var t,s,r=this,q=r.gi(a)
if(q===0)throw H.a(H.a9())
t=r.h(a,0)
for(s=1;s<q;++s){t=b.$2(t,r.h(a,s))
if(q!==r.gi(a))throw H.a(P.N(a))}return t},
aa:function(a,b){var t,s,r,q,p=this
if(p.gi(a)===0){t=J.cS(0,H.a3(a).k("q.E"))
return t}s=p.h(a,0)
r=P.d0(p.gi(a),s,!0,H.a3(a).k("q.E"))
for(q=1;q<p.gi(a);++q){t=p.h(a,q)
if(q>=r.length)return H.f(r,q)
r[q]=t}return r},
al:function(a){return this.aa(a,!0)},
V:function(a,b){var t
for(t=0;t<this.gi(a);++t)if(J.n(this.h(a,t),b))return t
return-1},
S:function(a,b){var t
for(t=0;t<this.gi(a);++t)if(b.$1(this.h(a,t)))return t
return-1},
gb4:function(a){return new H.aE(a,H.a3(a).k("aE<q.E>"))},
l:function(a){return P.fb(a,"[","]")}}
P.bf.prototype={}
P.d2.prototype={
$2:function(a,b){var t,s=this.a
if(!s.a)this.b.a+=", "
s.a=!1
s=this.b
t=s.a+=H.i(a)
s.a=t+": "
s.a+=H.i(b)}}
P.bg.prototype={
R:function(a,b){var t,s
for(t=this.gY(),t=t.gw(t);t.n();){s=t.gp()
b.$2(s,this.h(0,s))}},
gi:function(a){var t=this.gY()
return t.gi(t)},
l:function(a){return P.d1(this)},
$iU:1}
P.cF.prototype={}
P.bh.prototype={
h:function(a,b){return this.a.h(0,b)},
R:function(a,b){this.a.R(0,b)},
gi:function(a){var t=this.a
return t.gi(t)},
gY:function(){return this.a.gY()},
l:function(a){return P.d1(this.a)},
$iU:1}
P.br.prototype={}
P.bD.prototype={
am:function(a){var t=this.bq()
t.H(0,this)
return t},
H:function(a,b){var t
for(t=J.M(b);t.n();)this.G(0,t.gp())},
aD:function(a){var t=this.am(0)
t.H(0,a)
return t},
a2:function(a,b,c){return new H.S(this,b,H.Y(this).k("@<1>").U(c).k("S<1,2>"))},
l:function(a){return P.fb(this,"{","}")},
$io:1,
$ih:1,
$ici:1}
P.bH.prototype={}
P.d4.prototype={
$2:function(a,b){var t,s=this.b,r=this.a
s.a+=r.a
t=s.a+=H.i(a.a)
s.a=t+": "
s.a+=P.aL(b)
r.a=", "}}
P.b5.prototype={
q:function(a,b){if(b==null)return!1
return b instanceof P.b5&&this.a===b.a&&!0},
gv:function(a){var t=this.a
return(t^C.b.aP(t,30))&1073741823},
l:function(a){var t=this,s=P.ih(H.iF(t)),r=P.bU(H.iD(t)),q=P.bU(H.iz(t)),p=P.bU(H.iA(t)),o=P.bU(H.iC(t)),n=P.bU(H.iE(t)),m=P.ii(H.iB(t)),l=s+"-"+r+"-"+q+" "+p+":"+o+":"+n+"."+m
return l}}
P.aK.prototype={
q:function(a,b){if(b==null)return!1
return b instanceof P.aK&&this.a===b.a},
gv:function(a){return C.b.gv(this.a)},
l:function(a){var t,s,r,q=new P.cR(),p=this.a
if(p<0)return"-"+new P.aK(0-p).l(0)
t=q.$1(C.b.a0(p,6e7)%60)
s=q.$1(C.b.a0(p,1e6)%60)
r=new P.cQ().$1(p%1e6)
return""+C.b.a0(p,36e8)+":"+H.i(t)+":"+H.i(s)+"."+H.i(r)}}
P.cQ.prototype={
$1:function(a){if(a>=1e5)return""+a
if(a>=1e4)return"0"+a
if(a>=1000)return"00"+a
if(a>=100)return"000"+a
if(a>=10)return"0000"+a
return"00000"+a}}
P.cR.prototype={
$1:function(a){if(a>=10)return""+a
return"0"+a}}
P.y.prototype={}
P.bR.prototype={
l:function(a){var t=this.a
if(t!=null)return"Assertion failed: "+P.aL(t)
return"Assertion failed"}}
P.cp.prototype={}
P.ce.prototype={
l:function(a){return"Throw of null."}}
P.a7.prototype={
gaq:function(){return"Invalid argument"+(!this.a?"(s)":"")},
gap:function(){return""},
l:function(a){var t,s,r=this,q=r.c,p=q==null?"":" ("+q+")",o=r.d,n=o==null?"":": "+H.i(o),m=r.gaq()+p+n
if(!r.a)return m
t=r.gap()
s=P.aL(r.b)
return m+t+": "+s}}
P.bl.prototype={
gaq:function(){return"RangeError"},
gap:function(){var t,s=this.e,r=this.f
if(s==null)t=r!=null?": Not less than or equal to "+H.i(r):""
else if(r==null)t=": Not greater than or equal to "+H.i(s)
else if(r>s)t=": Not in inclusive range "+H.i(s)+".."+H.i(r)
else t=r<s?": Valid value range is empty":": Only valid value is "+H.i(s)
return t}}
P.bZ.prototype={
gaq:function(){return"RangeError"},
gap:function(){var t,s=this.b
if(typeof s!=="number")return s.F()
if(s<0)return": index must not be negative"
t=this.f
if(t===0)return": no indices are valid"
return": index should be less than "+H.i(t)},
gi:function(a){return this.f}}
P.cc.prototype={
l:function(a){var t,s,r,q,p,o,n,m,l=this,k={},j=new P.bp("")
k.a=""
t=l.c
for(s=t.length,r=0,q="",p="";r<s;++r,p=", "){o=t[r]
j.a=q+p
q=j.a+=P.aL(o)
k.a=", "}l.d.R(0,new P.d4(k,j))
n=P.aL(l.a)
m=j.l(0)
s="NoSuchMethodError: method not found: '"+H.i(l.b.a)+"'\nReceiver: "+n+"\nArguments: ["+m+"]"
return s}}
P.cs.prototype={
l:function(a){return"Unsupported operation: "+this.a}}
P.cq.prototype={
l:function(a){var t=this.a
return t!=null?"UnimplementedError: "+t:"UnimplementedError"}}
P.aR.prototype={
l:function(a){return"Bad state: "+this.a}}
P.bS.prototype={
l:function(a){var t=this.a
if(t==null)return"Concurrent modification during iteration."
return"Concurrent modification during iteration: "+P.aL(t)+"."}}
P.bn.prototype={
l:function(a){return"Stack Overflow"},
$iy:1}
P.bT.prototype={
l:function(a){var t=this.a
return t==null?"Reading static variable during its initialization":"Reading static variable '"+t+"' during its initialization"}}
P.dC.prototype={
l:function(a){return"Exception: "+this.a}}
P.h.prototype={
a2:function(a,b,c){return H.is(this,b,H.Y(this).k("h.E"),c)},
ab:function(a,b){return new H.D(this,b,H.Y(this).k("D<h.E>"))},
M:function(a,b){var t,s=this.gw(this)
if(!s.n())throw H.a(H.a9())
t=s.gp()
for(;s.n();)t=b.$2(t,s.gp())
return t},
gi:function(a){var t,s=this.gw(this)
for(t=0;s.n();)++t
return t},
L:function(a,b){var t,s,r
P.fi(b,"index")
for(t=this.gw(this),s=0;t.n();){r=t.gp()
if(b===s)return r;++s}throw H.a(P.fa(b,this,"index",null,s))},
l:function(a){return P.ik(this,"(",")")}}
P.c0.prototype={}
P.bk.prototype={
gv:function(a){return P.u.prototype.gv.call(C.D,this)},
l:function(a){return"null"}}
P.u.prototype={constructor:P.u,$iu:1,
q:function(a,b){return this===b},
gv:function(a){return H.aQ(this)},
l:function(a){return"Instance of '"+H.i(H.du(this))+"'"},
aj:function(a,b){throw H.a(P.fZ(this,b.gb1(),b.gb3(),b.gb2()))},
toString:function(){return this.l(this)}}
P.bp.prototype={
gi:function(a){return this.a.length},
l:function(a){var t=this.a
return t.charCodeAt(0)==0?t:t}}
W.e.prototype={}
W.bP.prototype={
l:function(a){return String(a)}}
W.bQ.prototype={
l:function(a){return String(a)}}
W.aw.prototype={$iaw:1}
W.a4.prototype={
gi:function(a){return a.length}}
W.cP.prototype={
l:function(a){return String(a)}}
W.d.prototype={
l:function(a){return a.localName}}
W.c.prototype={$ic:1}
W.bW.prototype={}
W.bY.prototype={
gi:function(a){return a.length}}
W.b8.prototype={$ib8:1}
W.C.prototype={
l:function(a){var t=a.nodeValue
return t==null?this.bb(a):t},
$iC:1}
W.ch.prototype={
gi:function(a){return a.length}}
W.aT.prototype={$iaT:1}
W.af.prototype={$iaf:1}
P.bd.prototype={$ibd:1}
P.cX.prototype={
$1:function(a){var t,s,r,q=this.a
if(q.a6(a))return q.h(0,a)
if(u.f.b(a)){t={}
q.m(0,a,t)
for(q=a.gY(),q=q.gw(q);q.n();){s=q.gp()
t[s]=this.$1(a.h(0,s))}return t}else if(u.q.b(a)){r=[]
q.m(0,a,r)
C.a.H(r,J.cJ(a,this,u.z))
return r}else return P.dP(a)}}
P.dQ.prototype={
$1:function(a){var t=function(b,c,d){return function(){return b(c,d,this,Array.prototype.slice.apply(arguments))}}(P.j8,a,!1)
P.fr(t,$.f8(),a)
return t}}
P.dR.prototype={
$1:function(a){return new this.a(a)}}
P.e_.prototype={
$1:function(a){return new P.c1(a)}}
P.e0.prototype={
$1:function(a){return new P.an(a,u.A)}}
P.e1.prototype={
$1:function(a){return new P.O(a)}}
P.O.prototype={
h:function(a,b){if(typeof b!="string"&&typeof b!="number")throw H.a(P.b0("property is not a String or num"))
return P.hk(this.a[b])},
m:function(a,b,c){if(typeof b!="string"&&typeof b!="number")throw H.a(P.b0("property is not a String or num"))
this.a[b]=P.dP(c)},
q:function(a,b){if(b==null)return!1
return b instanceof P.O&&this.a===b.a},
l:function(a){var t,s
try{t=String(this.a)
return t}catch(s){H.f7(s)
t=this.bg(0)
return t}},
gv:function(a){return 0}}
P.c1.prototype={}
P.an.prototype={
aH:function(a){var t=this,s=a<0||a>=t.gi(t)
if(s)throw H.a(P.dv(a,0,t.gi(t),null,null))},
h:function(a,b){if(H.aV(b))this.aH(b)
return this.be(0,b)},
m:function(a,b,c){if(H.aV(b))this.aH(b)
this.bf(0,b,c)},
gi:function(a){var t=this.a.length
if(typeof t==="number"&&t>>>0===t)return t
throw H.a(P.iJ("Bad JsArray length"))},
$io:1,
$ih:1,
$iA:1}
P.bx.prototype={}
V.c5.prototype={
gbJ:function(a){var t=this.a
switch(t){case-1:return"Unknown error."
case 9:return"The input polygon is null or empty."
case 150:return"The input polygon has insufficient points."
case 700:return"The inset polygon self-intersects."
case 1201:return"The input polygon self-intersects."
case 2201:return"The input polygon is too large."
case 2828:return"The input polygon is too small."
case-30:return"The input polygon is non-monotone for all angles."
case 3110:return"The input polygon could not be decomposed into sweepable sections."
case 4242:return"The input polygon could not be covered by a sweeping path."
case 1399:return"Missing path planning parameters."
case 2000:return"Inset width parameter is invalid."
case 1440:return"Step width parameter is invalid."
default:return"Unknown error (Code "+t+")."}}}
X.aN.prototype={
q:function(a,b){if(b==null)return!1
return b instanceof X.aN&&this.a===b.a&&this.b===b.b},
gv:function(a){return C.c.gv(this.a)^C.c.gv(this.b)}}
X.d3.prototype={}
X.f4.prototype={
$1:function(a){return L.fR(a,this.a)}}
X.f5.prototype={
$1:function(a){var t,s=this.a,r=a.b,q=s.a+r/6371e3*180/3.141592653589793
r=a.a
if(typeof r!=="number")return r.b6()
t=Math.cos(q*0.017453292519943295)
return X.fg(q,s.b+r/6371e3/t*180/3.141592653589793)}}
B.b_.prototype={
aF:function(a,b){var t,s,r,q=B.ag(C.c.j(a,6.283185307179586),C.c.j(b,6.283185307179586)),p=H.b([],u.U)
for(t=this.a,s=t.length,r=0;r<t.length;t.length===s||(0,H.K)(t),++r)C.a.H(p,t[r].b9(q))
this.a=p},
bM:function(a,b){var t=this.a,s=H.F(t).k("l<1,ar*>")
this.a=P.r(new H.l(t,new B.cM(b),s),!0,s.k("t.E"))},
ag:function(a){return C.a.bv(this.a,new B.cL(a))},
gaE:function(a){var t=this.a
return new H.l(t,new B.cN(),H.F(t).k("l<1,H*>")).am(0)}}
B.cM.prototype={
$1:function(a){return a.bN(this.a)}}
B.cL.prototype={
$1:function(a){return a.a5(this.a)}}
B.cN.prototype={
$1:function(a){var t=a.a
return t==null?0:t}}
B.ar.prototype={
bN:function(a){var t,s,r=this
if(r.c)return r
t=r.a
if(typeof t!=="number")return t.A()
s=r.b
if(typeof s!=="number")return s.A()
return B.ag(t+a,s+a)},
a5:function(a){var t,s,r
if(this.c)return!0
t=this.a
if(typeof a!=="number")return a.u()
if(typeof t!=="number")return H.j(t)
s=C.c.j(a-t,6.283185307179586)
r=this.b
if(typeof r!=="number")return r.u()
return s<=C.c.j(r-t,6.283185307179586)},
b9:function(a){var t,s,r,q,p,o,n,m,l,k=this
if(a.c)return P.a5(u.Z)
if(k.c)return P.T([B.ag(a.b,a.a)],u.Z)
t=a.a
s=k.a
if(t==s&&a.b==k.b)return P.a5(u.Z)
r=a.b
if(r==s&&t==k.b)return P.T([k],u.Z)
q=k.a5(t)
p=k.a5(r)
o=a.a5(s)
n=k.b
m=a.a5(n)
if(q&&p&&!o&&!m)return P.T([B.ag(s,t),B.ag(r,n)],u.Z)
l=!q
if(l&&!p&&!o&&!m)return P.T([k],u.Z)
if(l&&!p&&o&&m)return P.a5(u.Z)
if(q&&!p&&!o&&m)return P.T([B.ag(s,t)],u.Z)
if(l&&p&&o&&!m)return P.T([B.ag(r,n)],u.Z)
if(q&&p&&o&&m)return P.T([B.ag(r,t)],u.Z)
if(q&&!p&&o&&m)return P.a5(u.Z)
if(q&&p&&o&&!m)return P.T([B.ag(r,n)],u.Z)
if(l&&p&&o&&m)return P.a5(u.Z)
if(q&&p&&!o&&m)return P.T([B.ag(s,t)],u.Z)
return P.T([k],u.Z)}}
L.x.prototype={
E:function(a,b){var t,s,r=Math.cos(H.eb(a))
if(typeof b!=="number")return b.Z()
t=Math.sin(H.eb(a))
s=this.a
if(typeof s!=="number")return s.A()
return new L.x(s+b*r,this.b+b*t)},
ak:function(a,b){var t,s,r,q,p,o,n=this
if(n.q(0,b)||a===0)return n
t=Math.sin(a)
s=Math.cos(a)
r=n.a
q=b.a
if(typeof r!=="number")return r.u()
if(typeof q!=="number")return H.j(q)
r-=q
p=b.b
o=n.b-p
return new L.x(r*s-o*t+q,r*t+o*s+p)},
t:function(a){var t,s,r=a.a,q=this.a
if(typeof r!=="number")return r.u()
if(typeof q!=="number")return H.j(q)
t=r-q
s=a.b-this.b
return Math.sqrt(t*t+s*s)},
K:function(a){var t=a.a,s=this.a
if(typeof t!=="number")return t.u()
if(typeof s!=="number")return H.j(s)
return C.c.j(Math.atan2(a.b-this.b,t-s),6.283185307179586)},
ad:function(a,b){if(b===0)return this.q(0,a)
if(this.q(0,a))return!0
else if(this.t(a)<=b)return!0
return!1},
bw:function(a){return this.ad(a,1e-9)},
J:function(a,b){var t,s,r=this.a,q=b.a
if(typeof r!=="number")return r.u()
if(typeof q!=="number")return H.j(q)
t=r-q
if(t>0)return 1
if(t<0)return-1
s=this.b-b.b
if(s>0)return 1
if(s<0)return-1
return 0},
q:function(a,b){if(b==null)return!1
return b instanceof L.x&&this.J(0,b)===0},
gv:function(a){return J.av(this.a)^C.c.gv(this.b)},
l:function(a){return"("+H.i(this.a)+", "+H.i(this.b)+")"}}
L.eX.prototype={
$2:function(a,b){var t=a.a,s=b.a
if(typeof t!=="number")return t.F()
if(typeof s!=="number")return H.j(s)
return t<s?a:b}}
L.eT.prototype={
$2:function(a,b){var t=a.a,s=b.a
if(typeof t!=="number")return t.B()
if(typeof s!=="number")return H.j(s)
return t>s?a:b}}
L.eY.prototype={
$2:function(a,b){return a.b<b.b?a:b}}
L.eU.prototype={
$2:function(a,b){return a.b>b.b?a:b}}
A.v.prototype={
af:function(a,b){var t,s,r,q,p,o,n,m,l,k,j,i,h
for(t=this.a,s=J.m(t),r=0,q=0;q<s.gi(t);){p=s.h(t,q);++q
o=s.h(t,C.b.j(q,s.gi(t)))
n=o.a
m=p.a
if(typeof n!=="number")return n.u()
if(typeof m!=="number")return H.j(m)
l=a.b
k=p.b
j=a.a
if(typeof j!=="number")return j.u()
i=o.b
h=(n-m)*(l-k)-(j-m)*(i-k)
if(h===0)if(R.bL(a,p,o))return b
if(k<=l){if(i>l)r=h>0?r+1:r}else if(i<=l)r=h<0?r-1:r}return r!==0},
av:function(a){return this.af(a,!1)},
P:function(){var t,s,r,q,p,o,n,m,l,k=this.b
if(k==null){for(k=this.a,t=J.m(k),s=0,r=0;r<t.gi(k);r=q){q=r+1
p=C.b.j(q,t.gi(k))
o=t.h(k,r).a
n=t.h(k,p).b
if(typeof o!=="number")return o.Z()
m=t.h(k,r).b
l=t.h(k,p).a
if(typeof l!=="number")return H.j(l)
s=s+o*n-m*l}k=this.b=Math.abs(s)/2}return k},
ak:function(a,b){var t
if(a===0)return this
t=J.cJ(this.a,new A.dr(b,a),u.R)
return new A.v(P.r(t,!0,t.$ti.k("t.E")))},
O:function(){var t,s,r,q,p=P.a5(u.a)
for(t=this.a,s=J.m(t),r=0;r<s.gi(t);r=q){q=r+1
p.G(0,new R.ac(s.h(t,r),s.h(t,C.b.j(q,s.gi(t)))))}return R.jJ(p)},
aX:function(a){var t,s,r,q,p,o,n,m=this.a,l=a.a,k=L.hJ(m),j=L.hG(m),i=L.hK(m),h=L.hH(m),g=L.hJ(l),f=L.hG(l),e=L.hK(l),d=L.hH(l)
if(typeof k!=="number")return k.F()
if(typeof f!=="number")return H.j(f)
if(k<f){if(typeof j!=="number")return j.B()
if(typeof g!=="number")return H.j(g)
t=j>g&&h>e&&i<d}else t=!1
if(!t)return!1
for(t=J.m(m),s=J.m(l),r=0;r<t.gi(m);){q=t.h(m,r);++r
p=t.h(m,C.b.j(r,t.gi(m)))
for(o=0;o<s.gi(l);o=n){n=o+1
if(R.jB(q,p,s.h(l,o),s.h(l,C.b.j(n,s.gi(l)))))return!0}}return!1},
aW:function(a,b){var t,s,r,q,p,o,n,m,l,k,j,i,h=this,g=null,f="Failing input:",e=h.D().a,d=H.b([],u.K)
for(t=J.m(e),s=0;s<t.gi(e);s=q){r=t.h(e,s)
q=s+1
p=t.h(e,C.b.j(q,t.gi(e)))
o=t.h(e,(s>0?s:t.gi(e))-1)
n=A.cG(r,o,p)
if(n===3.141592653589793)continue
if(n===0){m=t.ab(e,new A.dn(r))
l=new A.v(P.r(m,!0,m.$ti.k("h.E")))
if(l.av(r))continue
C.a.si(d,0)
return l.X(a)}C.a.H(d,A.jb(o,r,p,a,n))}if(d.length<3){P.z("Polygon generated output of less than two points.")
P.z(f)
for(t=J.M(h.a);t.n();)H.w(J.P(t.gp()))
return g}k=new A.v(d)
if(k.O()){if(b)return g
j=A.jR(d)
if(j==null){P.z("Failed to fix self-intersection polygon (null output)!")
P.z(f)
for(t=J.M(h.a);t.n();)H.w(J.P(t.gp()))
return g}else k=new A.v(j)
if(k.O()){P.z("Failed to fix self-intersecting polygon (bad output)!")
P.z(f)
for(t=d.length,i=0;i<d.length;d.length===t||(0,H.K)(d),++i)H.w(J.P(d[i]))
return g}}return k.aX(h)?k.bz(h):k},
X:function(a){return this.aW(a,!1)},
aY:function(){var t,s,r,q,p,o,n,m=this.c
if(m==null){for(m=this.a,t=J.m(m),s=0,r=0;r<t.gi(m);){q=t.h(m,r);++r
p=t.h(m,C.b.j(r,t.gi(m)))
o=p.a
n=q.a
if(typeof o!=="number")return o.u()
if(typeof n!=="number")return H.j(n)
s+=(o-n)*(p.b+q.b)}m=this.c=s>0}return m},
D:function(){if(this.aY())return this
else{var t=J.i1(this.a)
return new A.v(P.r(t,!0,t.$ti.k("t.E")))}},
bz:function(a8){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0,a1,a2,a3=this.D().a,a4=a8.D().a,a5=u.u,a6=H.b([],a5),a7=H.b([],a5)
for(a5=J.m(a3),t=J.m(a4),s=0;s<a5.gi(a3);s=q){r=a5.h(a3,s)
q=s+1
p=a5.h(a3,C.b.j(q,a5.gi(a3)))
C.a.si(a7,0)
for(o=0;o<t.gi(a4);o=n){n=o+1
m=R.ft(r,p,t.h(a4,o),t.h(a4,C.b.j(n,t.gi(a4))))
if(m!=null){l=new A.aU()
l.a=m
l.b=s
l.c=o
a7.push(l)}}l=a7.length
if(l>1){k=new A.dd(r)
if(!!a7.immutable$list)H.L(P.J("sort"));--l
if(l-0<=32)H.cl(a7,0,l,k)
else H.ck(a7,0,l,k)}C.a.H(a6,a7)}j=a8.av(a5.h(a3,0))
for(l=a6.length,i=0;i<l;++i){j=!j
a6[i].d=j}if(l===0)if(a8.av(a5.h(a3,0)))return this
else return null
l=u.G
h=H.b([],l)
g=H.b([],l)
for(l=u.aa,k=u.a8,s=0;s<a5.gi(a3);++s){h.push(new A.aq(a5.h(a3,s),null))
C.a.H(h,new H.B(new H.D(a6,new A.de(s),l),new A.df(),k))}for(a5=k.k("h.E"),s=0;s<t.gi(a4);++s){g.push(new A.aq(t.h(a4,s),null))
f=P.r(new H.B(new H.D(a6,new A.dg(s),l),new A.dh(),k),!0,a5)
e=new A.di(a4,s)
if(!!f.immutable$list)H.L(P.J("sort"))
d=f.length-1
if(d-0<=32)H.cl(f,0,d,e)
else H.ck(f,0,d,e)
C.a.H(g,f)}for(a5=a6.length,i=0;i<a6.length;a6.length===a5||(0,H.K)(a6),++i){m=a6[i]
m.b=C.a.S(h,new A.dj(m))
m.c=C.a.S(g,new A.dk(m))}c=H.b([],u.K)
b=new H.D(a6,new A.dl(),l).M(0,new A.dm())
a=b.b
for(a0=-1,a1=0;++a1,a1<15e5;){if(typeof a!=="number")return a.bQ()
if(a>=0){if(c.length>1&&a===b.b)break
if(a>=h.length)return H.f(h,a)
c.push(h[a].a)
a5=h.length
if(a>=a5)return H.f(h,a)
a2=h[a].b
if(a2!=null&&!a2.d){a0=a2.c
a=-1}else a=C.b.j(a+1,a5)}else{if(c.length>1&&a0==b.c)break
if(a0>>>0!==a0||a0>=g.length)return H.f(g,a0)
a5=g[a0]
if(a5.b==null)c.push(a5.a)
a5=g.length
if(a0>=a5)return H.f(g,a0)
a2=g[a0].b
if(a2!=null&&a2.d){a=a2.b
a0=-1}else a0=(a0+1)%a5}}return new A.v(c)},
ah:function(a){var t,s,r,q,p,o=a.a,n=a.b,m=H.b([],u.K)
for(t=this.a,s=J.m(t),r=0;r<s.gi(t);r=q){q=r+1
p=R.hm(o,n,s.h(t,r),s.h(t,C.b.j(q,s.gi(t))))
if(p!=null)m.push(p)}if(m.length<=1)return m
A.jw(a,m)
return m},
aZ:function(){var t,s,r,q,p,o=this,n=o.e
if(n!=null)return n
t=o.D()
s=J.E(o.a)
for(n=t.a,r=J.m(n),q=0;q<s;q=p){p=q+1
if(A.cG(r.h(n,q),r.h(n,C.b.j(q-1,s)),r.h(n,C.b.j(p,s)))>3.141592653589793)return o.e=!1}return o.e=!0},
W:function(){var t,s,r,q,p,o,n,m,l=this,k=null,j=l.r
if(j==null){j=l.a
t=J.m(j)
if(t.gi(j)<3){j=new B.b_()
j.a=H.b([],u.U)
return j}if(l.aZ()){j=new B.b_()
j.a=H.b([new B.ar(k,k,!0)],u.U)
return j}s=new B.b_()
s.a=H.b([new B.ar(k,k,!0)],u.U)
r=l.D()
q=t.gi(j)
for(j=r.a,t=J.m(j),p=0;p<q;){o=t.h(j,p)
n=t.h(j,C.b.j(p-1,q));++p
m=t.h(j,C.b.j(p,q))
if(A.cG(o,n,m)>3.141592653589793){s.aF(o.K(n),m.K(o))
s.aF(n.K(o),o.K(m))}else continue}s.bM(0,1.5707963267948966)
l.r=s
j=s}return j},
ae:function(a){var t,s=this.D().a,r=J.m(s),q=C.b.j(a+1,r.gi(s)),p=r.h(s,a),o=r.h(s,q)
for(t=0;t<r.gi(s);++t){if(t===a||t===q)continue
if(R.a6(p,o,r.h(s,t))!==C.f)return!0}return!1},
aS:function(a){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f=this.a,e=J.R(f),d=e.gI(f)
if(typeof a!=="number")return a.A()
t=d.E(a+1.5707963267948966,10)
for(s=-1,r=1/0,q=-1,p=-1/0,o=0;o<e.gi(f);++o){n=e.h(f,o)
n.toString
m=d.t(t)
l=d.t(n)
k=t.t(n)
j=(m+l+k)/2
i=Math.sqrt(j*(j-m)*(j-l)*(j-k))
h=R.a6(d,t,n)===C.f?1:-1
g=2*i/m*h
if(g<r){r=g
s=o}if(g>p){p=g
q=o}}return H.b([s,q],u.i)},
a3:function(a,b){var t=this,s=t.a
a=A.fz(a,s)
b=A.fz(b,s)
if(!t.af(a,!0)){P.z("shortestPath: polygon does not contain p0.")
return H.b([a,b],u.K)}if(!t.af(b,!0)){P.z("shortestPath: Polygon does not contain p1.")
return H.b([a,b],u.K)}return t.aO(a,b,null,null)},
aO:function(a1,a2,a3,a4){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d,c,b,a,a0={}
if(J.n(a1,a4)&&J.n(a2,a4)){P.z("_shortestPathRec called consecutively with repeated parameters.")
P.z("Aborting to avoid infinite loop.")
return H.b([a1,a2],u.K)}t=u.d9
s=H.b([],t)
r=this.D().a
for(q=J.m(r),p=0;p<q.gi(r);p=o){o=p+1
n=R.ft(q.h(r,p),q.h(r,C.b.j(o,q.gi(r))),a1,a2)
if(n!=null)s.push(new A.cA(p,n))}if(s.length===0)return H.b([a1,a2],u.K)
C.a.N(s,new A.da(a1))
if(0>=s.length)return H.f(s,0)
m=s[0]
l=H.b([],t)
for(p=1;p<s.length;p+=2)l.push(s[p])
if(l.length===0){P.z("List of reentering intersections is null. Aborting!")
return H.b([a1,a2],u.K)}t=m.b
k=u.K
j=H.b([t],k)
i=m.a
a0.a=i
for(;!0;){h=C.b.j(a0.a+1,q.gi(r))
a0.a=h
j.push(q.h(r,h))
g=C.a.S(l,new A.db(a0))
if(g!==-1){if(g<0||g>=l.length)return H.f(l,g)
j.push(l[g].b)
break}}f=H.b([t],k)
a0.a=i
for(;!0;){i=C.b.j(a0.a-1,q.gi(r))
a0.a=i
f.push(q.h(r,C.b.j(i+1,q.gi(r))))
g=C.a.S(l,new A.dc(a0))
if(g!==-1){if(g<0||g>=l.length)return H.f(l,g)
f.push(l[g].b)
break}}if(!J.n(C.a.gC(f),C.a.gC(j)))e=C.a.gC(f).t(a1)>C.a.gC(j).t(a1)?-1:1
else e=A.aZ(f)<A.aZ(j)?-1:1
d=e===1?j:f
c=this.aO(A.fz(C.a.gC(d),this.a),a2,a1,a2)
t=H.b([],k)
for(q=d.length,b=0;b<d.length;d.length===q||(0,H.K)(d),++b)t.push(d[b])
for(q=H.fj(c,1,null,H.F(c).c),q=new H.ao(q,q.gi(q));q.n();){a=q.d
t.push(a)}return t},
by:function(){var t,s,r,q,p,o,n,m,l,k,j,i=this.x
if(i!=null)return i
for(i=this.a,t=J.m(i),s=0,r=0,q=0,p=0;p<t.gi(i);){o=t.h(i,p);++p
n=t.h(i,C.b.j(p,t.gi(i)))
m=o.a
l=n.b
if(typeof m!=="number")return m.Z()
k=n.a
j=o.b
if(typeof k!=="number")return k.Z()
s+=m*l-k*j
r+=(m+k)*s
q+=(j+l)*s}i=6*(s*0.5)
return this.x=new L.x(r/i,q/i)},
bA:function(){var t,s,r,q,p,o,n,m,l,k,j,i,h,g,f,e,d=this,c=d.y
if(c!=null)return c
t=d.by()
if(d.af(t,!0))return d.y=t
s=H.b([],u.K)
for(c=d.a,r=J.m(c),q=0;q<r.gi(c);){p=r.h(c,q);++q
o=r.h(c,C.b.j(q,r.gi(c)))
n=t.a
m=p.a
if(typeof n!=="number")return n.u()
if(typeof m!=="number")return H.j(m)
l=t.b
k=p.b
j=[n-m,l-k]
l=o.a
if(typeof l!=="number")return l.u()
i=[l-m,o.b-k]
l=i[0]
n=i[1]
h=(j[0]*l+j[1]*n)/(l*l+n*n)
s.push(new L.x(m+l*h,k+n*h))}for(g=1/0,f=null,q=0;q<s.length;++q){e=s[q].t(t)
if(e<g){if(q>=s.length)return H.f(s,q)
f=s[q]
g=e}}d.y=f
c=f.a
c.toString
if(!(c==1/0||c==-1/0))if(!isNaN(c)){c=f.b
c=c==1/0||c==-1/0||isNaN(c)}else c=!0
else c=!0
if(c)P.z("correctedCentroid is bugged!")
return f},
b8:function(a){var t,s,r,q,p={}
if(J.E(this.a)!==J.E(a.a))return!1
p.a=null
p.a=this.D()
t=a.D()
p.b=0
s=t.a
r=J.R(s)
q=r.S(s,new A.ds(p,0))
if(q===-1)return!1
do{if(!J.cI(p.a.a,p.b).ad(r.h(s,q),0))return!1
p.b=C.b.j(p.b+1,J.E(p.a.a))
q=C.b.j(q+1,r.gi(s))}while(p.b!==0)
return!0},
az:function(a){var t,s,r,q,p,o,n,m,l=J.i5(this.D().a,new A.dp()),k=P.r(l,!0,l.$ti.k("h.E"))
for(t=0;l=k.length,t<l;t=s){s=t+1
r=k[s%l]
q=k[t]
if(r!=null&&r.ad(q,a)){if(t>=k.length)return H.f(k,t)
k[t]=null}}if(!!k.fixed$length)H.L(P.J("removeWhere"))
C.a.aN(k,new A.dq(),!0)
p=H.b([],u.K)
for(t=0;l=k.length,t<l;){o=k[C.b.j(t-1,l)]
q=k[t];++t
n=A.cG(q,o,k[t%l])
if(Math.abs(n-3.141592653589793)<1e-9)p.push(q)
else if(Math.abs(n)<1e-9)p.push(q)
else if(Math.abs(n-6.283185307179586)<1e-9)p.push(q)}m=P.r(this.a,!0,u.R)
C.a.R(p,C.a.gbK(m))
return new A.v(m)},
a8:function(){return this.az(0)}}
A.dr.prototype={
$1:function(a){return a.ak(this.b,this.a)}}
A.dn.prototype={
$1:function(a){return!J.n(a,this.a)}}
A.dd.prototype={
$2:function(a,b){var t=this.a
return C.c.J(a.a.t(t),b.a.t(t))}}
A.de.prototype={
$1:function(a){return a.b===this.a}}
A.df.prototype={
$1:function(a){return new A.aq(a.a,a)}}
A.dg.prototype={
$1:function(a){return a.c===this.a}}
A.dh.prototype={
$1:function(a){return new A.aq(a.a,a)}}
A.di.prototype={
$2:function(a,b){var t=this.a,s=this.b,r=J.m(t)
return C.c.J(a.a.t(r.h(t,s)),b.a.t(r.h(t,s)))}}
A.dj.prototype={
$1:function(a){return a.b==this.a}}
A.dk.prototype={
$1:function(a){return a.b==this.a}}
A.dl.prototype={
$1:function(a){return a.d}}
A.dm.prototype={
$2:function(a,b){var t=a.c,s=b.c
if(typeof t!=="number")return t.F()
if(typeof s!=="number")return H.j(s)
if(t<s)return a
else if(t>s)return b
else{t=a.b
s=b.b
if(typeof t!=="number")return t.F()
if(typeof s!=="number")return H.j(s)
return t<s?a:b}}}
A.da.prototype={
$2:function(a,b){var t=this.a
return C.c.J(a.b.t(t),b.b.t(t))}}
A.db.prototype={
$1:function(a){return a.a===this.a.a}}
A.dc.prototype={
$1:function(a){return a.a===this.a.a}}
A.ds.prototype={
$1:function(a){var t=this.a
return J.cI(t.a.a,t.b).ad(a,this.b)}}
A.dp.prototype={
$1:function(a){return a!=null}}
A.dq.prototype={
$1:function(a){return a==null}}
A.dV.prototype={
$2:function(a,b){return C.c.J(a.b,b.b)}}
A.dW.prototype={
$2:function(a,b){return C.c.J(b.b,a.b)}}
A.dX.prototype={
$2:function(a,b){return J.bO(a.a,b.a)}}
A.dY.prototype={
$2:function(a,b){return J.bO(b.a,a.a)}}
A.aq.prototype={}
A.aU.prototype={}
A.et.prototype={
$2:function(a,b){var t,s=this.a,r=this.b
if(r>=s.length)return H.f(s,r)
t=a.t(s[r])
if(r>=s.length)return H.f(s,r)
return C.c.J(t,b.t(s[r]))}}
A.eu.prototype={
$1:function(a){return a!=null&&this.a.a.bw(a)}}
A.ev.prototype={
$1:function(a){return a==null}}
A.ew.prototype={
$1:function(a){return new A.v(a)}}
A.ex.prototype={
$2:function(a,b){var t=a.P(),s=b.P()
if(typeof t!=="number")return t.B()
if(typeof s!=="number")return H.j(s)
return t>s?a:b}}
A.cA.prototype={}
R.bw.prototype={
ga_:function(){var t,s,r,q=this,p=q.e
if(p==null){p=q.b
t=p.b
s=q.a
r=s.b
p=p.a
s=s.a
if(typeof p!=="number")return p.u()
if(typeof s!=="number")return H.j(s)
s=q.e=(t-r)/(p-s)
p=s}return p},
gi:function(a){var t,s,r,q=this.a,p=this.b
if(q.J(0,p)===0)return 0
q=q.a
t=p.a
if(typeof q!=="number")return q.u()
if(typeof t!=="number")return H.j(t)
s=q-t
r=t-p.b
return Math.sqrt(s*s+r*r)},
ai:function(a){var t,s=a.a,r=this.b,q=r.a
if(typeof s!=="number")return s.b7()
if(typeof q!=="number")return H.j(q)
if(s<=q){q=this.a
t=q.a
if(typeof t!=="number")return H.j(t)
if(s>=t){s=a.b
q=q.b
r=r.b
s=s<=Math.max(q,r)&&s>=Math.min(q,r)}else s=!1}else s=!1
return s},
ay:function(a){var t,s,r,q,p,o,n=this,m=n.a,l=a.a,k=J.I(m)
if(!k.q(m,l)){t=a.b
if(!k.q(m,t)){k=n.b
s=J.I(k)
k=s.q(k,l)||s.q(k,t)}else k=!0}else k=!0
if(k)return!1
k=n.b
r=R.a6(m,k,l)
t=a.b
q=R.a6(m,k,t)
p=R.a6(l,t,m)
o=R.a6(l,t,k)
if(r!==q&&p!==o)return!0
if(r===C.d&&n.ai(l))return!0
if(q===C.d&&n.ai(t))return!0
if(p===C.d&&a.ai(m))return!0
if(o===C.d&&a.ai(k))return!0
return!1}}
R.cx.prototype={
l:function(a){return this.b}}
R.bC.prototype={
gaA:function(){var t=this.a
return this.b===C.k?t.a:t.b}}
R.dH.prototype={
aJ:function(a,b,c){var t,s,r,q,p
if(a==b)return 0
t=a.a
s=t.b
t=t.a
if(typeof c!=="number")return c.u()
if(typeof t!=="number")return H.j(t)
r=s+(c-t)*a.ga_()
t=b.a
q=t.b
t=t.a
if(typeof t!=="number")return H.j(t)
p=q+(c-t)*b.ga_()
s=isNaN(r)?s:r
t=s-(isNaN(p)?q:p)
if(t>0)return 1
if(t<0)return-1
if(a.ga_()-b.ga_()>0)return 1
if(a.ga_()-b.ga_()<0)return-1
return 0},
bu:function(a){var t=this.b
t.push(a)
C.a.N(t,new R.dI(this,a))},
bL:function(a){C.a.N(this.b,new R.dJ(this,a))},
aT:function(a){var t,s,r=this.b,q=C.a.V(r,a)
if(q===-1)return null
t=q+1
s=r.length
if(t>=s)return null
if(t<0)return H.f(r,t)
return r[t]},
aU:function(a){var t,s=this.b,r=C.a.V(s,a)
if(r===-1)return null
if(r===0)return null
t=r-1
if(t<0||t>=s.length)return H.f(s,t)
return s[t]}}
R.dI.prototype={
$2:function(a,b){return this.a.aJ(a,b,this.b.a.a)}}
R.dJ.prototype={
$2:function(a,b){return this.a.aJ(a,b,this.b.gaA().a)}}
R.dO.prototype={
$2:function(a,b){return a.gaA().J(0,b.gaA())}}
R.ac.prototype={
bI:function(a){return this.a.t(this.b)},
q:function(a,b){if(b==null)return!1
if(b instanceof R.ac)return J.n(b.a,this.a)&&J.n(b.b,this.b)
else return!1},
gv:function(a){return J.av(this.a)^J.av(this.b)}}
R.ab.prototype={
b5:function(a,b,c){return new R.ab(this.a.E(b,c),this.b.E(b,c))}}
R.bm.prototype={
l:function(a){return this.b}}
R.e2.prototype={
$1:function(a){var t=a.a,s=a.b,r=t.J(0,s)<0?t:s
return new R.bw(r,t.J(0,s)<0?s:t)}}
L.aC.prototype={}
L.d8.prototype={
$1:function(a){return L.jN(this.a,a,this.b.a)}}
L.d9.prototype={
$1:function(a){var t,s,r,q
a.toString
t=H.Y(a).c
s=P.r(a,!0,t)
r=new H.l(s,new L.d6(this.a),H.F(s).k("l<1,v*>")).bc(0,new L.d7())
q=P.r(r,!0,r.$ti.k("h.E"))
return new L.aC(this.b,P.r(a,!0,t),q)}}
L.d6.prototype={
$1:function(a){return a.X(this.a.a)}}
L.d7.prototype={
$1:function(a){return a!=null}}
L.e4.prototype={
$2:function(a,b){return J.bO(a,b)}}
L.e5.prototype={
$1:function(a){var t=this.a,s=this.b
if(s>=t.length)return H.f(t,s)
return L.jQ(a,t[s],this.c)}}
L.e6.prototype={
$2:function(a,b){return new L.ay(a.a.aD(b.a),a.b.aD(b.b))}}
L.e7.prototype={
$2:function(a,b){return a.aD(b)}}
L.e8.prototype={
$1:function(a){return a.ak(this.a,J.cI(this.b.a,0))}}
L.eV.prototype={
$2:function(a,b){return J.bO(a.P(),b.P())}}
L.eW.prototype={
$2:function(a,b){return J.bO(a.P(),b.P())}}
L.f6.prototype={
$1:function(a){return J.fM(this.a.a.a,a)===-1}}
L.at.prototype={}
L.ay.prototype={}
L.ed.prototype={
$1:function(a){return new L.at(this.a.length-1,a)}}
L.ee.prototype={
$2:function(a,b){return-1*C.c.J(a.b.b,b.b.b)}}
L.ef.prototype={
$1:function(a){return a}}
L.el.prototype={
$1:function(a){return a}}
L.em.prototype={
$1:function(a){return!1}}
L.en.prototype={
$1:function(a){return J.n(a.b,this.a)}}
L.eo.prototype={
$1:function(a){return J.n(a.b,this.a)}}
L.ep.prototype={
$1:function(a){return a}}
L.eq.prototype={
$1:function(a){return a}}
L.er.prototype={
$1:function(a){return!1}}
L.es.prototype={
$1:function(a){return J.n(a.b,this.a)}}
L.eg.prototype={
$1:function(a){return J.n(a.b,this.a)}}
L.eh.prototype={
$1:function(a){return J.E(a.a)>2}}
L.ei.prototype={
$1:function(a){return a.a8()}}
L.ej.prototype={
$1:function(a){return J.E(a.a)>2}}
L.ek.prototype={
$1:function(a){return a.a8()}}
V.eZ.prototype={
$1:function(a){return new K.aP(a.b,this.a,1)}}
S.f2.prototype={
$1:function(a){return S.jU(a,this.a,this.b)}}
S.f3.prototype={
$1:function(a){return a==null}}
S.ez.prototype={
$1:function(a){if(a.O()){this.a.push(a)
return!1}else return!0}}
S.eA.prototype={
$1:function(a){var t=Q.jO(a,this.a),s=t.length
if(s===0){P.z("No candidates found for polygon:")
for(s=J.M(a.a);s.n();)H.w(J.P(s.gp()))}return t}}
S.eB.prototype={
$1:function(a){var t=a.P(),s=this.a.a.P()
if(typeof t!=="number")return t.b6()
if(typeof s!=="number")return H.j(s)
return t/s}}
S.eE.prototype={
$2:function(a,b){if(typeof a!=="number")return a.A()
if(typeof b!=="number")return H.j(b)
return a+b}}
S.eF.prototype={
$1:function(a){return!a.O()}}
S.eG.prototype={
$1:function(a){return a.bA()}}
S.eH.prototype={
$0:function(){this.a.a=!0}}
S.eI.prototype={
$1:function(a){var t=this.a
if(a>>>0!==a||a>=t.length)return H.f(t,a)
return t[a]}}
S.eJ.prototype={
$1:function(a){var t=this.a
if(a>>>0!==a||a>=t.length)return H.f(t,a)
return t[a]}}
S.eK.prototype={
$1:function(a){return a==null}}
S.eL.prototype={
$1:function(a){return a!=null}}
S.eC.prototype={
$1:function(a){return a.b}}
S.eD.prototype={
$2:function(a,b){return S.ja(a,b,this.a)}}
S.dU.prototype={
$1:function(a){return a}}
S.dT.prototype={
$1:function(a){var t,s=this.a
if(a>>>0!==a||a>=s.length)return H.f(s,a)
t=s[a]
C.a.aB(s,a)
return t}}
K.aP.prototype={
aQ:function(a){var t=P.r(this.a,!0,u.R),s=a===1?1:t.length,r=Math.pow(A.aZ(t),2),q=this.e.a.P()
if(typeof q!=="number")return H.j(q)
return s*(r/q)*this.f}}
Q.ad.prototype={}
Q.e9.prototype={
$1:function(a){return H.b([a.a,a.b],u.K)}}
Q.ea.prototype={
$2:function(a,b){var t,s,r=J.m(a),q=u.K
if(r.ga1(a))r=H.b([b.a,b.b],q)
else{q=H.b([],q)
for(t=r.gw(a);t.n();)q.push(t.gp())
for(r=this.a.a3(r.gC(a),b.a),r=H.fj(r,1,null,H.F(r).c),r=new H.ao(r,r.gi(r));r.n();){s=r.d
q.push(s)}q.push(b.b)
r=q}return r}}
Q.aG.prototype={}
V.f_.prototype={
$1:function(a){u.V.a(a)
return X.fg(a.h(0,"latitude"),a.h(0,"longitude"))}}
V.f0.prototype={
$1:function(a){return P.cZ(["latitude",a.a,"longitude",a.b],u.X,u.z)}}
V.f1.prototype={
$1:function(a){return P.cW(a)}};(function aliases(){var t=J.Z.prototype
t.bb=t.l
t.ba=t.aj
t=J.am.prototype
t.bd=t.l
t=P.h.prototype
t.bc=t.ab
t=P.u.prototype
t.bg=t.l
t=P.O.prototype
t.be=t.h
t.bf=t.m})();(function installTearOffs(){var t=hunkHelpers._instance_1i,s=hunkHelpers._static_1,r=hunkHelpers._static_0,q=hunkHelpers._instance_0i,p=hunkHelpers._static_2,o=hunkHelpers.installStaticTearOff
t(J.p.prototype,"gbK","a9",1)
s(P,"jK","iM",0)
s(P,"jL","iN",0)
s(P,"jM","iO",0)
r(P,"hu","jD",3)
s(P,"k3","dP",4)
s(P,"k2","hk",5)
q(R.ac.prototype,"gi","bI",2)
p(V,"k7","ka",6)
o(P,"hF",2,null,["$1$2","$2"],["hI",function(a,b){return P.hI(a,b,u.H)}],7,1)})();(function inheritance(){var t=hunkHelpers.mixin,s=hunkHelpers.inherit,r=hunkHelpers.inheritMany
s(P.u,null)
r(P.u,[H.fc,J.Z,J.b1,P.h,H.ao,P.c0,H.bX,H.bV,H.b7,H.aS,P.bh,H.b2,H.ax,H.cU,H.dw,P.y,H.d5,H.cB,H.dE,P.bg,H.cY,H.c3,H.a0,H.cy,H.cC,P.dK,P.cv,P.dN,P.cz,P.bD,P.dD,P.aH,P.q,P.cF,P.b5,P.aK,P.bn,P.dC,P.bk,P.bp,P.O,V.c5,X.aN,X.d3,B.b_,B.ar,L.x,A.v,A.aq,A.aU,A.cA,R.bw,R.cx,R.bC,R.dH,R.ac,R.ab,R.bm,L.aC,L.at,L.ay,K.aP,Q.ad,Q.aG])
r(J.Z,[J.cT,J.bc,J.am,J.p,J.aM,J.az,H.aB,W.bW,W.aw,W.cP,W.c,W.b8,P.bd])
r(J.am,[J.cf,J.aF,J.al])
s(J.cV,J.p)
r(J.aM,[J.bb,J.ba])
r(P.h,[H.o,H.B,H.D,H.b6,H.bs])
r(H.o,[H.t,H.be,P.bu])
r(H.t,[H.bq,H.l,H.aE])
s(H.S,H.B)
r(P.c0,[H.c4,H.ct])
s(P.bH,P.bh)
s(P.br,P.bH)
s(H.b3,P.br)
s(H.b4,H.b2)
r(H.ax,[H.c_,H.dt,H.co,H.eN,H.eO,H.eP,P.dz,P.dy,P.dA,P.dB,P.dL,P.dZ,P.dG,P.d2,P.d4,P.cQ,P.cR,P.cX,P.dQ,P.dR,P.e_,P.e0,P.e1,X.f4,X.f5,B.cM,B.cL,B.cN,L.eX,L.eT,L.eY,L.eU,A.dr,A.dn,A.dd,A.de,A.df,A.dg,A.dh,A.di,A.dj,A.dk,A.dl,A.dm,A.da,A.db,A.dc,A.ds,A.dp,A.dq,A.dV,A.dW,A.dX,A.dY,A.et,A.eu,A.ev,A.ew,A.ex,R.dI,R.dJ,R.dO,R.e2,L.d8,L.d9,L.d6,L.d7,L.e4,L.e5,L.e6,L.e7,L.e8,L.eV,L.eW,L.f6,L.ed,L.ee,L.ef,L.el,L.em,L.en,L.eo,L.ep,L.eq,L.er,L.es,L.eg,L.eh,L.ei,L.ej,L.ek,V.eZ,S.f2,S.f3,S.ez,S.eA,S.eB,S.eE,S.eF,S.eG,S.eH,S.eI,S.eJ,S.eK,S.eL,S.eC,S.eD,S.dU,S.dT,Q.e9,Q.ea,V.f_,V.f0,V.f1])
s(H.b9,H.c_)
r(P.y,[P.cp,H.c2,H.cr,H.cg,H.cw,P.bR,P.ce,P.a7,P.cc,P.cs,P.cq,P.aR,P.bS,P.bT])
s(H.cd,P.cp)
r(H.co,[H.cm,H.aJ])
s(P.bf,P.bg)
r(P.bf,[H.aa,P.bt])
s(H.aO,H.aB)
r(H.aO,[H.by,H.bA])
s(H.bz,H.by)
s(H.aA,H.bz)
s(H.bB,H.bA)
s(H.bi,H.bB)
r(H.bi,[H.c6,H.c7,H.c8,H.c9,H.ca,H.bj,H.cb])
s(H.bE,H.cw)
s(P.dF,P.dN)
s(P.bv,P.bt)
s(P.a2,P.bD)
r(P.a7,[P.bl,P.bZ])
r(W.bW,[W.C,W.aT,W.af])
r(W.C,[W.d,W.a4])
s(W.e,W.d)
r(W.e,[W.bP,W.bQ,W.bY,W.ch])
r(P.O,[P.c1,P.bx])
s(P.an,P.bx)
t(H.by,P.q)
t(H.bz,H.b7)
t(H.bA,P.q)
t(H.bB,H.b7)
t(P.bH,P.cF)
t(P.bx,P.q)})()
var v={typeUniverse:{eC:new Map(),tR:{},eT:{},tPV:{},sEA:[]},mangledGlobalNames:{k:"int",H:"double",fG:"num",bo:"String",e3:"bool",bk:"Null",A:"List"},mangledNames:{},getTypeFromName:getGlobalFromName,metadata:[],types:["~(~())","e3(u?)","H*()","~()","u?(u?)","u?(@)","O*(an<@>*,O*)","0^(0^,0^)<fG>"],interceptorsByTag:null,leafTags:null,arrayRti:typeof Symbol=="function"&&typeof Symbol()=="symbol"?Symbol("$ti"):"$ti"}
H.j2(v.typeUniverse,JSON.parse('{"al":"am","cf":"am","aF":"am","kh":"c","kn":"c","kg":"d","kp":"d","ku":"d","ki":"e","kr":"e","kq":"C","km":"C","kl":"af","kj":"a4","kv":"a4","ko":"aw","kt":"aA","ks":"aB","am":{"ak":[]},"p":{"A":["1"],"o":["1"],"h":["1"]},"cV":{"p":["1"],"A":["1"],"o":["1"],"h":["1"]},"aM":{"H":[]},"bb":{"H":[],"k":[]},"ba":{"H":[]},"az":{"bo":[]},"o":{"h":["1"]},"t":{"o":["1"],"h":["1"]},"bq":{"t":["1"],"o":["1"],"h":["1"],"t.E":"1","h.E":"1"},"B":{"h":["2"],"h.E":"2"},"S":{"B":["1","2"],"o":["2"],"h":["2"],"h.E":"2"},"l":{"t":["2"],"o":["2"],"h":["2"],"t.E":"2","h.E":"2"},"D":{"h":["1"],"h.E":"1"},"b6":{"h":["2"],"h.E":"2"},"aE":{"t":["1"],"o":["1"],"h":["1"],"t.E":"1","h.E":"1"},"aS":{"cn":[]},"b3":{"U":["1","2"]},"b2":{"U":["1","2"]},"b4":{"U":["1","2"]},"bs":{"h":["1"],"h.E":"1"},"c_":{"ak":[]},"b9":{"ak":[]},"cd":{"y":[]},"c2":{"y":[]},"cr":{"y":[]},"ax":{"ak":[]},"co":{"ak":[]},"cm":{"ak":[]},"aJ":{"ak":[]},"cg":{"y":[]},"aa":{"U":["1","2"]},"be":{"o":["1"],"h":["1"],"h.E":"1"},"aB":{"a1":[]},"aO":{"a_":["1"],"a1":[]},"aA":{"q":["H"],"a_":["H"],"A":["H"],"o":["H"],"a1":[],"h":["H"],"q.E":"H"},"bi":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"]},"c6":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"c7":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"c8":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"c9":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"ca":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"bj":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"cb":{"q":["k"],"a_":["k"],"A":["k"],"o":["k"],"a1":[],"h":["k"],"q.E":"k"},"cw":{"y":[]},"bE":{"y":[]},"bt":{"U":["1","2"]},"bv":{"bt":["1","2"],"U":["1","2"]},"bu":{"o":["1"],"h":["1"],"h.E":"1"},"a2":{"bD":["1"],"ci":["1"],"o":["1"],"h":["1"]},"bf":{"U":["1","2"]},"bg":{"U":["1","2"]},"bh":{"U":["1","2"]},"br":{"U":["1","2"]},"bD":{"ci":["1"],"o":["1"],"h":["1"]},"A":{"o":["1"],"h":["1"]},"ci":{"o":["1"],"h":["1"]},"bR":{"y":[]},"cp":{"y":[]},"ce":{"y":[]},"a7":{"y":[]},"bl":{"y":[]},"bZ":{"y":[]},"cc":{"y":[]},"cs":{"y":[]},"cq":{"y":[]},"aR":{"y":[]},"bS":{"y":[]},"bn":{"y":[]},"bT":{"y":[]},"e":{"C":[]},"bP":{"C":[]},"bQ":{"C":[]},"a4":{"C":[]},"d":{"C":[]},"bY":{"C":[]},"ch":{"C":[]},"c1":{"O":[]},"an":{"q":["1"],"A":["1"],"o":["1"],"O":[],"h":["1"],"q.E":"1"}}'))
H.j1(v.typeUniverse,JSON.parse('{"b1":1,"o":1,"ao":1,"c4":2,"ct":1,"bX":2,"bV":1,"b7":1,"b2":2,"c3":1,"aO":1,"cz":1,"aH":1,"bf":2,"bg":2,"cF":2,"bh":2,"br":2,"bH":2,"c0":1,"bx":1}'))
0
var u=(function rtii(){var t=H.eM
return{d:t("aw"),h:t("b3<cn,@>"),W:t("o<@>"),l:t("y"),E:t("c"),x:t("b6<aG*,x*>"),Y:t("ak"),t:t("b8"),q:t("h<@>"),s:t("p<bo>"),n:t("p<@>"),K:t("p<x*>"),k:t("p<A<x*>*>"),v:t("p<A<H*>*>"),c:t("p<v*>"),w:t("p<aC*>"),D:t("p<ci<v*>*>"),b:t("p<ad*>"),G:t("p<aq*>"),d9:t("p<cA*>"),J:t("p<bw*>"),U:t("p<ar*>"),cp:t("p<aG*>"),r:t("p<at*>"),u:t("p<aU*>"),cM:t("p<bC*>"),m:t("p<H*>"),i:t("p<k*>"),T:t("bc"),g:t("al"),p:t("a_<@>"),A:t("an<@>"),B:t("aa<cn,@>"),cF:t("bd"),f:t("U<@,@>"),ak:t("B<ad*,A<x*>*>"),a8:t("B<aU*,aq*>"),bx:t("l<A<x*>*,v*>"),bo:t("l<v*,H*>"),M:t("l<ad*,aP*>"),L:t("l<H*,ci<v*>*>"),a1:t("C"),P:t("bk"),C:t("u"),N:t("bo"),Q:t("a1"),o:t("aF"),bG:t("D<ad*>"),aa:t("D<aU*>"),cg:t("aT"),bj:t("af"),aR:t("bv<@,@>"),y:t("e3"),cb:t("H"),z:t("@"),S:t("k"),R:t("x*"),V:t("O*"),I:t("aN*"),F:t("0&*"),_:t("u*"),j:t("v*"),a:t("ac*"),X:t("bo*"),Z:t("ar*"),c5:t("e3*"),c7:t("H*"),e:t("k*"),bc:t("fU<bk>?"),O:t("u?"),H:t("fG")}})();(function constants(){var t=hunkHelpers.makeConstList
C.C=J.Z.prototype
C.a=J.p.prototype
C.i=J.ba.prototype
C.b=J.bb.prototype
C.D=J.bc.prototype
C.c=J.aM.prototype
C.e=J.az.prototype
C.E=J.al.prototype
C.q=J.cf.prototype
C.j=J.aF.prototype
C.t=new H.bV()
C.l=function getTagFallback(o) {
  var s = Object.prototype.toString.call(o);
  return s.substring(8, s.length - 1);
}
C.u=function() {
  var toStringFunction = Object.prototype.toString;
  function getTag(o) {
    var s = toStringFunction.call(o);
    return s.substring(8, s.length - 1);
  }
  function getUnknownTag(object, tag) {
    if (/^HTML[A-Z].*Element$/.test(tag)) {
      var name = toStringFunction.call(object);
      if (name == "[object Object]") return null;
      return "HTMLElement";
    }
  }
  function getUnknownTagGenericBrowser(object, tag) {
    if (self.HTMLElement && object instanceof HTMLElement) return "HTMLElement";
    return getUnknownTag(object, tag);
  }
  function prototypeForTag(tag) {
    if (typeof window == "undefined") return null;
    if (typeof window[tag] == "undefined") return null;
    var constructor = window[tag];
    if (typeof constructor != "function") return null;
    return constructor.prototype;
  }
  function discriminator(tag) { return null; }
  var isBrowser = typeof navigator == "object";
  return {
    getTag: getTag,
    getUnknownTag: isBrowser ? getUnknownTagGenericBrowser : getUnknownTag,
    prototypeForTag: prototypeForTag,
    discriminator: discriminator };
}
C.z=function(getTagFallback) {
  return function(hooks) {
    if (typeof navigator != "object") return hooks;
    var ua = navigator.userAgent;
    if (ua.indexOf("DumpRenderTree") >= 0) return hooks;
    if (ua.indexOf("Chrome") >= 0) {
      function confirm(p) {
        return typeof window == "object" && window[p] && window[p].name == p;
      }
      if (confirm("Window") && confirm("HTMLElement")) return hooks;
    }
    hooks.getTag = getTagFallback;
  };
}
C.v=function(hooks) {
  if (typeof dartExperimentalFixupGetTag != "function") return hooks;
  hooks.getTag = dartExperimentalFixupGetTag(hooks.getTag);
}
C.w=function(hooks) {
  var getTag = hooks.getTag;
  var prototypeForTag = hooks.prototypeForTag;
  function getTagFixed(o) {
    var tag = getTag(o);
    if (tag == "Document") {
      if (!!o.xmlVersion) return "!Document";
      return "!HTMLDocument";
    }
    return tag;
  }
  function prototypeForTagFixed(tag) {
    if (tag == "Document") return null;
    return prototypeForTag(tag);
  }
  hooks.getTag = getTagFixed;
  hooks.prototypeForTag = prototypeForTagFixed;
}
C.y=function(hooks) {
  var userAgent = typeof navigator == "object" ? navigator.userAgent : "";
  if (userAgent.indexOf("Firefox") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "GeoGeolocation": "Geolocation",
    "Location": "!Location",
    "WorkerMessageEvent": "MessageEvent",
    "XMLDocument": "!Document"};
  function getTagFirefox(o) {
    var tag = getTag(o);
    return quickMap[tag] || tag;
  }
  hooks.getTag = getTagFirefox;
}
C.x=function(hooks) {
  var userAgent = typeof navigator == "object" ? navigator.userAgent : "";
  if (userAgent.indexOf("Trident/") == -1) return hooks;
  var getTag = hooks.getTag;
  var quickMap = {
    "BeforeUnloadEvent": "Event",
    "DataTransfer": "Clipboard",
    "HTMLDDElement": "HTMLElement",
    "HTMLDTElement": "HTMLElement",
    "HTMLPhraseElement": "HTMLElement",
    "Position": "Geoposition"
  };
  function getTagIE(o) {
    var tag = getTag(o);
    var newTag = quickMap[tag];
    if (newTag) return newTag;
    if (tag == "Object") {
      if (window.DataView && (o instanceof window.DataView)) return "DataView";
    }
    return tag;
  }
  function prototypeForTagIE(tag) {
    var constructor = window[tag];
    if (constructor == null) return null;
    return constructor.prototype;
  }
  hooks.getTag = getTagIE;
  hooks.prototypeForTag = prototypeForTagIE;
}
C.m=function(hooks) { return hooks; }

C.n=new H.dE()
C.h=new P.dF()
C.A=new P.aK(0)
C.B=new P.aK(1e6)
C.o=H.b(t([]),u.n)
C.F=H.b(t([]),H.eM("p<cn*>"))
C.p=new H.b4(0,{},C.F,H.eM("b4<cn*,@>"))
C.d=new R.bm("SegmentOrientation.collinear")
C.f=new R.bm("SegmentOrientation.clockwise")
C.G=new R.bm("SegmentOrientation.counterclockwise")
C.H=new H.aS("call")
C.k=new R.cx("_EventSide.left")
C.r=new R.cx("_EventSide.right")})();(function staticFields(){$.h9=null
$.a8=0
$.fP=null
$.fO=null
$.hy=null
$.ht=null
$.hN=null
$.ey=null
$.eQ=null
$.fD=null
$.aW=null
$.bJ=null
$.bK=null
$.fx=!1
$.cu=C.h
$.W=H.b([],H.eM("p<u>"))})();(function lazyInitializers(){var t=hunkHelpers.lazy
t($,"kk","f8",function(){return H.hx("_$dart_dartClosure")})
t($,"kw","hQ",function(){return H.ae(H.dx({
toString:function(){return"$receiver$"}}))})
t($,"kx","hR",function(){return H.ae(H.dx({$method$:null,
toString:function(){return"$receiver$"}}))})
t($,"ky","hS",function(){return H.ae(H.dx(null))})
t($,"kz","hT",function(){return H.ae(function(){var $argumentsExpr$='$arguments$'
try{null.$method$($argumentsExpr$)}catch(s){return s.message}}())})
t($,"kC","hW",function(){return H.ae(H.dx(void 0))})
t($,"kD","hX",function(){return H.ae(function(){var $argumentsExpr$='$arguments$'
try{(void 0).$method$($argumentsExpr$)}catch(s){return s.message}}())})
t($,"kB","hV",function(){return H.ae(H.h4(null))})
t($,"kA","hU",function(){return H.ae(function(){try{null.$method$}catch(s){return s.message}}())})
t($,"kF","hZ",function(){return H.ae(H.h4(void 0))})
t($,"kE","hY",function(){return H.ae(function(){try{(void 0).$method$}catch(s){return s.message}}())})
t($,"kG","fH",function(){return P.iL()})
t($,"kW","i_",function(){return P.j9(P.fA(self))})
t($,"kH","fI",function(){return H.hx("_$dart_dartObject")})
t($,"kX","fJ",function(){return function DartObject(a){this.o=a}})})();(function nativeSupport(){!function(){var t=function(a){var n={}
n[a]=1
return Object.keys(hunkHelpers.convertToFastObject(n))[0]}
v.getIsolateTag=function(a){return t("___dart_"+a+v.isolateTag)}
var s="___dart_isolate_tags_"
var r=Object[s]||(Object[s]=Object.create(null))
var q="_ZxYxX"
for(var p=0;;p++){var o=t(q+"_"+p+"_")
if(!(o in r)){r[o]=1
v.isolateTag=o
break}}v.dispatchPropertyName=v.getIsolateTag("dispatch_record")}()
hunkHelpers.setOrUpdateInterceptorsByTag({DOMError:J.Z,MediaError:J.Z,NavigatorUserMediaError:J.Z,OverconstrainedError:J.Z,PositionError:J.Z,SQLError:J.Z,DataView:H.aB,ArrayBufferView:H.aB,Float32Array:H.aA,Float64Array:H.aA,Int16Array:H.c6,Int32Array:H.c7,Int8Array:H.c8,Uint16Array:H.c9,Uint32Array:H.ca,Uint8ClampedArray:H.bj,CanvasPixelArray:H.bj,Uint8Array:H.cb,HTMLAudioElement:W.e,HTMLBRElement:W.e,HTMLBaseElement:W.e,HTMLBodyElement:W.e,HTMLButtonElement:W.e,HTMLCanvasElement:W.e,HTMLContentElement:W.e,HTMLDListElement:W.e,HTMLDataElement:W.e,HTMLDataListElement:W.e,HTMLDetailsElement:W.e,HTMLDialogElement:W.e,HTMLDivElement:W.e,HTMLEmbedElement:W.e,HTMLFieldSetElement:W.e,HTMLHRElement:W.e,HTMLHeadElement:W.e,HTMLHeadingElement:W.e,HTMLHtmlElement:W.e,HTMLIFrameElement:W.e,HTMLImageElement:W.e,HTMLInputElement:W.e,HTMLLIElement:W.e,HTMLLabelElement:W.e,HTMLLegendElement:W.e,HTMLLinkElement:W.e,HTMLMapElement:W.e,HTMLMediaElement:W.e,HTMLMenuElement:W.e,HTMLMetaElement:W.e,HTMLMeterElement:W.e,HTMLModElement:W.e,HTMLOListElement:W.e,HTMLObjectElement:W.e,HTMLOptGroupElement:W.e,HTMLOptionElement:W.e,HTMLOutputElement:W.e,HTMLParagraphElement:W.e,HTMLParamElement:W.e,HTMLPictureElement:W.e,HTMLPreElement:W.e,HTMLProgressElement:W.e,HTMLQuoteElement:W.e,HTMLScriptElement:W.e,HTMLShadowElement:W.e,HTMLSlotElement:W.e,HTMLSourceElement:W.e,HTMLSpanElement:W.e,HTMLStyleElement:W.e,HTMLTableCaptionElement:W.e,HTMLTableCellElement:W.e,HTMLTableDataCellElement:W.e,HTMLTableHeaderCellElement:W.e,HTMLTableColElement:W.e,HTMLTableElement:W.e,HTMLTableRowElement:W.e,HTMLTableSectionElement:W.e,HTMLTemplateElement:W.e,HTMLTextAreaElement:W.e,HTMLTimeElement:W.e,HTMLTitleElement:W.e,HTMLTrackElement:W.e,HTMLUListElement:W.e,HTMLUnknownElement:W.e,HTMLVideoElement:W.e,HTMLDirectoryElement:W.e,HTMLFontElement:W.e,HTMLFrameElement:W.e,HTMLFrameSetElement:W.e,HTMLMarqueeElement:W.e,HTMLElement:W.e,HTMLAnchorElement:W.bP,HTMLAreaElement:W.bQ,Blob:W.aw,File:W.aw,CDATASection:W.a4,CharacterData:W.a4,Comment:W.a4,ProcessingInstruction:W.a4,Text:W.a4,DOMException:W.cP,SVGAElement:W.d,SVGAnimateElement:W.d,SVGAnimateMotionElement:W.d,SVGAnimateTransformElement:W.d,SVGAnimationElement:W.d,SVGCircleElement:W.d,SVGClipPathElement:W.d,SVGDefsElement:W.d,SVGDescElement:W.d,SVGDiscardElement:W.d,SVGEllipseElement:W.d,SVGFEBlendElement:W.d,SVGFEColorMatrixElement:W.d,SVGFEComponentTransferElement:W.d,SVGFECompositeElement:W.d,SVGFEConvolveMatrixElement:W.d,SVGFEDiffuseLightingElement:W.d,SVGFEDisplacementMapElement:W.d,SVGFEDistantLightElement:W.d,SVGFEFloodElement:W.d,SVGFEFuncAElement:W.d,SVGFEFuncBElement:W.d,SVGFEFuncGElement:W.d,SVGFEFuncRElement:W.d,SVGFEGaussianBlurElement:W.d,SVGFEImageElement:W.d,SVGFEMergeElement:W.d,SVGFEMergeNodeElement:W.d,SVGFEMorphologyElement:W.d,SVGFEOffsetElement:W.d,SVGFEPointLightElement:W.d,SVGFESpecularLightingElement:W.d,SVGFESpotLightElement:W.d,SVGFETileElement:W.d,SVGFETurbulenceElement:W.d,SVGFilterElement:W.d,SVGForeignObjectElement:W.d,SVGGElement:W.d,SVGGeometryElement:W.d,SVGGraphicsElement:W.d,SVGImageElement:W.d,SVGLineElement:W.d,SVGLinearGradientElement:W.d,SVGMarkerElement:W.d,SVGMaskElement:W.d,SVGMetadataElement:W.d,SVGPathElement:W.d,SVGPatternElement:W.d,SVGPolygonElement:W.d,SVGPolylineElement:W.d,SVGRadialGradientElement:W.d,SVGRectElement:W.d,SVGScriptElement:W.d,SVGSetElement:W.d,SVGStopElement:W.d,SVGStyleElement:W.d,SVGElement:W.d,SVGSVGElement:W.d,SVGSwitchElement:W.d,SVGSymbolElement:W.d,SVGTSpanElement:W.d,SVGTextContentElement:W.d,SVGTextElement:W.d,SVGTextPathElement:W.d,SVGTextPositioningElement:W.d,SVGTitleElement:W.d,SVGUseElement:W.d,SVGViewElement:W.d,SVGGradientElement:W.d,SVGComponentTransferFunctionElement:W.d,SVGFEDropShadowElement:W.d,SVGMPathElement:W.d,Element:W.d,AbortPaymentEvent:W.c,AnimationEvent:W.c,AnimationPlaybackEvent:W.c,ApplicationCacheErrorEvent:W.c,BackgroundFetchClickEvent:W.c,BackgroundFetchEvent:W.c,BackgroundFetchFailEvent:W.c,BackgroundFetchedEvent:W.c,BeforeInstallPromptEvent:W.c,BeforeUnloadEvent:W.c,BlobEvent:W.c,CanMakePaymentEvent:W.c,ClipboardEvent:W.c,CloseEvent:W.c,CompositionEvent:W.c,CustomEvent:W.c,DeviceMotionEvent:W.c,DeviceOrientationEvent:W.c,ErrorEvent:W.c,Event:W.c,InputEvent:W.c,SubmitEvent:W.c,ExtendableEvent:W.c,ExtendableMessageEvent:W.c,FetchEvent:W.c,FocusEvent:W.c,FontFaceSetLoadEvent:W.c,ForeignFetchEvent:W.c,GamepadEvent:W.c,HashChangeEvent:W.c,InstallEvent:W.c,KeyboardEvent:W.c,MediaEncryptedEvent:W.c,MediaKeyMessageEvent:W.c,MediaQueryListEvent:W.c,MediaStreamEvent:W.c,MediaStreamTrackEvent:W.c,MessageEvent:W.c,MIDIConnectionEvent:W.c,MIDIMessageEvent:W.c,MouseEvent:W.c,DragEvent:W.c,MutationEvent:W.c,NotificationEvent:W.c,PageTransitionEvent:W.c,PaymentRequestEvent:W.c,PaymentRequestUpdateEvent:W.c,PointerEvent:W.c,PopStateEvent:W.c,PresentationConnectionAvailableEvent:W.c,PresentationConnectionCloseEvent:W.c,ProgressEvent:W.c,PromiseRejectionEvent:W.c,PushEvent:W.c,RTCDataChannelEvent:W.c,RTCDTMFToneChangeEvent:W.c,RTCPeerConnectionIceEvent:W.c,RTCTrackEvent:W.c,SecurityPolicyViolationEvent:W.c,SensorErrorEvent:W.c,SpeechRecognitionError:W.c,SpeechRecognitionEvent:W.c,SpeechSynthesisEvent:W.c,StorageEvent:W.c,SyncEvent:W.c,TextEvent:W.c,TouchEvent:W.c,TrackEvent:W.c,TransitionEvent:W.c,WebKitTransitionEvent:W.c,UIEvent:W.c,VRDeviceEvent:W.c,VRDisplayEvent:W.c,VRSessionEvent:W.c,WheelEvent:W.c,MojoInterfaceRequestEvent:W.c,ResourceProgressEvent:W.c,USBConnectionEvent:W.c,IDBVersionChangeEvent:W.c,AudioProcessingEvent:W.c,OfflineAudioCompletionEvent:W.c,WebGLContextEvent:W.c,EventTarget:W.bW,HTMLFormElement:W.bY,ImageData:W.b8,Document:W.C,DocumentFragment:W.C,HTMLDocument:W.C,ShadowRoot:W.C,XMLDocument:W.C,Attr:W.C,DocumentType:W.C,Node:W.C,HTMLSelectElement:W.ch,Window:W.aT,DOMWindow:W.aT,DedicatedWorkerGlobalScope:W.af,ServiceWorkerGlobalScope:W.af,SharedWorkerGlobalScope:W.af,WorkerGlobalScope:W.af,IDBKeyRange:P.bd})
hunkHelpers.setOrUpdateLeafTags({DOMError:true,MediaError:true,NavigatorUserMediaError:true,OverconstrainedError:true,PositionError:true,SQLError:true,DataView:true,ArrayBufferView:false,Float32Array:true,Float64Array:true,Int16Array:true,Int32Array:true,Int8Array:true,Uint16Array:true,Uint32Array:true,Uint8ClampedArray:true,CanvasPixelArray:true,Uint8Array:false,HTMLAudioElement:true,HTMLBRElement:true,HTMLBaseElement:true,HTMLBodyElement:true,HTMLButtonElement:true,HTMLCanvasElement:true,HTMLContentElement:true,HTMLDListElement:true,HTMLDataElement:true,HTMLDataListElement:true,HTMLDetailsElement:true,HTMLDialogElement:true,HTMLDivElement:true,HTMLEmbedElement:true,HTMLFieldSetElement:true,HTMLHRElement:true,HTMLHeadElement:true,HTMLHeadingElement:true,HTMLHtmlElement:true,HTMLIFrameElement:true,HTMLImageElement:true,HTMLInputElement:true,HTMLLIElement:true,HTMLLabelElement:true,HTMLLegendElement:true,HTMLLinkElement:true,HTMLMapElement:true,HTMLMediaElement:true,HTMLMenuElement:true,HTMLMetaElement:true,HTMLMeterElement:true,HTMLModElement:true,HTMLOListElement:true,HTMLObjectElement:true,HTMLOptGroupElement:true,HTMLOptionElement:true,HTMLOutputElement:true,HTMLParagraphElement:true,HTMLParamElement:true,HTMLPictureElement:true,HTMLPreElement:true,HTMLProgressElement:true,HTMLQuoteElement:true,HTMLScriptElement:true,HTMLShadowElement:true,HTMLSlotElement:true,HTMLSourceElement:true,HTMLSpanElement:true,HTMLStyleElement:true,HTMLTableCaptionElement:true,HTMLTableCellElement:true,HTMLTableDataCellElement:true,HTMLTableHeaderCellElement:true,HTMLTableColElement:true,HTMLTableElement:true,HTMLTableRowElement:true,HTMLTableSectionElement:true,HTMLTemplateElement:true,HTMLTextAreaElement:true,HTMLTimeElement:true,HTMLTitleElement:true,HTMLTrackElement:true,HTMLUListElement:true,HTMLUnknownElement:true,HTMLVideoElement:true,HTMLDirectoryElement:true,HTMLFontElement:true,HTMLFrameElement:true,HTMLFrameSetElement:true,HTMLMarqueeElement:true,HTMLElement:false,HTMLAnchorElement:true,HTMLAreaElement:true,Blob:true,File:true,CDATASection:true,CharacterData:true,Comment:true,ProcessingInstruction:true,Text:true,DOMException:true,SVGAElement:true,SVGAnimateElement:true,SVGAnimateMotionElement:true,SVGAnimateTransformElement:true,SVGAnimationElement:true,SVGCircleElement:true,SVGClipPathElement:true,SVGDefsElement:true,SVGDescElement:true,SVGDiscardElement:true,SVGEllipseElement:true,SVGFEBlendElement:true,SVGFEColorMatrixElement:true,SVGFEComponentTransferElement:true,SVGFECompositeElement:true,SVGFEConvolveMatrixElement:true,SVGFEDiffuseLightingElement:true,SVGFEDisplacementMapElement:true,SVGFEDistantLightElement:true,SVGFEFloodElement:true,SVGFEFuncAElement:true,SVGFEFuncBElement:true,SVGFEFuncGElement:true,SVGFEFuncRElement:true,SVGFEGaussianBlurElement:true,SVGFEImageElement:true,SVGFEMergeElement:true,SVGFEMergeNodeElement:true,SVGFEMorphologyElement:true,SVGFEOffsetElement:true,SVGFEPointLightElement:true,SVGFESpecularLightingElement:true,SVGFESpotLightElement:true,SVGFETileElement:true,SVGFETurbulenceElement:true,SVGFilterElement:true,SVGForeignObjectElement:true,SVGGElement:true,SVGGeometryElement:true,SVGGraphicsElement:true,SVGImageElement:true,SVGLineElement:true,SVGLinearGradientElement:true,SVGMarkerElement:true,SVGMaskElement:true,SVGMetadataElement:true,SVGPathElement:true,SVGPatternElement:true,SVGPolygonElement:true,SVGPolylineElement:true,SVGRadialGradientElement:true,SVGRectElement:true,SVGScriptElement:true,SVGSetElement:true,SVGStopElement:true,SVGStyleElement:true,SVGElement:true,SVGSVGElement:true,SVGSwitchElement:true,SVGSymbolElement:true,SVGTSpanElement:true,SVGTextContentElement:true,SVGTextElement:true,SVGTextPathElement:true,SVGTextPositioningElement:true,SVGTitleElement:true,SVGUseElement:true,SVGViewElement:true,SVGGradientElement:true,SVGComponentTransferFunctionElement:true,SVGFEDropShadowElement:true,SVGMPathElement:true,Element:false,AbortPaymentEvent:true,AnimationEvent:true,AnimationPlaybackEvent:true,ApplicationCacheErrorEvent:true,BackgroundFetchClickEvent:true,BackgroundFetchEvent:true,BackgroundFetchFailEvent:true,BackgroundFetchedEvent:true,BeforeInstallPromptEvent:true,BeforeUnloadEvent:true,BlobEvent:true,CanMakePaymentEvent:true,ClipboardEvent:true,CloseEvent:true,CompositionEvent:true,CustomEvent:true,DeviceMotionEvent:true,DeviceOrientationEvent:true,ErrorEvent:true,Event:true,InputEvent:true,SubmitEvent:true,ExtendableEvent:true,ExtendableMessageEvent:true,FetchEvent:true,FocusEvent:true,FontFaceSetLoadEvent:true,ForeignFetchEvent:true,GamepadEvent:true,HashChangeEvent:true,InstallEvent:true,KeyboardEvent:true,MediaEncryptedEvent:true,MediaKeyMessageEvent:true,MediaQueryListEvent:true,MediaStreamEvent:true,MediaStreamTrackEvent:true,MessageEvent:true,MIDIConnectionEvent:true,MIDIMessageEvent:true,MouseEvent:true,DragEvent:true,MutationEvent:true,NotificationEvent:true,PageTransitionEvent:true,PaymentRequestEvent:true,PaymentRequestUpdateEvent:true,PointerEvent:true,PopStateEvent:true,PresentationConnectionAvailableEvent:true,PresentationConnectionCloseEvent:true,ProgressEvent:true,PromiseRejectionEvent:true,PushEvent:true,RTCDataChannelEvent:true,RTCDTMFToneChangeEvent:true,RTCPeerConnectionIceEvent:true,RTCTrackEvent:true,SecurityPolicyViolationEvent:true,SensorErrorEvent:true,SpeechRecognitionError:true,SpeechRecognitionEvent:true,SpeechSynthesisEvent:true,StorageEvent:true,SyncEvent:true,TextEvent:true,TouchEvent:true,TrackEvent:true,TransitionEvent:true,WebKitTransitionEvent:true,UIEvent:true,VRDeviceEvent:true,VRDisplayEvent:true,VRSessionEvent:true,WheelEvent:true,MojoInterfaceRequestEvent:true,ResourceProgressEvent:true,USBConnectionEvent:true,IDBVersionChangeEvent:true,AudioProcessingEvent:true,OfflineAudioCompletionEvent:true,WebGLContextEvent:true,EventTarget:false,HTMLFormElement:true,ImageData:true,Document:true,DocumentFragment:true,HTMLDocument:true,ShadowRoot:true,XMLDocument:true,Attr:true,DocumentType:true,Node:false,HTMLSelectElement:true,Window:true,DOMWindow:true,DedicatedWorkerGlobalScope:true,ServiceWorkerGlobalScope:true,SharedWorkerGlobalScope:true,WorkerGlobalScope:true,IDBKeyRange:true})
H.aO.$nativeSuperclassTag="ArrayBufferView"
H.by.$nativeSuperclassTag="ArrayBufferView"
H.bz.$nativeSuperclassTag="ArrayBufferView"
H.aA.$nativeSuperclassTag="ArrayBufferView"
H.bA.$nativeSuperclassTag="ArrayBufferView"
H.bB.$nativeSuperclassTag="ArrayBufferView"
H.bi.$nativeSuperclassTag="ArrayBufferView"})()
convertAllToFastObject(w)
convertToFastObject($);(function(a){if(typeof document==="undefined"){a(null)
return}if(typeof document.currentScript!='undefined'){a(document.currentScript)
return}var t=document.scripts
function onLoad(b){for(var r=0;r<t.length;++r)t[r].removeEventListener("load",onLoad,false)
a(b.target)}for(var s=0;s<t.length;++s)t[s].addEventListener("load",onLoad,false)})(function(a){v.currentScript=a
if(typeof dartMainRunner==="function")dartMainRunner(V.hE,[])
else V.hE([])})})()
//# sourceMappingURL=node_entrypoint.dart.js.map
// Appended section: Export functions.
exports.planRoute = function planRouteExport(polygon, params) {
  const res = self.planRoute(polygon, params);
  if (res.success) return res.plannedPath;
  else throw res.thrownException;
};
